"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainId = exports.ChainName = void 0;
var ChainName;
(function (ChainName) {
    ChainName["EthereumMainnet"] = "Ethereum Mainnet";
    ChainName["ExpanseNetwork"] = "Expanse Network";
    ChainName["Ropsten"] = "Ropsten";
    ChainName["Rinkeby"] = "Rinkeby";
    ChainName["Goerli"] = "Goerli";
    ChainName["KottiTestnet"] = "Kotti Testnet";
    ChainName["ThaiChain"] = "ThaiChain";
    ChainName["Ubiq"] = "Ubiq";
    ChainName["UbiqNetworkTestnet"] = "Ubiq Network Testnet";
    ChainName["OPMainnet"] = "OP Mainnet";
    ChainName["MetadiumMainnet"] = "Metadium Mainnet";
    ChainName["MetadiumTestnet"] = "Metadium Testnet";
    ChainName["DiodeTestnetStaging"] = "Diode Testnet Staging";
    ChainName["FlareMainnet"] = "Flare Mainnet";
    ChainName["DiodePrenet"] = "Diode Prenet";
    ChainName["SongbirdTestnetCoston"] = "Songbird Testnet Coston";
    ChainName["ThaiChain2.0ThaiFi"] = "ThaiChain 2.0 ThaiFi";
    ChainName["ThunderCoreTestnet"] = "ThunderCore Testnet";
    ChainName["SongbirdCanary-Network"] = "Songbird Canary-Network";
    ChainName["ElastosSmartChain"] = "Elastos Smart Chain";
    ChainName["ElastosSmartChainTestnet"] = "Elastos Smart Chain Testnet";
    ChainName["ELA-DID-SidechainMainnet"] = "ELA-DID-Sidechain Mainnet";
    ChainName["ELA-DID-SidechainTestnet"] = "ELA-DID-Sidechain Testnet";
    ChainName["KardiaChainMainnet"] = "KardiaChain Mainnet";
    ChainName["CronosMainnet"] = "Cronos Mainnet";
    ChainName["GenesisL1testnet"] = "Genesis L1 testnet";
    ChainName["ShibaChain"] = "ShibaChain";
    ChainName["BobaNetworkRinkebyTestnet"] = "Boba Network Rinkeby Testnet";
    ChainName["GenesisL1"] = "Genesis L1";
    ChainName["RootstockMainnet"] = "Rootstock Mainnet";
    ChainName["RootstockTestnet"] = "Rootstock Testnet";
    ChainName["GoodDataTestnet"] = "GoodData Testnet";
    ChainName["GoodDataMainnet"] = "GoodData Mainnet";
    ChainName["SecureChainMainnet"] = "SecureChain Mainnet";
    ChainName["TBWGChain"] = "TBWG Chain";
    ChainName["DxchainMainnet"] = "Dxchain Mainnet";
    ChainName["XplaMainnet"] = "Xpla Mainnet";
    ChainName["Valorbit"] = "Valorbit";
    ChainName["U2USolarisMainnet"] = "U2U Solaris Mainnet";
    ChainName["TelosEVMMainnet"] = "Telos EVM Mainnet";
    ChainName["TelosEVMTestnet"] = "Telos EVM Testnet";
    ChainName["LUKSOMainnet"] = "LUKSO Mainnet";
    ChainName["DarwiniaPangolinTestnet"] = "Darwinia Pangolin Testnet";
    ChainName["CrabNetwork"] = "Crab Network";
    ChainName["DarwiniaPangoroTestnet"] = "Darwinia Pangoro Testnet";
    ChainName["DarwiniaNetwork"] = "Darwinia Network";
    ChainName["AcriaIntelliChain"] = "Acria IntelliChain";
    ChainName["EnnothemMainnetProterozoic"] = "Ennothem Mainnet Proterozoic";
    ChainName["EnnothemTestnetPioneer"] = "Ennothem Testnet Pioneer";
    ChainName["XDCNetwork"] = "XDC Network";
    ChainName["XDCApothemNetwork"] = "XDC Apothem Network";
    ChainName["CoinExSmartChainMainnet"] = "CoinEx Smart Chain Mainnet";
    ChainName["CoinExSmartChainTestnet"] = "CoinEx Smart Chain Testnet";
    ChainName["OpenpieceMainnet"] = "Openpiece Mainnet";
    ChainName["ZyxMainnet"] = "Zyx Mainnet";
    ChainName["BNBSmartChainMainnet"] = "BNB Smart Chain Mainnet";
    ChainName["SyscoinMainnet"] = "Syscoin Mainnet";
    ChainName["OntologyMainnet"] = "Ontology Mainnet";
    ChainName["EOSEVMLegacy"] = "EOS EVM Legacy";
    ChainName["GoChain"] = "GoChain";
    ChainName["EthereumClassic"] = "Ethereum Classic";
    ChainName["MordenTestnet"] = "Morden Testnet";
    ChainName["MordorTestnet"] = "Mordor Testnet";
    ChainName["Ellaism"] = "Ellaism";
    ChainName["OKExChainTestnet"] = "OKExChain Testnet";
    ChainName["OKXChainMainnet"] = "OKXChain Mainnet";
    ChainName["DBChainTestnet"] = "DBChain Testnet";
    ChainName["SoterOneMainnet"] = "SoterOne Mainnet";
    ChainName["OptimismKovan"] = "Optimism Kovan";
    ChainName["HooSmartChain"] = "Hoo Smart Chain";
    ChainName["ConfluxeSpace(Testnet)"] = "Conflux eSpace (Testnet)";
    ChainName["DxChainTestnet"] = "DxChain Testnet";
    ChainName["FNCY"] = "FNCY";
    ChainName["IDChainMainnet"] = "IDChain Mainnet";
    ChainName["DecimalSmartChainMainnet"] = "Decimal Smart Chain Mainnet";
    ChainName["Mix"] = "Mix";
    ChainName["POANetworkSokol"] = "POA Network Sokol";
    ChainName["PrimusChainmainnet"] = "PrimusChain mainnet";
    ChainName["ZenithMainnet"] = "Zenith Mainnet";
    ChainName["GeneChain"] = "GeneChain";
    ChainName["JapanOpenChainMainnet"] = "Japan Open Chain Mainnet";
    ChainName["MeterMainnet"] = "Meter Mainnet";
    ChainName["MeterTestnet"] = "Meter Testnet";
    ChainName["LinqtoDevnet"] = "Linqto Devnet";
    ChainName["GateChainTestnet"] = "GateChain Testnet";
    ChainName["GateChainMainnet"] = "GateChain Mainnet";
    ChainName["NovaNetwork"] = "Nova Network";
    ChainName["Viction"] = "Viction";
    ChainName["VictionTestnet"] = "Viction Testnet";
    ChainName["GarizonStage0"] = "Garizon Stage0";
    ChainName["GarizonStage1"] = "Garizon Stage1";
    ChainName["GarizonStage2"] = "Garizon Stage2";
    ChainName["GarizonStage3"] = "Garizon Stage3";
    ChainName["SwissDLT"] = "SwissDLT";
    ChainName["CamDLMainnet"] = "CamDL Mainnet";
    ChainName["KUBMainnet"] = "KUB Mainnet";
    ChainName["BNBSmartChainTestnet"] = "BNB Smart Chain Testnet";
    ChainName["SixProtocol"] = "Six Protocol";
    ChainName["POANetworkCore"] = "POA Network Core";
    ChainName["Gnosis"] = "Gnosis";
    ChainName["EtherInc"] = "EtherInc";
    ChainName["Web3GamesTestnet"] = "Web3Games Testnet";
    ChainName["WorldLandMainnet"] = "WorldLand Mainnet";
    ChainName["KaibaLightningChainTestnet"] = "Kaiba Lightning Chain Testnet";
    ChainName["Web3GamesDevnet"] = "Web3Games Devnet";
    ChainName["VelasEVMMainnet"] = "Velas EVM Mainnet";
    ChainName["NebulaTestnet"] = "Nebula Testnet";
    ChainName["ThunderCoreMainnet"] = "ThunderCore Mainnet";
    ChainName["Shibarium"] = "Shibarium";
    ChainName["ProtonTestnet"] = "Proton Testnet";
    ChainName["EtherLiteChain"] = "EtherLite Chain";
    ChainName["CoinbitMainnet"] = "Coinbit Mainnet";
    ChainName["Dehvo"] = "Dehvo";
    ChainName["FlareTestnetCoston2"] = "Flare Testnet Coston2";
    ChainName["DeBankTestnet(Deprecated)"] = "DeBank Testnet(Deprecated)";
    ChainName["DeBankMainnet"] = "DeBank Mainnet";
    ChainName["UptickMainnet"] = "Uptick Mainnet";
    ChainName["ArcologyTestnet"] = "Arcology Testnet";
    ChainName["ENULSMainnet"] = "ENULS Mainnet";
    ChainName["ENULSTestnet"] = "ENULS Testnet";
    ChainName["RealchainMainnet"] = "Realchain Mainnet";
    ChainName["FuseMainnet"] = "Fuse Mainnet";
    ChainName["FuseSparknet"] = "Fuse Sparknet";
    ChainName["DecentralizedWebMainnet"] = "Decentralized Web Mainnet";
    ChainName["OYchainTestnet"] = "OYchain Testnet";
    ChainName["OYchainMainnet"] = "OYchain Mainnet";
    ChainName["Factory127Mainnet"] = "Factory 127 Mainnet";
    ChainName["HuobiECOChainMainnet"] = "Huobi ECO Chain Mainnet";
    ChainName["InnovatorChain"] = "Innovator Chain";
    ChainName["Unichain"] = "Unichain";
    ChainName["EngramTestnet"] = "Engram Testnet";
    ChainName["NamefiChainMainnet"] = "Namefi Chain Mainnet";
    ChainName["HashKeyChainTestnet"] = "HashKey Chain Testnet";
    ChainName["IExecSidechain"] = "iExec Sidechain";
    ChainName["AlyxChainTestnet"] = "Alyx Chain Testnet";
    ChainName["DeamchainMainnet"] = "Deamchain Mainnet";
    ChainName["PolygonMainnet"] = "Polygon Mainnet";
    ChainName["DefiOracleMetaMainnet"] = "Defi Oracle Meta Mainnet";
    ChainName["WoopChainMainnet"] = "WoopChain Mainnet";
    ChainName["EternalMainnet"] = "Eternal Mainnet";
    ChainName["OpenpieceTestnet"] = "Openpiece Testnet";
    ChainName["DAXCHAIN"] = "DAX CHAIN";
    ChainName["MonadMainnet"] = "Monad Mainnet";
    ChainName["PHINetworkv2"] = "PHI Network v2";
    ChainName["SoraAITestnet"] = "SoraAI Testnet";
    ChainName["SonicMainnet"] = "Sonic Mainnet";
    ChainName["FlagMainnet"] = "Flag Mainnet";
    ChainName["ShimmerEVM"] = "ShimmerEVM";
    ChainName["SixProtocolTestnet"] = "Six Protocol Testnet";
    ChainName["RedbellyNetworkMainnet"] = "Redbelly Network Mainnet";
    ChainName["RedbellyNetworkDevnet"] = "Redbelly Network Devnet";
    ChainName["RedbellyNetworkTestnet"] = "Redbelly Network Testnet";
    ChainName["RedbellyNetworkTGE"] = "Redbelly Network TGE";
    ChainName["TenetTestnet"] = "Tenet Testnet";
    ChainName["OEBlockTestnet"] = "OEBlock Testnet";
    ChainName["Puppynet"] = "Puppynet";
    ChainName["RoburnaMainnet"] = "Roburna Mainnet";
    ChainName["RoburnaTestnet"] = "Roburna Testnet";
    ChainName["ArmoniaEvaChainMainnet"] = "Armonia Eva Chain Mainnet";
    ChainName["ArmoniaEvaChainTestnet"] = "Armonia Eva Chain Testnet";
    ChainName["LightstreamsTestnet"] = "Lightstreams Testnet";
    ChainName["LightstreamsMainnet"] = "Lightstreams Mainnet";
    ChainName["OmniOmegaTestnet"] = "Omni Omega Testnet";
    ChainName["OmniTestnet(Deprecated)"] = "Omni Testnet (Deprecated)";
    ChainName["Omni"] = "Omni";
    ChainName["AtoshiTestnet"] = "Atoshi Testnet";
    ChainName["AIOZNetwork"] = "AIOZ Network";
    ChainName["MantaPacificMainnet"] = "Manta Pacific Mainnet";
    ChainName["HOOSmartChainTestnet"] = "HOO Smart Chain Testnet";
    ChainName["CO2eChain"] = "CO2e Chain";
    ChainName["Latam-BlockchainResilTestnet"] = "Latam-Blockchain Resil Testnet";
    ChainName["OTC"] = "OTC";
    ChainName["DCMainnet"] = "DC Mainnet";
    ChainName["HashKeyChain"] = "HashKey Chain";
    ChainName["ABEYTestnet"] = "ABEY Testnet";
    ChainName["ABEYMainnet"] = "ABEY Mainnet";
    ChainName["AMEChainMainnet"] = "AME Chain Mainnet";
    ChainName["WaterfallNetwork"] = "Waterfall Network";
    ChainName["IOSTMainnet"] = "IOST Mainnet";
    ChainName["Ethernity"] = "Ethernity";
    ChainName["DojimaTestnet"] = "Dojima Testnet";
    ChainName["MintMainnet"] = "Mint Mainnet";
    ChainName["SeeleMainnet"] = "Seele Mainnet";
    ChainName["Dojima"] = "Dojima";
    ChainName["BMCMainnet"] = "BMC Mainnet";
    ChainName["BMCTestnet"] = "BMC Testnet";
    ChainName["CMDAOBBQChain"] = "CMDAO BBQ Chain";
    ChainName["FileFileGo"] = "FileFileGo";
    ChainName["CryptoEmergency"] = "Crypto Emergency";
    ChainName["Firachain"] = "firachain";
    ChainName["XLayerTestnet"] = "X Layer Testnet";
    ChainName["XLayerMainnet"] = "X Layer Mainnet";
    ChainName["NeutrinosTestNet"] = "Neutrinos TestNet";
    ChainName["BitchainMainnet"] = "Bitchain Mainnet";
    ChainName["BitTorrentChainMainnet"] = "BitTorrent Chain Mainnet";
    ChainName["ArbitrumonxDai"] = "Arbitrum on xDai";
    ChainName["MOACtestnet"] = "MOAC testnet";
    ChainName["EdgelessTestnet"] = "Edgeless Testnet";
    ChainName["WowChainMainnet"] = "WowChain Mainnet";
    ChainName["OpBNBMainnet"] = "opBNB Mainnet";
    ChainName["EKAASH"] = "EKAASH";
    ChainName["VinuChainTestnet"] = "VinuChain Testnet";
    ChainName["VinuChainNetwork"] = "VinuChain Network";
    ChainName["StructxMainnet"] = "Structx Mainnet";
    ChainName["Bitnet"] = "Bitnet";
    ChainName["FreightTrustNetwork"] = "Freight Trust Network";
    ChainName["MAPOMakalu"] = "MAPO Makalu";
    ChainName["B2HubMainnet"] = "B2 Hub Mainnet";
    ChainName["ShinariumMainnet"] = "Shinarium Mainnet";
    ChainName["IDNMainnet"] = "IDN Mainnet";
    ChainName["HappychainTestnet"] = "Happychain Testnet";
    ChainName["SiriusNetV2"] = "SiriusNet V2";
    ChainName["SoterOneMainnetold"] = "SoterOne Mainnet old";
    ChainName["ScalindTestnet"] = "Scalind Testnet";
    ChainName["BlockExMainnet"] = "BlockEx Mainnet";
    ChainName["Permission"] = "Permission";
    ChainName["B2Mainnet"] = "B2 Mainnet";
    ChainName["ViridisTestnet"] = "Viridis Testnet";
    ChainName["LACHAINMainnet"] = "LACHAIN Mainnet";
    ChainName["LACHAINTestnet"] = "LACHAIN Testnet";
    ChainName["Prom"] = "Prom";
    ChainName["MindNetworkMainnet"] = "Mind Network Mainnet";
    ChainName["SwapDEX"] = "SwapDEX";
    ChainName["Lens"] = "Lens";
    ChainName["EthernityTestnet"] = "Ethernity Testnet";
    ChainName["ProtoJumboTestnet"] = "ProtoJumbo Testnet";
    ChainName["DeamchainTestnet"] = "Deamchain Testnet";
    ChainName["BlastMainnet"] = "Blast Mainnet";
    ChainName["TACMainnet"] = "TAC Mainnet";
    ChainName["CronoszkEVMTestnet"] = "Cronos zkEVM Testnet";
    ChainName["PlingaMainnet"] = "Plinga Mainnet";
    ChainName["EnergyWebChain"] = "Energy Web Chain";
    ChainName["ChooChain"] = "ChooChain";
    ChainName["OasysMainnet"] = "Oasys Mainnet";
    ChainName["FantomOpera"] = "Fantom Opera";
    ChainName["GlideL1ProtocolXP"] = "Glide L1 Protocol XP";
    ChainName["Fraxtal"] = "Fraxtal";
    ChainName["GlideL2ProtocolXP"] = "Glide L2 Protocol XP";
    ChainName["SwanChainMainnet"] = "Swan Chain Mainnet";
    ChainName["Kroma"] = "Kroma";
    ChainName["HuobiECOChainTestnet"] = "Huobi ECO Chain Testnet";
    ChainName["Setheum"] = "Setheum";
    ChainName["NeonlinkMainnet"] = "Neonlink Mainnet";
    ChainName["GuruNetwork"] = "Guru Network";
    ChainName["GuruNetworkTestnet"] = "Guru Network Testnet";
    ChainName["SURBlockchainNetwork"] = "SUR Blockchain Network";
    ChainName["Neura"] = "Neura";
    ChainName["NeuraTestnet"] = "Neura Testnet";
    ChainName["NeuraDevnet"] = "Neura Devnet";
    ChainName["HighPerformanceBlockchain"] = "High Performance Blockchain";
    ChainName["EgonCoinMainnet"] = "EgonCoin Mainnet";
    ChainName["XROne"] = "XR One";
    ChainName["LaChain"] = "LaChain";
    ChainName["XFair.AIMainnet"] = "xFair.AI Mainnet";
    ChainName["BPXChain"] = "BPX Chain";
    ChainName["ZkSyncEraGoerliTestnet(deprecated)"] = "zkSync Era Goerli Testnet (deprecated)";
    ChainName["DeprecatedCronoszkEVMTestnet"] = "Deprecated Cronos zkEVM Testnet";
    ChainName["BobaNetwork"] = "Boba Network";
    ChainName["OrderlyMainnet"] = "Orderly Mainnet";
    ChainName["DaVinci"] = "DaVinci";
    ChainName["HederaMainnet"] = "Hedera Mainnet";
    ChainName["HederaTestnet"] = "Hedera Testnet";
    ChainName["HederaPreviewnet"] = "Hedera Previewnet";
    ChainName["HederaLocalnet"] = "Hedera Localnet";
    ChainName["ZkSyncSepoliaTestnet"] = "zkSync Sepolia Testnet";
    ChainName["Bobaopera"] = "Bobaopera";
    ChainName["ZKcandySepoliaTestnet"] = "ZKcandy Sepolia Testnet";
    ChainName["NeurochainTestnet"] = "Neurochain Testnet";
    ChainName["ZKSatsMainnet"] = "ZKSats Mainnet";
    ChainName["LovelyNetworkTestnet"] = "Lovely Network Testnet";
    ChainName["Furtheon"] = "Furtheon";
    ChainName["WyzthTestnet"] = "Wyzth Testnet";
    ChainName["OmaxMainnet"] = "Omax Mainnet";
    ChainName["NeurochainMainnet"] = "Neurochain Mainnet";
    ChainName["Filecoin-Mainnet"] = "Filecoin - Mainnet";
    ChainName["WorldEcoMoney"] = "WorldEcoMoney";
    ChainName["ZKcandyMainnet"] = "ZKcandy Mainnet";
    ChainName["KCCMainnet"] = "KCC Mainnet";
    ChainName["KCCTestnet"] = "KCC Testnet";
    ChainName["CosvmMainnet"] = "Cosvm Mainnet";
    ChainName["ZkSyncMainnet"] = "zkSync Mainnet";
    ChainName["GRVTExchange"] = "GRVT Exchange";
    ChainName["GRVTExchangeTestnet"] = "GRVT Exchange Testnet";
    ChainName["TeloszkEVMTestnet"] = "Telos zkEVM Testnet";
    ChainName["OmaxTestnet"] = "Omax Testnet";
    ChainName["Web3QMainnet"] = "Web3Q Mainnet";
    ChainName["DFKChainTest"] = "DFK Chain Test";
    ChainName["Shiden"] = "Shiden";
    ChainName["R5Network"] = "R5 Network";
    ChainName["CronosTestnet"] = "Cronos Testnet";
    ChainName["PencilsProtocol"] = "Pencils Protocol";
    ChainName["TSCMainnet"] = "TSC Mainnet";
    ChainName["Shape"] = "Shape";
    ChainName["ThetaMainnet"] = "Theta Mainnet";
    ChainName["ThetaSapphireTestnet"] = "Theta Sapphire Testnet";
    ChainName["ThetaAmberTestnet"] = "Theta Amber Testnet";
    ChainName["ThetaTestnet"] = "Theta Testnet";
    ChainName["PulseChain"] = "PulseChain";
    ChainName["ConstaTestnet"] = "Consta Testnet";
    ChainName["ZKAmoebaTestnet"] = "ZKAmoeba Testnet";
    ChainName["ZKAmoebaMainnet"] = "ZKAmoeba Mainnet";
    ChainName["Lisinski"] = "Lisinski";
    ChainName["CronoszkEVMMainnet"] = "Cronos zkEVM Mainnet";
    ChainName["CamDLTestnet"] = "CamDL Testnet";
    ChainName["NEARProtocol"] = "NEAR Protocol";
    ChainName["NEARProtocolTestnet"] = "NEAR Protocol Testnet";
    ChainName["Nativ3Mainnet"] = "Nativ3 Mainnet";
    ChainName["HyperonChainTestNet"] = "HyperonChain TestNet";
    ChainName["OzoneChainTestnet"] = "Ozone Chain Testnet";
    ChainName["SyndrL3"] = "Syndr L3";
    ChainName["PepeChainMainnet"] = "Pepe Chain Mainnet";
    ChainName["SXNetworkMainnet"] = "SX Network Mainnet";
    ChainName["LaTestnet"] = "LaTestnet";
    ChainName["OptimismGoerliTestnet"] = "Optimism Goerli Testnet";
    ChainName["ViridisMainnet"] = "Viridis Mainnet";
    ChainName["PGN(PublicGoodsNetwork)"] = "PGN (Public Goods Network)";
    ChainName["StenixMainnet"] = "Stenix Mainnet";
    ChainName["TheWidowsMite"] = "The Widows Mite";
    ChainName["ZeethChain"] = "Zeeth Chain";
    ChainName["GesoVerse"] = "Geso Verse";
    ChainName["BoyaaMainnet"] = "Boyaa Mainnet";
    ChainName["TenTestnet"] = "Ten Testnet";
    ChainName["SynapseChainTestnet"] = "Synapse Chain Testnet";
    ChainName["ARZIOChain"] = "ARZIO Chain";
    ChainName["AreonNetworkTestnet"] = "Areon Network Testnet";
    ChainName["AreonNetworkMainnet"] = "Areon Network Mainnet";
    ChainName["AppChain"] = "AppChain";
    ChainName["FormNetwork"] = "Form Network";
    ChainName["WorldChain"] = "World Chain";
    ChainName["StandardMainnet"] = "Standard Mainnet";
    ChainName["BlackFortExchangeNetwork"] = "BlackFort Exchange Network";
    ChainName["Landstars"] = "Landstars";
    ChainName["Rupaya"] = "Rupaya";
    ChainName["CaminoC-Chain"] = "Camino C-Chain";
    ChainName["ColumbusTestNetwork"] = "Columbus Test Network";
    ChainName["SyndicateChain"] = "Syndicate Chain";
    ChainName["Double-AChainMainnet"] = "Double-A Chain Mainnet";
    ChainName["Double-AChainTestnet"] = "Double-A Chain Testnet";
    ChainName["GearZeroNetworkMainnet"] = "Gear Zero Network Mainnet";
    ChainName["XTSmartChainMainnet"] = "XT Smart Chain Mainnet";
    ChainName["FirechainMainnet"] = "Firechain Mainnet";
    ChainName["PundiAIFXOmnilayer"] = "Pundi AIFX Omnilayer";
    ChainName["Candle"] = "Candle";
    ChainName["OpTrustMainnet"] = "OpTrust Mainnet";
    ChainName["PAWCHAINTestnet"] = "PAWCHAIN Testnet";
    ChainName["FlowEVMTestnet"] = "Flow EVM Testnet";
    ChainName["River"] = "River";
    ChainName["Vela1ChainMainnet"] = "Vela1 Chain Mainnet";
    ChainName["TaoNetwork"] = "Tao Network";
    ChainName["PrometheuzTestnet"] = "Prometheuz Testnet";
    ChainName["DogechainTestnet"] = "Dogechain Testnet";
    ChainName["RolluxMainnet"] = "Rollux Mainnet";
    ChainName["MetaChainMainnet"] = "MetaChain Mainnet";
    ChainName["FilenovaMainnet"] = "Filenova Mainnet";
    ChainName["MetisStardustTestnet"] = "Metis Stardust Testnet";
    ChainName["Astar"] = "Astar";
    ChainName["AcalaMandalaTestnetTC9"] = "Acala Mandala Testnet TC9";
    ChainName["KaruraNetworkTestnet"] = "Karura Network Testnet";
    ChainName["AcalaNetworkTestnet"] = "Acala Network Testnet";
    ChainName["MetisGoerliTestnet"] = "Metis Goerli Testnet";
    ChainName["Meshnyantestnet"] = "Meshnyan testnet";
    ChainName["VineTestnet"] = "Vine Testnet";
    ChainName["DarwinDevnet"] = "Darwin Devnet";
    ChainName["EIOBMainnet"] = "EIOB Mainnet";
    ChainName["GraphlinqBlockchainMainnet"] = "Graphlinq Blockchain Mainnet";
    ChainName["Skynet"] = "Skynet";
    ChainName["BinaryMainnet"] = "Binary Mainnet";
    ChainName["BinarySepolia"] = "Binary Sepolia";
    ChainName["NFBChain"] = "NFB Chain";
    ChainName["Avocado"] = "Avocado";
    ChainName["FlowEVMPreviewnet"] = "Flow EVM Previewnet";
    ChainName["SXNetworkTestnet"] = "SX Network Testnet";
    ChainName["EnduranceSmartChainMainnet"] = "Endurance Smart Chain Mainnet";
    ChainName["KalichainTestnet"] = "Kalichain Testnet";
    ChainName["Kalichain"] = "Kalichain";
    ChainName["AmaxSmartchain"] = "AmaxSmartchain";
    ChainName["PixieChainTestnet"] = "Pixie Chain Testnet";
    ChainName["LAOSArrakis"] = "LAOS Arrakis";
    ChainName["JuncaChain"] = "JuncaChain";
    ChainName["JuncaChaintestnet"] = "JuncaChain testnet";
    ChainName["Janction"] = "Janction";
    ChainName["JanctionTestnet"] = "Janction Testnet";
    ChainName["KaruraNetwork"] = "Karura Network";
    ChainName["NEROTestnet"] = "NERO Testnet";
    ChainName["Redstone"] = "Redstone";
    ChainName["Matchain"] = "Matchain";
    ChainName["MatchainTestnet"] = "Matchain Testnet";
    ChainName["StarSocialTestnet"] = "Star Social Testnet";
    ChainName["DarwiniaKoiTestnet"] = "Darwinia Koi Testnet";
    ChainName["BlockChainStationMainnet"] = "BlockChain Station Mainnet";
    ChainName["BlockChainStationTestnet"] = "BlockChain Station Testnet";
    ChainName["Highbury"] = "Highbury";
    ChainName["Tucana"] = "Tucana";
    ChainName["Birdee-2"] = "Birdee-2";
    ChainName["VrcscanMainnet"] = "Vrcscan Mainnet";
    ChainName["UXLINKONEMainnet"] = "UXLINK ONE Mainnet";
    ChainName["ShibariumBeta"] = "Shibarium Beta";
    ChainName["LycanChain"] = "Lycan Chain";
    ChainName["Blucrates"] = "Blucrates";
    ChainName["LovelyNetworkMainnet"] = "Lovely Network Mainnet";
    ChainName["CantoTestnet"] = "Canto Testnet";
    ChainName["VentionSmartChainTestnet"] = "Vention Smart Chain Testnet";
    ChainName["ScriptTestnet"] = "Script Testnet";
    ChainName["TranchedMainnet"] = "Tranched Mainnet";
    ChainName["FlowEVMMainnet"] = "Flow EVM Mainnet";
    ChainName["Rivalz"] = "Rivalz";
    ChainName["QL1"] = "QL1";
    ChainName["OpenChainTestnet"] = "OpenChain Testnet";
    ChainName["CheapETH"] = "cheapETH";
    ChainName["AUTHEOTestnet"] = "AUTHEO Testnet";
    ChainName["MAALChain"] = "MAAL Chain";
    ChainName["AcalaNetwork"] = "Acala Network";
    ChainName["AerochainTestnet"] = "Aerochain Testnet";
    ChainName["Patex"] = "Patex";
    ChainName["RupayaTestnet"] = "Rupaya Testnet";
    ChainName["LucidBlockchain"] = "Lucid Blockchain";
    ChainName["Haic"] = "Haic";
    ChainName["EvozMainnet"] = "Evoz Mainnet";
    ChainName["PortalFantasyChainTest"] = "Portal Fantasy Chain Test";
    ChainName["Haven1Testnet"] = "Haven1 Testnet";
    ChainName["QitmeerNetworkMainnet"] = "Qitmeer Network Mainnet";
    ChainName["FirechainzkEVM"] = "Firechain zkEVM";
    ChainName["BeOneChainMainnet"] = "BeOne Chain Mainnet";
    ChainName["CallistoMainnet"] = "Callisto Mainnet";
    ChainName["CallistoTestnetDeprecated"] = "Callisto Testnet Deprecated";
    ChainName["RunicChainTestnet"] = "Runic Chain Testnet";
    ChainName["DailyNetworkMainnet"] = "Daily Network Mainnet";
    ChainName["DailyNetworkTestnet"] = "Daily Network Testnet";
    ChainName["CheckDotBlockchainDevnet"] = "CheckDot Blockchain Devnet";
    ChainName["TaraxaMainnet"] = "Taraxa Mainnet";
    ChainName["TaraxaTestnet"] = "Taraxa Testnet";
    ChainName["HongKongMainnet"] = "HongKong Mainnet";
    ChainName["ZeethChainDev"] = "Zeeth Chain Dev";
    ChainName["ElectraNetwork"] = "Electra Network";
    ChainName["RadiusTestnet"] = "Radius Testnet";
    ChainName["FantasiaChainMainnet"] = "Fantasia Chain Mainnet";
    ChainName["ElectraTestNetwork"] = "Electra Test Network";
    ChainName["BandaiNamcoResearchVerseMainnet"] = "Bandai Namco Research Verse Mainnet";
    ChainName["DexitNetwork"] = "Dexit Network";
    ChainName["AmbrosChainMainnet"] = "Ambros Chain Mainnet";
    ChainName["WeberGovernanceMainnet"] = "Weber Governance Mainnet";
    ChainName["Wanchain"] = "Wanchain";
    ChainName["MAXIChainTestnet"] = "MAXI Chain Testnet";
    ChainName["MAXIChainMainnet"] = "MAXI Chain Mainnet";
    ChainName["GarizonTestnetStage0"] = "Garizon Testnet Stage0";
    ChainName["GarizonTestnetStage1"] = "Garizon Testnet Stage1";
    ChainName["GarizonTestnetStage2"] = "Garizon Testnet Stage2";
    ChainName["GarizonTestnetStage3"] = "Garizon Testnet Stage3";
    ChainName["PortalFantasyChain"] = "Portal Fantasy Chain";
    ChainName["DecentraBoneLayer1Testnet"] = "DecentraBone Layer1 Testnet";
    ChainName["TAPROOTMainnet"] = "TAPROOT Mainnet";
    ChainName["Rinia"] = "Rinia";
    ChainName["SlerfChainMainnet"] = "SlerfChain Mainnet";
    ChainName["ModeTestnet"] = "Mode Testnet";
    ChainName["YidarkChainMainnet"] = "Yidark Chain Mainnet";
    ChainName["HaustMainnet"] = "Haust Mainnet";
    ChainName["PulseChainTestnet"] = "PulseChain Testnet";
    ChainName["PulseChainTestnetv2b"] = "PulseChain Testnet v2b";
    ChainName["PulseChainTestnetv3"] = "PulseChain Testnet v3";
    ChainName["PulseChainTestnetv4"] = "PulseChain Testnet v4";
    ChainName["SubtensorEVMTestnet"] = "Subtensor EVM Testnet";
    ChainName["MuNodeTestnet"] = "muNode Testnet";
    ChainName["LyraChain"] = "Lyra Chain";
    ChainName["BTC20SmartChain"] = "BTC20 Smart Chain";
    ChainName["SubtensorEVM"] = "Subtensor EVM";
    ChainName["EthXY"] = "EthXY";
    ChainName["OortMainnet"] = "Oort Mainnet";
    ChainName["OortHuygens"] = "Oort Huygens";
    ChainName["OortAscraeus"] = "Oort Ascraeus";
    ChainName["PalmSmartChain"] = "Palm Smart Chain";
    ChainName["NepalBlockchainNetwork"] = "Nepal Blockchain Network";
    ChainName["EthXYTestnet"] = "EthXY Testnet";
    ChainName["TOPMainnetEVM"] = "TOP Mainnet EVM";
    ChainName["IOPNTestnet"] = "IOPN Testnet";
    ChainName["MemoSmartChainMainnet"] = "Memo Smart Chain Mainnet";
    ChainName["LAGOMMainnet"] = "LAGOM Mainnet";
    ChainName["BinaryChainMainnet"] = "BinaryChain Mainnet";
    ChainName["TOPMainnet"] = "TOP Mainnet";
    ChainName["ELibertyMainnet"] = "eLiberty Mainnet";
    ChainName["5ireChainMainnet"] = "5ireChain Mainnet";
    ChainName["BifrostPolkadotMainnet"] = "Bifrost Polkadot Mainnet";
    ChainName["5ireChainThunderTestnet"] = "5ireChain Thunder Testnet";
    ChainName["HyperliquidEVMTestnet"] = "Hyperliquid EVM Testnet";
    ChainName["WanchainTestnet"] = "Wanchain Testnet";
    ChainName["GTONMainnet"] = "GTON Mainnet";
    ChainName["KaiaKairosTestnet"] = "Kaia Kairos Testnet";
    ChainName["TectumEmissionToken"] = "Tectum Emission Token";
    ChainName["T-EKTA"] = "T-EKTA";
    ChainName["LemonChainTestnet"] = "LemonChainTestnet";
    ChainName["LemonChain"] = "LemonChain";
    ChainName["NewtonTestnet"] = "Newton Testnet";
    ChainName["EurusMainnet"] = "Eurus Mainnet";
    ChainName["JumbochainMainnet"] = "Jumbochain Mainnet";
    ChainName["EvriceNetwork"] = "Evrice Network";
    ChainName["RebusClassicMainnet"] = "Rebus Classic Mainnet";
    ChainName["Newton"] = "Newton";
    ChainName["Sakura"] = "Sakura";
    ChainName["CloverTestnet"] = "Clover Testnet";
    ChainName["CLVParachain"] = "CLV Parachain";
    ChainName["BitTorrentChainTestnet"] = "BitTorrent Chain Testnet";
    ChainName["BitTorrentChainDonau"] = "BitTorrent Chain Donau";
    ChainName["ConfluxeSpace"] = "Conflux eSpace";
    ChainName["ProxyNetworkTestnet"] = "Proxy Network Testnet";
    ChainName["BronosTestnet"] = "Bronos Testnet";
    ChainName["BronosMainnet"] = "Bronos Mainnet";
    ChainName["OpenGPUMainnet"] = "OpenGPU Mainnet";
    ChainName["ShimmerEVMTestnetDeprecated1072"] = "ShimmerEVM Testnet Deprecated 1072";
    ChainName["ShimmerEVMTestnet"] = "ShimmerEVM Testnet";
    ChainName["IOTAEVMTestnet"] = "IOTA EVM Testnet";
    ChainName["MintaraTestnet"] = "Mintara Testnet";
    ChainName["MintaraMainnet"] = "Mintara Mainnet";
    ChainName["MetisAndromedaMainnet"] = "Metis Andromeda Mainnet";
    ChainName["Humans.aiMainnet"] = "Humans.ai Mainnet";
    ChainName["MOACmainnet"] = "MOAC mainnet";
    ChainName["Dymension"] = "Dymension";
    ChainName["PolygonzkEVM"] = "Polygon zkEVM";
    ChainName["BLXqTestnet"] = "BLXq Testnet";
    ChainName["BLXqMainnet"] = "BLXq Mainnet";
    ChainName["WEMIX3.0Mainnet"] = "WEMIX3.0 Mainnet";
    ChainName["WEMIX3.0Testnet"] = "WEMIX3.0 Testnet";
    ChainName["B2HubTestnet"] = "B2 Hub Testnet";
    ChainName["CoreBlockchainTestnet2"] = "Core Blockchain Testnet2";
    ChainName["CoreBlockchainTestnet"] = "Core Blockchain Testnet";
    ChainName["CoreBlockchainMainnet"] = "Core Blockchain Mainnet";
    ChainName["DogcoinMainnet"] = "Dogcoin Mainnet";
    ChainName["B2Testnet"] = "B2 Testnet";
    ChainName["TakerChainMainnet"] = "Taker Chain Mainnet";
    ChainName["DeFiChainEVMNetworkMainnet"] = "DeFiChain EVM Network Mainnet";
    ChainName["DeFiChainEVMNetworkTestnet"] = "DeFiChain EVM Network Testnet";
    ChainName["DeFiMetaChainChangiTestnet"] = "DeFiMetaChain Changi Testnet";
    ChainName["StateMesh"] = "StateMesh";
    ChainName["Lisk"] = "Lisk";
    ChainName["AmStarTestnet"] = "AmStar Testnet";
    ChainName["MathChain"] = "MathChain";
    ChainName["MathChainTestnet"] = "MathChain Testnet";
    ChainName["FlagTestnet"] = "Flag Testnet";
    ChainName["SymplexiaSmartChain"] = "Symplexia Smart Chain";
    ChainName["OriginTestnet"] = "Origin Testnet";
    ChainName["LitheumTestNetwork"] = "Litheum Test Network";
    ChainName["SmartHostTeknolojiTESTNET"] = "Smart Host Teknoloji TESTNET";
    ChainName["ClubMosMainnet"] = "ClubMos Mainnet";
    ChainName["IoraChain"] = "Iora Chain";
    ChainName["CuckooChain"] = "Cuckoo Chain";
    ChainName["EvanescoTestnet"] = "Evanesco Testnet";
    ChainName["WorldTradeTechnicalChainMainnet"] = "World Trade Technical Chain Mainnet";
    ChainName["SaitaBlockChain(SBC)"] = "SaitaBlockChain(SBC)";
    ChainName["CuckooSepolia"] = "Cuckoo Sepolia";
    ChainName["ADFChainTestnet"] = "ADF Chain Testnet";
    ChainName["PopcateumMainnet"] = "Popcateum Mainnet";
    ChainName["EnterChainMainnet"] = "EnterChain Mainnet";
    ChainName["ADFChain"] = "ADF Chain";
    ChainName["CycleNetworkTestnet"] = "Cycle Network Testnet";
    ChainName["CycleNetworkTestnetJellyfish"] = "Cycle Network Testnet Jellyfish";
    ChainName["HybridTestnet(Deprecated)"] = "Hybrid Testnet (Deprecated)";
    ChainName["HybridTestnet"] = "Hybrid Testnet";
    ChainName["BitcoinProtocolTestnet"] = "Bitcoin Protocol Testnet";
    ChainName["CycleNetworkTestnetCuttlefish"] = "Cycle Network Testnet Cuttlefish";
    ChainName["ExzoNetworkMainnet"] = "Exzo Network Mainnet";
    ChainName["UltronTestnet"] = "Ultron Testnet";
    ChainName["UltronMainnet"] = "Ultron Mainnet";
    ChainName["StepNetwork"] = "Step Network";
    ChainName["ITXMainnet"] = "ITX Mainnet";
    ChainName["ARCMainnet"] = "ARC Mainnet";
    ChainName["ARCTestnet"] = "ARC Testnet";
    ChainName["OMPlatformMainnet"] = "OM Platform Mainnet";
    ChainName["DogetherMainnet"] = "Dogether Mainnet";
    ChainName["CICChainTestnet"] = "CIC Chain Testnet";
    ChainName["MetaccesTestnet"] = "Metacces Testnet";
    ChainName["HALOMainnet"] = "HALO Mainnet";
    ChainName["Moonbeam"] = "Moonbeam";
    ChainName["Moonriver"] = "Moonriver";
    ChainName["Moonrockold"] = "Moonrock old";
    ChainName["MoonbaseAlpha"] = "Moonbase Alpha";
    ChainName["Moonrock"] = "Moonrock";
    ChainName["SwisstronikTestnet"] = "Swisstronik Testnet";
    ChainName["Bobabeam"] = "Bobabeam";
    ChainName["BobabaseTestnet"] = "Bobabase Testnet";
    ChainName["ArgochainTestnet"] = "Argochain Testnet";
    ChainName["Argochain"] = "Argochain";
    ChainName["GlueMainnet"] = "Glue Mainnet";
    ChainName["UnichainSepoliaTestnet"] = "Unichain Sepolia Testnet";
    ChainName["COINZAX"] = "COINZAX";
    ChainName["DosFujiSubnet"] = "Dos Fuji Subnet";
    ChainName["JaiHoChain"] = "JaiHo Chain";
    ChainName["AlyxMainnet"] = "Alyx Mainnet";
    ChainName["StoryAeneidTestnet"] = "Story Aeneid Testnet";
    ChainName["AIAMainnet"] = "AIA Mainnet";
    ChainName["AIATestnet"] = "AIA Testnet";
    ChainName["SeiTestnet"] = "Sei Testnet";
    ChainName["SeiNetwork"] = "Sei Network";
    ChainName["KiiTestnetOro"] = "Kii Testnet Oro";
    ChainName["GethTestnet"] = "Geth Testnet";
    ChainName["ElysiumTestnet"] = "Elysium Testnet";
    ChainName["ElysiumMainnet"] = "Elysium Mainnet";
    ChainName["BlitzSubnet"] = "Blitz Subnet";
    ChainName["CICChainMainnet"] = "CIC Chain Mainnet";
    ChainName["ZafiriumMainnet"] = "Zafirium Mainnet";
    ChainName["RamesttaMainnet"] = "Ramestta Mainnet";
    ChainName["Pingakshatestnet"] = "Pingaksha testnet";
    ChainName["KalarChain"] = "Kalar Chain";
    ChainName["AmStarMainnet"] = "AmStar Mainnet";
    ChainName["JoseonMainnet"] = "Joseon Mainnet";
    ChainName["PolygonzkEVMTestnetold"] = "Polygon zkEVM Testnet old";
    ChainName["SiliconzkEVMSepoliaTestnet(Deprecated)"] = "Silicon zkEVM Sepolia Testnet(Deprecated)";
    ChainName["PolygonzkEVMTestnetPreAudit-Upgraded"] = "Polygon zkEVM Testnet Pre Audit-Upgraded";
    ChainName["Perennial"] = "Perennial";
    ChainName["ONINOMainnet"] = "ONINO Mainnet";
    ChainName["RikezaNetworkMainnet"] = "Rikeza Network Mainnet";
    ChainName["LivingAssetsMainnet"] = "Living Assets Mainnet";
    ChainName["PolygonzkEVMTestnet"] = "Polygon zkEVM Testnet";
    ChainName["GILTestnet"] = "GIL Testnet";
    ChainName["MetaChainIstanbul"] = "MetaChain Istanbul";
    ChainName["CtexScanBlockchain"] = "Ctex Scan Blockchain";
    ChainName["ZKBaseMainnet"] = "ZKBase Mainnet";
    ChainName["Vana"] = "Vana";
    ChainName["VitruveoMainnet"] = "Vitruveo Mainnet";
    ChainName["IDosGamesChainTestnet"] = "iDos Games Chain Testnet";
    ChainName["BEVMCanary"] = "BEVM Canary";
    ChainName["SherpaxMainnet"] = "Sherpax Mainnet";
    ChainName["SherpaxTestnet"] = "Sherpax Testnet";
    ChainName["StoryTestnet"] = "Story Testnet";
    ChainName["Story"] = "Story";
    ChainName["BeagleMessagingChain"] = "Beagle Messaging Chain";
    ChainName["StoryOdysseyTestnet"] = "Story Odyssey Testnet";
    ChainName["DatacoreSmartChain"] = "Datacore Smart Chain";
    ChainName["Tenet"] = "Tenet";
    ChainName["StarCHAINTestnet"] = "StarCHAIN Testnet";
    ChainName["StarCHAIN"] = "StarCHAIN";
    ChainName["ReactiveMainnet"] = "Reactive Mainnet";
    ChainName["Betherance"] = "Betherance";
    ChainName["EthereumInscriptionMainnet"] = "Ethereum Inscription Mainnet";
    ChainName["CatecoinChainMainnet"] = "Catecoin Chain Mainnet";
    ChainName["Atheios"] = "Atheios";
    ChainName["GravityAlphaMainnet"] = "Gravity Alpha Mainnet";
    ChainName["PivotalMainnet"] = "Pivotal Mainnet";
    ChainName["Btachain"] = "Btachain";
    ChainName["Liquichain"] = "Liquichain";
    ChainName["HorizenGobiTestnet"] = "Horizen Gobi Testnet";
    ChainName["MintTestnet"] = "Mint Testnet";
    ChainName["MintSepoliaTestnet"] = "Mint Sepolia Testnet";
    ChainName["LUDANMainnet"] = "LUDAN Mainnet";
    ChainName["NEROMainnet"] = "NERO Mainnet";
    ChainName["AnytypeEVMChain"] = "Anytype EVM Chain";
    ChainName["TBSIMainnet"] = "TBSI Mainnet";
    ChainName["TBSITestnet"] = "TBSI Testnet";
    ChainName["DoricNetwork"] = "Doric Network";
    ChainName["PaletteChainMainnet"] = "Palette Chain Mainnet";
    ChainName["EthparMainnet"] = "Ethpar Mainnet";
    ChainName["ReyaNetwork"] = "Reya Network";
    ChainName["FugaMainnet"] = "Fuga Mainnet";
    ChainName["FugaTestnet"] = "Fuga Testnet";
    ChainName["FugaDevelop"] = "Fuga Develop";
    ChainName["MetalL2Testnet"] = "Metal L2 Testnet";
    ChainName["MetalL2"] = "Metal L2";
    ChainName["PartyChain"] = "PartyChain";
    ChainName["GaussMainnet"] = "Gauss Mainnet";
    ChainName["ZKBaseSepoliaTestnet"] = "ZKBase Sepolia Testnet";
    ChainName["Kerleano"] = "Kerleano";
    ChainName["RabbitAnalogTestnetChain"] = "Rabbit Analog Testnet Chain";
    ChainName["Lif3ChainTestnet"] = "Lif3 Chain Testnet";
    ChainName["CubeChainMainnet"] = "Cube Chain Mainnet";
    ChainName["CubeChainTestnet"] = "Cube Chain Testnet";
    ChainName["RubySmartChainMAINNET"] = "Ruby Smart Chain MAINNET";
    ChainName["PlayBlock"] = "PlayBlock";
    ChainName["Verifytestnet"] = "Verify testnet";
    ChainName["SwisstronikMainnet"] = "Swisstronik Mainnet";
    ChainName["HighOctaneSubnet"] = "HighOctane Subnet";
    ChainName["Teslafunds"] = "Teslafunds";
    ChainName["Soneium"] = "Soneium";
    ChainName["Whitechain"] = "Whitechain";
    ChainName["GitshockCartenzTestnet"] = "Gitshock Cartenz Testnet";
    ChainName["LightlinkPhoenixMainnet"] = "Lightlink Phoenix Mainnet";
    ChainName["LightlinkPegasusTestnet"] = "Lightlink Pegasus Testnet";
    ChainName["BONNetwork"] = "BON Network";
    ChainName["ReDeFiLayer2"] = "ReDeFi Layer 2";
    ChainName["SportsChainNetwork"] = "Sports Chain Network";
    ChainName["BitcichainMainnet"] = "Bitcichain Mainnet";
    ChainName["BitcichainTestnet"] = "Bitcichain Testnet";
    ChainName["MerkleScan"] = "Merkle Scan";
    ChainName["Scalind"] = "Scalind";
    ChainName["RubySmartChainTestnet"] = "Ruby Smart Chain Testnet";
    ChainName["UPBCRESCDITestnet"] = "UPB CRESCDI Testnet";
    ChainName["Swellchain"] = "Swellchain";
    ChainName["SwellchainTestnet"] = "Swellchain Testnet";
    ChainName["ArvixTestnet"] = "Arvix Testnet";
    ChainName["ONUSChainTestnet"] = "ONUS Chain Testnet";
    ChainName["SoneiumTestnetMinato"] = "Soneium Testnet Minato";
    ChainName["BionixTestnet"] = "Bionix Testnet";
    ChainName["D-ChainMainnet"] = "D-Chain Mainnet";
    ChainName["SelendraNetworkTestnet"] = "Selendra Network Testnet";
    ChainName["DexillaTestnet"] = "Dexilla Testnet";
    ChainName["AIW3Testnet"] = "AIW3 Testnet";
    ChainName["SelendraNetworkMainnet"] = "Selendra Network Mainnet";
    ChainName["Eleanor"] = "Eleanor";
    ChainName["SuperSmartChainTestnet"] = "Super Smart Chain Testnet";
    ChainName["SuperSmartChainMainnet"] = "Super Smart Chain Mainnet";
    ChainName["Atelier"] = "Atelier";
    ChainName["RedeCoin"] = "RedeCoin";
    ChainName["ONUSChainMainnet"] = "ONUS Chain Mainnet";
    ChainName["EurusTestnet"] = "Eurus Testnet";
    ChainName["SatoshIE"] = "SatoshIE";
    ChainName["SatoshIETestnet"] = "SatoshIE Testnet";
    ChainName["EtherGem"] = "EtherGem";
    ChainName["LydiaCoin"] = "Lydia Coin";
    ChainName["HubbleExchange"] = "Hubble Exchange";
    ChainName["B3SepoliaTestnet"] = "B3 Sepolia Testnet";
    ChainName["Ekta"] = "Ekta";
    ChainName["EdeXaTestnet"] = "edeXa Testnet";
    ChainName["Sanko"] = "Sanko";
    ChainName["Kyoto"] = "Kyoto";
    ChainName["KyotoTestnet"] = "Kyoto Testnet";
    ChainName["DogechainMainnet"] = "Dogechain Mainnet";
    ChainName["MilkomedaC1Mainnet"] = "Milkomeda C1 Mainnet";
    ChainName["MilkomedaA1Mainnet"] = "Milkomeda A1 Mainnet";
    ChainName["MetaLinkNetwork"] = "MetaLink Network";
    ChainName["CloudWalkTestnet"] = "CloudWalk Testnet";
    ChainName["CloudWalkMainnet"] = "CloudWalk Mainnet";
    ChainName["Panarchy"] = "Panarchy";
    ChainName["NOWChainTestnet"] = "NOW Chain Testnet";
    ChainName["MainnetZMainnet"] = "MainnetZ Mainnet";
    ChainName["Adiri"] = "Adiri";
    ChainName["PublicMintDevnet"] = "PublicMint Devnet";
    ChainName["PublicMintTestnet"] = "PublicMint Testnet";
    ChainName["RoninMainnet"] = "Ronin Mainnet";
    ChainName["EdgewareEdgeEVMMainnet"] = "Edgeware EdgeEVM Mainnet";
    ChainName["BeresheetBereEVMTestnet"] = "Beresheet BereEVM Testnet";
    ChainName["TaycanTestnet"] = "Taycan Testnet";
    ChainName["SwanSaturnTestnet"] = "Swan Saturn Testnet";
    ChainName["RangersProtocolMainnet"] = "Rangers Protocol Mainnet";
    ChainName["EdgelessNetwork"] = "Edgeless Network";
    ChainName["Centrifuge"] = "Centrifuge";
    ChainName["Catalyst"] = "Catalyst";
    ChainName["PhalaNetwork"] = "Phala Network";
    ChainName["KiwiSubnet"] = "Kiwi Subnet";
    ChainName["ShrapnelTestnet"] = "Shrapnel Testnet";
    ChainName["AlephZero"] = "Aleph Zero";
    ChainName["VanarMainnet"] = "Vanar Mainnet";
    ChainName["NeuroWeb"] = "NeuroWeb";
    ChainName["ShrapnelSubnet"] = "Shrapnel Subnet";
    ChainName["AIW3Mainnet"] = "AIW3 Mainnet";
    ChainName["StratosTestnet"] = "Stratos Testnet";
    ChainName["Stratos"] = "Stratos";
    ChainName["MovoSmartChainMainnet"] = "Movo Smart Chain Mainnet";
    ChainName["MetaccesMainnet"] = "Metacces Mainnet";
    ChainName["QuokkacoinMainnet"] = "Quokkacoin Mainnet";
    ChainName["Altair"] = "Altair";
    ChainName["Algol"] = "Algol";
    ChainName["EcoballMainnet"] = "Ecoball Mainnet";
    ChainName["EcoballTestnetEspuma"] = "Ecoball Testnet Espuma";
    ChainName["ExosamaNetwork"] = "Exosama Network";
    ChainName["UCHAINMainnet"] = "UCHAIN Mainnet";
    ChainName["CatenaMainnet"] = "Catena Mainnet";
    ChainName["MetaplayeroneMainnet"] = "Metaplayerone Mainnet";
    ChainName["MetaplayeroneDubaiTestnet"] = "Metaplayerone Dubai Testnet";
    ChainName["BigShortBetsTestnet"] = "BigShortBets Testnet";
    ChainName["BigShortBets"] = "BigShortBets";
    ChainName["DefiOracleMetaTestnet"] = "Defi Oracle Meta Testnet";
    ChainName["OnenessNetwork"] = "Oneness Network";
    ChainName["OnenessTestNet"] = "Oneness TestNet";
    ChainName["BOSagoraMainnet"] = "BOSagora Mainnet";
    ChainName["FindoraMainnet"] = "Findora Mainnet";
    ChainName["FindoraTestnet"] = "Findora Testnet";
    ChainName["FindoraForge"] = "Findora Forge";
    ChainName["AnimechainTestnet"] = "Animechain Testnet";
    ChainName["Game7"] = "Game7";
    ChainName["SnaxChain"] = "SnaxChain";
    ChainName["MoonsamaNetwork"] = "Moonsama Network";
    ChainName["AntofyMainnet"] = "Antofy Mainnet";
    ChainName["BitcoinEVM"] = "Bitcoin EVM";
    ChainName["EvanescoMainnet"] = "Evanesco Mainnet";
    ChainName["KavaTestnet"] = "Kava Testnet";
    ChainName["Kava"] = "Kava";
    ChainName["VChainMainnet"] = "VChain Mainnet";
    ChainName["KrestNetwork"] = "Krest Network";
    ChainName["BOMBChain"] = "BOMB Chain";
    ChainName["EbroNetwork"] = "Ebro Network";
    ChainName["Arevia"] = "Arevia";
    ChainName["CratD2C"] = "CratD2C";
    ChainName["ChronicleVesuvius-LitProtocolTestnet"] = "Chronicle Vesuvius - Lit Protocol Testnet";
    ChainName["SOMANetworkTestnet"] = "SOMA Network Testnet";
    ChainName["Altcoinchain"] = "Altcoinchain";
    ChainName["RSS3VSLSepoliaTestnet"] = "RSS3 VSL Sepolia Testnet";
    ChainName["SOMANetworkMainnet"] = "SOMA Network Mainnet";
    ChainName["AtletaOlympia"] = "Atleta Olympia";
    ChainName["OmniaChain"] = "Omnia Chain";
    ChainName["GOATNetwork"] = "GOAT Network";
    ChainName["SiliconzkEVM"] = "Silicon zkEVM";
    ChainName["(deprecated)KromaSepolia"] = "(deprecated) Kroma Sepolia";
    ChainName["KromaSepolia"] = "Kroma Sepolia";
    ChainName["KiteAITestnet"] = "KiteAI Testnet";
    ChainName["NexisNetworkTestnet"] = "Nexis Network Testnet";
    ChainName["TACTurin"] = "TAC Turin";
    ChainName["BOMBChainTestnet"] = "BOMB Chain Testnet";
    ChainName["TCGVerseMainnet"] = "TCG Verse Mainnet";
    ChainName["K2Mainnet"] = "K2 Mainnet";
    ChainName["XODEX"] = "XODEX";
    ChainName["Rufus"] = "Rufus";
    ChainName["InEVMTestnet"] = "inEVM Testnet";
    ChainName["KingOfLegendsMainnet"] = "King Of Legends Mainnet";
    ChainName["StandardTestnet"] = "Standard Testnet";
    ChainName["AtletaNetwork"] = "Atleta Network";
    ChainName["PolygonzkEVMCardonaTestnet"] = "Polygon zkEVM Cardona Testnet";
    ChainName["HybridChainNetworkTestnet"] = "Hybrid Chain Network Testnet";
    ChainName["HybridChainNetworkMainnet"] = "Hybrid Chain Network Mainnet";
    ChainName["6DegreeofOutreach"] = "6Degree of Outreach";
    ChainName["UnicornUltraNebulasTestnet"] = "Unicorn Ultra Nebulas Testnet";
    ChainName["NOWChainMainnet"] = "NOW Chain Mainnet";
    ChainName["KarakGoerli"] = "Karak Goerli";
    ChainName["K2Testnet"] = "K2 Testnet";
    ChainName["FraxtalTestnet"] = "Fraxtal Testnet";
    ChainName["InEVMMainnet"] = "inEVM Mainnet";
    ChainName["Bahamuthorizon"] = "Bahamut horizon";
    ChainName["KorthoMainnet"] = "Kortho Mainnet";
    ChainName["TechPayMainnet"] = "TechPay Mainnet";
    ChainName["PhoBlockchainMainnet"] = "Pho Blockchain Mainnet";
    ChainName["PoCRNet"] = "PoCRNet";
    ChainName["RedlightChainMainnet"] = "Redlight Chain Mainnet";
    ChainName["EZChainC-ChainMainnet"] = "EZChain C-Chain Mainnet";
    ChainName["EZChainC-ChainTestnet"] = "EZChain C-Chain Testnet";
    ChainName["WhitechainTestnet"] = "Whitechain Testnet";
    ChainName["AILayerTestnet"] = "AILayer Testnet";
    ChainName["AILayerMainnet"] = "AILayer Mainnet";
    ChainName["APEX"] = "APEX";
    ChainName["MorphTestnet"] = "Morph Testnet";
    ChainName["K-LAOS"] = "K-LAOS";
    ChainName["XRSepolia"] = "XR Sepolia";
    ChainName["ElizabethTestnet"] = "Elizabeth Testnet";
    ChainName["Abstract"] = "Abstract";
    ChainName["Nanon"] = "Nanon";
    ChainName["GMNetworkMainnet"] = "GM Network Mainnet";
    ChainName["Apertum"] = "Apertum";
    ChainName["MorphHolesky"] = "Morph Holesky";
    ChainName["Morph"] = "Morph";
    ChainName["HyperAGIMainnet"] = "HyperAGI Mainnet";
    ChainName["ChipsNetwork"] = "Chips Network";
    ChainName["BobaNetworkGoerliTestnet"] = "Boba Network Goerli Testnet";
    ChainName["AarmaMainnet"] = "Aarma Mainnet";
    ChainName["EluxChain"] = "Elux Chain";
    ChainName["HYCHAIN"] = "HYCHAIN";
    ChainName["XenonChainTestnet"] = "Xenon Chain Testnet";
    ChainName["BitYuanMainnet"] = "BitYuan Mainnet";
    ChainName["CENNZnetRata"] = "CENNZnet Rata";
    ChainName["CENNZnetNikau"] = "CENNZnet Nikau";
    ChainName["CanxiumMainnet"] = "Canxium Mainnet";
    ChainName["PLAYA3ULLGAMES"] = "PLAYA3ULL GAMES";
    ChainName["BCHyperChainMainnet"] = "BC Hyper Chain Mainnet";
    ChainName["OrlandoChain"] = "Orlando Chain";
    ChainName["RebusTestnet"] = "Rebus Testnet";
    ChainName["BifrostMainnet"] = "Bifrost Mainnet";
    ChainName["MovementEVM"] = "Movement EVM";
    ChainName["XLNetworkTestnet"] = "XL Network Testnet";
    ChainName["Immu3EVM"] = "Immu3 EVM";
    ChainName["VultureEVMBeta"] = "Vulture EVM Beta";
    ChainName["SatoshiVMAlphaMainnet"] = "SatoshiVM Alpha Mainnet";
    ChainName["SatoshiVMTestnet"] = "SatoshiVM Testnet";
    ChainName["Filecoin-Hyperspacetestnet"] = "Filecoin - Hyperspace testnet";
    ChainName["Dubxcoinnetwork"] = "Dubxcoin network";
    ChainName["Dubxcointestnet"] = "Dubxcoin testnet";
    ChainName["DebounceSubnetTestnet"] = "Debounce Subnet Testnet";
    ChainName["ZCoreTestnet"] = "ZCore Testnet";
    ChainName["EthStorageL2Mainnet"] = "EthStorage L2 Mainnet";
    ChainName["EthStorageTestnet"] = "EthStorage Testnet";
    ChainName["Web3QGalileo"] = "Web3Q Galileo";
    ChainName["QuarkChainL2BetaTestnet"] = "QuarkChain L2 Beta Testnet";
    ChainName["EthStorageL2Testnet"] = "EthStorage L2 Testnet";
    ChainName["EthStorageDevnet"] = "EthStorage Devnet";
    ChainName["Peaq"] = "peaq";
    ChainName["EthStorageMainnet"] = "EthStorage Mainnet";
    ChainName["PentagonChain"] = "Pentagon Chain";
    ChainName["Meroneum"] = "Meroneum";
    ChainName["MeroneumTestnet"] = "Meroneum Testnet";
    ChainName["ParibuNetMainnet"] = "Paribu Net Mainnet";
    ChainName["PepeUnchained"] = "Pepe Unchained";
    ChainName["EVOLVEMainnet"] = "EVOLVE Mainnet";
    ChainName["SecureChainTestnet"] = "SecureChain Testnet";
    ChainName["LayerEdgetestnet"] = "LayerEdge testnet";
    ChainName["GTCSCAN"] = "GTCSCAN";
    ChainName["ParibuNetTestnet"] = "Paribu Net Testnet";
    ChainName["JFINChain"] = "JFIN Chain";
    ChainName["JFINPOS"] = "JFINPOS";
    ChainName["PandoProjectMainnet"] = "PandoProject Mainnet";
    ChainName["PandoProjectTestnet"] = "PandoProject Testnet";
    ChainName["Tycooncoin"] = "Tycooncoin";
    ChainName["BotanixTestnet"] = "Botanix Testnet";
    ChainName["BotanixMainnet"] = "Botanix Mainnet";
    ChainName["IChainNetwork"] = "iChain Network";
    ChainName["IChainTestnet"] = "iChain Testnet";
    ChainName["JouleverseMainnet"] = "Jouleverse Mainnet";
    ChainName["BittexMainnet"] = "Bittex Mainnet";
    ChainName["EmpireNetwork"] = "Empire Network";
    ChainName["SenjePowersTestnet"] = "SenjePowers Testnet";
    ChainName["SenjePowersMainnet"] = "SenjePowers Mainnet";
    ChainName["XplaTestnet"] = "Xpla Testnet";
    ChainName["XoneMainnet"] = "Xone Mainnet";
    ChainName["Crossbell"] = "Crossbell";
    ChainName["AstarzkEVM"] = "Astar zkEVM";
    ChainName["AlveyChainMainnet"] = "AlveyChain Mainnet";
    ChainName["TangleTestnet"] = "Tangle Testnet";
    ChainName["FirechainzkEVMGhostrider"] = "Firechain zkEVM Ghostrider";
    ChainName["KalyChainMainnet"] = "KalyChain Mainnet";
    ChainName["KalyChainTestnet"] = "KalyChain Testnet";
    ChainName["DRACNetwork"] = "DRAC Network";
    ChainName["DOSTestnet"] = "DOS Testnet";
    ChainName["DYNOMainnet"] = "DYNO Mainnet";
    ChainName["DYNOTestnet"] = "DYNO Testnet";
    ChainName["PayNetworkMainnet"] = "PayNetwork Mainnet";
    ChainName["APEXTestnet"] = "APEX Testnet";
    ChainName["YuanChainMainnet"] = "YuanChain Mainnet";
    ChainName["OzoneChainMainnet"] = "Ozone Chain Mainnet";
    ChainName["PeperiumChainTestnet"] = "Peperium Chain Testnet";
    ChainName["FantomTestnet"] = "Fantom Testnet";
    ChainName["X1Fastnet"] = "X1 Fastnet";
    ChainName["CarboniumTestnetNetwork"] = "Carbonium Testnet Network";
    ChainName["GANTestnet"] = "GAN Testnet";
    ChainName["BobaoperaTestnet"] = "Bobaopera Testnet";
    ChainName["Bahamutocean"] = "Bahamut ocean";
    ChainName["Nahmii3Mainnet"] = "Nahmii 3 Mainnet";
    ChainName["Nahmii3Testnet"] = "Nahmii 3 Testnet";
    ChainName["MusterMainnet"] = "Muster Mainnet";
    ChainName["TobeChainTestnet"] = "Tobe Chain Testnet";
    ChainName["ZerothMainnet"] = "Zeroth Mainnet";
    ChainName["FastexChain(Bahamut)OasisTestnet"] = "Fastex Chain (Bahamut) Oasis Testnet";
    ChainName["BitindiTestnet"] = "Bitindi Testnet";
    ChainName["BitindiMainnet"] = "Bitindi Mainnet";
    ChainName["AIOZNetworkTestnet"] = "AIOZ Network Testnet";
    ChainName["Humans.aiTestnet"] = "Humans.ai Testnet";
    ChainName["TipboxcoinTestnet"] = "Tipboxcoin Testnet";
    ChainName["CrossFiTestnet"] = "CrossFi Testnet";
    ChainName["CrossFiMainnet"] = "CrossFi Mainnet";
    ChainName["SXRollup"] = "SX Rollup";
    ChainName["PHINetworkV1"] = "PHI Network V1";
    ChainName["MerlinMainnet"] = "Merlin Mainnet";
    ChainName["LUKSOTestnet"] = "LUKSO Testnet";
    ChainName["LiskSepoliaTestnet"] = "Lisk Sepolia Testnet";
    ChainName["MerlinErigonTestnet"] = "Merlin Erigon Testnet";
    ChainName["NexiMainnet"] = "Nexi Mainnet";
    ChainName["NexiV2Mainnet"] = "Nexi V2 Mainnet";
    ChainName["LaikaTestnet"] = "Laika Testnet";
    ChainName["EchosChain"] = "Echos Chain";
    ChainName["BobafujiTestnet"] = "Bobafuji Testnet";
    ChainName["Beam"] = "Beam";
    ChainName["MemeCore"] = "MemeCore";
    ChainName["CreditSmartChainMainnet"] = "Credit Smart Chain Mainnet";
    ChainName["TestnetPika"] = "Testnet Pika";
    ChainName["HtmlcoinMainnet"] = "Htmlcoin Mainnet";
    ChainName["OrderlySepoliaTestnet"] = "Orderly Sepolia Testnet";
    ChainName["HydraChain"] = "Hydra Chain";
    ChainName["EmoneyNetworkTestnet"] = "Emoney Network Testnet";
    ChainName["EmoneyNetworkMainnet"] = "Emoney Network Mainnet";
    ChainName["TRUMPCHAIN"] = "TRUMPCHAIN";
    ChainName["VERYMainnet"] = "VERY Mainnet";
    ChainName["MSTChain"] = "MST Chain";
    ChainName["GoldChain"] = "Gold Chain";
    ChainName["AppChainTestnet"] = "AppChain Testnet";
    ChainName["IoTeXNetworkMainnet"] = "IoTeX Network Mainnet";
    ChainName["IoTeXNetworkTestnet"] = "IoTeX Network Testnet";
    ChainName["MEVerseChainTestnet"] = "MEVerse Chain Testnet";
    ChainName["BlackFortExchangeNetworkTestnetDEPRECATED"] = "BlackFort Exchange Network Testnet DEPRECATED";
    ChainName["EvnodeTestnet"] = "Evnode Testnet";
    ChainName["WorldChainSepoliaTestnet"] = "World Chain Sepolia Testnet";
    ChainName["BlackFortExchangeNetworkTestnet"] = "BlackFort Exchange Network Testnet";
    ChainName["GlobelChain"] = "Globel Chain";
    ChainName["OEVNetwork"] = "OEV Network";
    ChainName["VenidiumTestnet"] = "Venidium Testnet";
    ChainName["VenidiumMainnet"] = "Venidium Mainnet";
    ChainName["BlackFortExchangeNetworkDeprecated"] = "BlackFort Exchange Network Deprecated";
    ChainName["Mantle"] = "Mantle";
    ChainName["MantleTestnet"] = "Mantle Testnet";
    ChainName["TreasurenetMainnetAlpha"] = "Treasurenet Mainnet Alpha";
    ChainName["MantleSepoliaTestnet"] = "Mantle Sepolia Testnet";
    ChainName["TreasurenetTestnet"] = "Treasurenet Testnet";
    ChainName["ONIGIRITestSubnet"] = "ONIGIRI Test Subnet";
    ChainName["ONIGIRISubnet"] = "ONIGIRI Subnet";
    ChainName["SkateMainnet"] = "Skate Mainnet";
    ChainName["NollieSkatechainTestnet"] = "Nollie Skatechain Testnet";
    ChainName["PioneZero"] = "Pione Zero";
    ChainName["PioneChainMainnet"] = "Pione Chain Mainnet";
    ChainName["SyndicateTestnet"] = "Syndicate Testnet";
    ChainName["SyndicateFrameChain"] = "Syndicate Frame Chain";
    ChainName["SICTestnet"] = "SIC Testnet";
    ChainName["CoordinapeTestnet"] = "Coordinape Testnet";
    ChainName["CharmverseTestnet"] = "Charmverse Testnet";
    ChainName["SuperloyaltyTestnet"] = "Superloyalty Testnet";
    ChainName["AzraTestnet"] = "Azra Testnet";
    ChainName["Ham"] = "Ham";
    ChainName["CitreaTestnet"] = "Citrea Testnet";
    ChainName["Seismicdevnet"] = "Seismic devnet";
    ChainName["MocaChainTestnet"] = "Moca Chain Testnet";
    ChainName["Bahamut"] = "Bahamut";
    ChainName["SmartLayerNetwork"] = "Smart Layer Network";
    ChainName["TLChainNetworkMainnet"] = "TLChain Network Mainnet";
    ChainName["EraSwapMainnet"] = "EraSwap Mainnet";
    ChainName["HumanodeMainnet"] = "Humanode Mainnet";
    ChainName["FirechainMainnetOld"] = "Firechain Mainnet Old";
    ChainName["UzmiNetworkMainnet"] = "Uzmi Network Mainnet";
    ChainName["OpTrustTestnet"] = "OpTrust Testnet";
    ChainName["ITXTestnet"] = "ITX Testnet";
    ChainName["Superseed"] = "Superseed";
    ChainName["Netsbo"] = "Netsbo";
    ChainName["TritaniumTestnet"] = "Tritanium Testnet";
    ChainName["Settlus"] = "Settlus";
    ChainName["SettlusTestnet"] = "Settlus Testnet";
    ChainName["SettlusSepoliaTestnet"] = "Settlus Sepolia Testnet";
    ChainName["EdeXaMainnet"] = "edeXa Mainnet";
    ChainName["InertiaScan"] = "Inertia Scan";
    ChainName["Egochain"] = "Egochain";
    ChainName["Saga"] = "Saga";
    ChainName["PointPayMainnet"] = "PointPay Mainnet";
    ChainName["VEXEVMTESTNET"] = "VEX EVM TESTNET";
    ChainName["DuckChainMainnet"] = "DuckChain Mainnet";
    ChainName["Nahmii2Mainnet"] = "Nahmii 2 Mainnet";
    ChainName["Nahmii2Testnet"] = "Nahmii 2 Testnet";
    ChainName["ChainVerseMainnet"] = "Chain Verse Mainnet";
    ChainName["OpBNBTestnet"] = "opBNB Testnet";
    ChainName["ArcturusTestneet"] = "Arcturus Testneet";
    ChainName["ArcturusChainTestnet"] = "Arcturus Chain Testnet";
    ChainName["QIEBlockchain"] = "QIE Blockchain";
    ChainName["FilenovaTestnet"] = "Filenova Testnet";
    ChainName["TanssiDemo"] = "Tanssi Demo";
    ChainName["SyscoinTanenbaumTestnet"] = "Syscoin Tanenbaum Testnet";
    ChainName["HikaNetworkTestnet"] = "Hika Network Testnet";
    ChainName["SatoshiChainTestnet"] = "SatoshiChain Testnet";
    ChainName["Ganache"] = "Ganache";
    ChainName["Tangle"] = "Tangle";
    ChainName["OntologyTestnet"] = "Ontology Testnet";
    ChainName["ChangChainFoundationMainnet"] = "Chang Chain Foundation Mainnet";
    ChainName["WegochainRubidiumMainnet"] = "Wegochain Rubidium Mainnet";
    ChainName["BounceBitTestnet"] = "BounceBit Testnet";
    ChainName["BounceBitMainnet"] = "BounceBit Mainnet";
    ChainName["BCHyperChainTestnet"] = "BC Hyper Chain Testnet";
    ChainName["TresTestnet"] = "Tres Testnet";
    ChainName["TresMainnet"] = "Tres Mainnet";
    ChainName["CascadiaTestnet"] = "Cascadia Testnet";
    ChainName["UPTNTestnet"] = "UPTN Testnet";
    ChainName["UPTN"] = "UPTN";
    ChainName["TeaMainnet"] = "Tea Mainnet";
    ChainName["Rails"] = "Rails";
    ChainName["LAOS"] = "LAOS";
    ChainName["NFBChainTestnet"] = "NFB Chain Testnet";
    ChainName["AuraEuphoriaTestnet"] = "Aura Euphoria Testnet";
    ChainName["AuraMainnet"] = "Aura Mainnet";
    ChainName["MegaETHTestnet"] = "MegaETH Testnet";
    ChainName["DigitSoulSmartChain"] = "Digit Soul Smart Chain";
    ChainName["ConnextSepolia"] = "Connext Sepolia";
    ChainName["Peerpay"] = "Peerpay";
    ChainName["FlammaTestnet"] = "Flamma Testnet";
    ChainName["ScolcoinWeiChainTestnet"] = "Scolcoin WeiChain Testnet";
    ChainName["FoxTestnetNetwork"] = "Fox Testnet Network";
    ChainName["PixieChainMainnet"] = "Pixie Chain Mainnet";
    ChainName["LatestChainTestnet"] = "Latest Chain Testnet";
    ChainName["CybriaMainnet"] = "Cybria Mainnet";
    ChainName["CybriaTestnet"] = "Cybria Testnet";
    ChainName["Storchain"] = "Storchain";
    ChainName["EdgeMatrixChain"] = "Edge Matrix Chain";
    ChainName["IRIShub"] = "IRIShub";
    ChainName["OXChain"] = "OX Chain";
    ChainName["PAXBMainnet"] = "PAXB Mainnet";
    ChainName["CompverseMainnet"] = "Compverse Mainnet";
    ChainName["GoldSmartChainMainnet"] = "Gold Smart Chain Mainnet";
    ChainName["RACEMainnet"] = "RACE Mainnet";
    ChainName["RACETestnet"] = "RACE Testnet";
    ChainName["PoolsMainnet"] = "Pools Mainnet";
    ChainName["MTTNetwork"] = "MTT Network";
    ChainName["Nibirucataclysm-1"] = "Nibiru cataclysm-1";
    ChainName["Nibirutestnet-2"] = "Nibiru testnet-2";
    ChainName["XylumeTestNet"] = "Xylume TestNet";
    ChainName["LaikaMainnet"] = "Laika Mainnet";
    ChainName["TombChainMainnet"] = "Tomb Chain Mainnet";
    ChainName["PolySmartChain"] = "PolySmartChain";
    ChainName["ZetaChainMainnet"] = "ZetaChain Mainnet";
    ChainName["ZetaChainTestnet"] = "ZetaChain Testnet";
    ChainName["BSTChain"] = "BST Chain";
    ChainName["Ellatheheart"] = "Ella the heart";
    ChainName["PlanqMainnet"] = "Planq Mainnet";
    ChainName["PlanqAtlasTestnet"] = "Planq Atlas Testnet";
    ChainName["BharatBlockchainNetwork"] = "Bharat Blockchain Network";
    ChainName["Nume"] = "Nume";
    ChainName["0XL3"] = "0XL3";
    ChainName["HelpTheHomeless"] = "Help The Homeless";
    ChainName["BitrockMainnet"] = "Bitrock Mainnet";
    ChainName["UXLINKOneTestnet"] = "UXLINK One Testnet";
    ChainName["ExSatMainnet"] = "exSat Mainnet";
    ChainName["NexeraMainnet"] = "Nexera Mainnet";
    ChainName["Nibirutestnet-1"] = "Nibiru testnet-1";
    ChainName["Nibirudevnet-3"] = "Nibiru devnet-3";
    ChainName["InitVerseMainnet"] = "InitVerse Mainnet";
    ChainName["InitVersegenesistestnet"] = "InitVerse genesis testnet";
    ChainName["ZEUSTestnet"] = "ZEUS Testnet";
    ChainName["XPLAVerse"] = "XPLA Verse";
    ChainName["KLYNTAR"] = "KLYNTAR";
    ChainName["HorizenEONMainnet"] = "Horizen EON Mainnet";
    ChainName["ShyftMainnet"] = "Shyft Mainnet";
    ChainName["Rarimo"] = "Rarimo";
    ChainName["RabaNetworkMainnet"] = "Raba Network Mainnet";
    ChainName["MEVerseChainMainnet"] = "MEVerse Chain Mainnet";
    ChainName["CyberMainnet"] = "Cyber Mainnet";
    ChainName["ADILTestnet"] = "ADIL Testnet";
    ChainName["AdilChainV2Mainnet"] = "Adil Chain V2 Mainnet";
    ChainName["TheRootNetwork-Mainnet"] = "The Root Network - Mainnet";
    ChainName["TheRootNetwork-PorciniTestnet"] = "The Root Network - Porcini Testnet";
    ChainName["Canto"] = "Canto";
    ChainName["CantoTesnet"] = "Canto Tesnet";
    ChainName["PhronTestnet"] = "Phron Testnet";
    ChainName["PandaSeaTestnet"] = "PandaSea Testnet";
    ChainName["BitrockTestnet"] = "Bitrock Testnet";
    ChainName["GDCCMAINNET"] = "GDCC MAINNET";
    ChainName["GDCCTESTNET"] = "GDCC TESTNET";
    ChainName["PandaSeaMainnet"] = "PandaSea Mainnet";
    ChainName["RiseoftheWarbotsTestnet"] = "Rise of the Warbots Testnet";
    ChainName["OreniumMainnetProtocol"] = "Orenium Mainnet Protocol";
    ChainName["DrawCoin"] = "Draw Coin";
    ChainName["OpenEXLONGTestnet"] = "OpenEX LONG Testnet";
    ChainName["MaalChainTestnet"] = "MaalChain Testnet";
    ChainName["MaalChainV2"] = "MaalChain V2";
    ChainName["MaalChainTestnetV2"] = "MaalChain Testnet V2";
    ChainName["PowerloomMainnet"] = "Powerloom Mainnet";
    ChainName["PowerloomMainnetV2"] = "Powerloom Mainnet V2";
    ChainName["HazlorTestnet"] = "Hazlor Testnet";
    ChainName["VexonTestnet"] = "Vexon Testnet";
    ChainName["KintoMainnet"] = "Kinto Mainnet";
    ChainName["ARDENIUMAthena"] = "ARDENIUM Athena";
    ChainName["Arena-z"] = "arena-z";
    ChainName["DotBlox"] = "Dot Blox";
    ChainName["MOMainnet"] = "MO Mainnet";
    ChainName["ExoriumTestnet"] = "Exorium Testnet";
    ChainName["DOSChain"] = "DOS Chain";
    ChainName["Teleport"] = "Teleport";
    ChainName["TeleportTestnet"] = "Teleport Testnet";
    ChainName["Polynomial"] = "Polynomial";
    ChainName["ISunCoinMainnet"] = "iSunCoin Mainnet";
    ChainName["MDGLTestnet"] = "MDGL Testnet";
    ChainName["BOATMainnet"] = "BOAT Mainnet";
    ChainName["KarakSepolia"] = "Karak Sepolia";
    ChainName["ShardeumLiberty1.X"] = "Shardeum Liberty 1.X";
    ChainName["ShardeumLiberty2.X"] = "Shardeum Liberty 2.X";
    ChainName["ShardeumSphinx1.X"] = "Shardeum Sphinx 1.X";
    ChainName["ShardeumTestnet"] = "Shardeum Testnet";
    ChainName["BitcoinChain"] = "Bitcoin Chain";
    ChainName["E-Dollar"] = "E-Dollar";
    ChainName["StreamuXBlockchain"] = "StreamuX Blockchain";
    ChainName["BharatBlockchainNetworkMainnet"] = "Bharat Blockchain Network Mainnet";
    ChainName["ZenChain"] = "ZenChain";
    ChainName["Shardeum"] = "Shardeum";
    ChainName["QitmeerNetworkTestnet"] = "Qitmeer Network Testnet";
    ChainName["QitmeerNetworkMixnet"] = "Qitmeer Network Mixnet";
    ChainName["QitmeerNetworkPrivnet"] = "Qitmeer Network Privnet";
    ChainName["Amana"] = "Amana";
    ChainName["Flana"] = "Flana";
    ChainName["Mizana"] = "Mizana";
    ChainName["TestnetBeOneChain"] = "Testnet BeOne Chain";
    ChainName["TorusMainnet"] = "Torus Mainnet";
    ChainName["TorusTestnet"] = "Torus Testnet";
    ChainName["KaiaMainnet"] = "Kaia Mainnet";
    ChainName["SpaceSubnet"] = "Space Subnet";
    ChainName["BlocktonBlockchain"] = "Blockton Blockchain";
    ChainName["KorthoTest"] = "KorthoTest";
    ChainName["Lorenzo"] = "Lorenzo";
    ChainName["B3"] = "B3";
    ChainName["XProtocol"] = "XProtocol";
    ChainName["DraconesFinancialServices"] = "Dracones Financial Services";
    ChainName["ZenChainTestnet"] = "ZenChain Testnet";
    ChainName["THATMainnet"] = "THAT Mainnet";
    ChainName["Base"] = "Base";
    ChainName["ChakraTestnet"] = "Chakra Testnet";
    ChainName["NewRealityBlockchain"] = "New Reality Blockchain";
    ChainName["TokiNetwork"] = "Toki Network";
    ChainName["TokiTestnet"] = "Toki Testnet";
    ChainName["HelaOfficialRuntimeMainnet"] = "Hela Official Runtime Mainnet";
    ChainName["TOOLGlobalMainnet"] = "TOOL Global Mainnet";
    ChainName["TOOLGlobalTestnet"] = "TOOL Global Testnet";
    ChainName["StoragechainMainnet"] = "Storagechain Mainnet";
    ChainName["StoragechainTestnet"] = "Storagechain Testnet";
    ChainName["BullionsSmartChain"] = "Bullions Smart Chain";
    ChainName["AlphNetwork"] = "Alph Network";
    ChainName["TMYChain"] = "TMY Chain";
    ChainName["OktoTestnet"] = "Okto Testnet";
    ChainName["Haven1"] = "Haven1";
    ChainName["IOTAEVM"] = "IOTA EVM";
    ChainName["HydraChainTestnet"] = "Hydra Chain Testnet";
    ChainName["MAROBlockchainMainnet"] = "MARO Blockchain Mainnet";
    ChainName["SuperLumio"] = "SuperLumio";
    ChainName["Lif3Chain"] = "Lif3 Chain";
    ChainName["Unique"] = "Unique";
    ChainName["QuartzbyUnique"] = "Quartz by Unique";
    ChainName["OpaltestnetbyUnique"] = "Opal testnet by Unique";
    ChainName["SapphirebyUnique"] = "Sapphire by Unique";
    ChainName["AveniumTestnet"] = "Avenium Testnet";
    ChainName["XANAChain"] = "XANAChain";
    ChainName["VyvoSmartChain"] = "Vyvo Smart Chain";
    ChainName["OreniumTestnetProtocol"] = "Orenium Testnet Protocol";
    ChainName["MammothMainnet"] = "Mammoth Mainnet";
    ChainName["JIBCHAINL1"] = "JIBCHAIN L1";
    ChainName["Algen"] = "Algen";
    ChainName["AlgenTestnet"] = "Algen Testnet";
    ChainName["AlgenLayer2"] = "Algen Layer2";
    ChainName["AlgenLayer2Testnet"] = "Algen Layer2 Testnet";
    ChainName["GiantMammothMainnet"] = "Giant Mammoth Mainnet";
    ChainName["Bloxberg"] = "bloxberg";
    ChainName["EvmosTestnet"] = "Evmos Testnet";
    ChainName["Evmos"] = "Evmos";
    ChainName["QubeticsAlphaTestnet"] = "Qubetics Alpha Testnet";
    ChainName["ShidoTestnetBlock"] = "Shido Testnet Block";
    ChainName["ShidoNetwork"] = "Shido Network";
    ChainName["BerylBitMainnet"] = "BerylBit Mainnet";
    ChainName["NexaTestnetBlock"] = "Nexa Testnet Block";
    ChainName["NexaMainnetBlock"] = "Nexa Mainnet Block";
    ChainName["QubeticsTestnet"] = "Qubetics Testnet";
    ChainName["ApexFusion-NexusMainnet"] = "Apex Fusion - Nexus Mainnet";
    ChainName["ApexFusion-Nexustestnet"] = "Apex Fusion - Nexus testnet";
    ChainName["IncoGentryTestnet"] = "Inco Gentry Testnet";
    ChainName["KPASmartChainTestnet"] = "KPA Smart Chain Testnet";
    ChainName["GenesisCoin"] = "Genesis Coin";
    ChainName["DestraDubaiTestnet"] = "Destra Dubai Testnet";
    ChainName["RiniaTestnetOld"] = "Rinia Testnet Old";
    ChainName["CodefinMainnet"] = "Codefin Mainnet";
    ChainName["Galactica-Reticulum"] = "Galactica-Reticulum";
    ChainName["DogcoinTestnet"] = "Dogcoin Testnet";
    ChainName["ZChain"] = "Z Chain";
    ChainName["OasysTestnet"] = "Oasys Testnet";
    ChainName["DelaSepoliaTestnet"] = "Dela Sepolia Testnet";
    ChainName["EvokeMainnet"] = "Evoke Mainnet";
    ChainName["LoadAlphanet"] = "Load Alphanet";
    ChainName["RangersProtocolTestnetRobin"] = "Rangers Protocol Testnet Robin";
    ChainName["QEasyWeb3Testnet"] = "QEasyWeb3 Testnet";
    ChainName["NeonlinkTestnet"] = "Neonlink Testnet";
    ChainName["RebusMainnet"] = "Rebus Mainnet";
    ChainName["OortMainnetDev"] = "Oort MainnetDev";
    ChainName["BobaBNBTestnet"] = "Boba BNB Testnet";
    ChainName["MainnetZTestnet"] = "MainnetZ Testnet";
    ChainName["PepeNetworkMainnet"] = "PepeNetwork Mainnet";
    ChainName["TabiTestnetv2"] = "Tabi Testnetv2";
    ChainName["TabiTestnet"] = "Tabi Testnet";
    ChainName["CarbonEVM"] = "Carbon EVM";
    ChainName["CarbonEVMTestnet"] = "Carbon EVM Testnet";
    ChainName["OptimusZ7Mainnet"] = "OptimusZ7 Mainnet";
    ChainName["IMPERIUMTESTNET"] = "IMPERIUM TESTNET";
    ChainName["IMPERIUMMAINNET"] = "IMPERIUM MAINNET";
    ChainName["BinaryChainTestnet"] = "BinaryChain Testnet";
    ChainName["DogelayerMainnet"] = "Dogelayer Mainnet";
    ChainName["Pointledger"] = "pointledger";
    ChainName["Arena-z-testnet"] = "arena-z-testnet";
    ChainName["LarissaChain"] = "Larissa Chain";
    ChainName["ZytronLineaMainnet"] = "Zytron Linea Mainnet";
    ChainName["EspentoMainnet"] = "Espento Mainnet";
    ChainName["UXERTESTNETNETWORK"] = "UXER TESTNET NETWORK";
    ChainName["MindSmartChainTestnet"] = "Mind Smart Chain Testnet";
    ChainName["ComboMainnet"] = "Combo Mainnet";
    ChainName["VolleyMainnet"] = "Volley Mainnet";
    ChainName["MFEVCHAINMAINNET"] = "MFEV CHAIN MAINNET";
    ChainName["AgungNetwork"] = "Agung Network";
    ChainName["MindSmartChainMainnet"] = "Mind Smart Chain Mainnet";
    ChainName["AltLayerTestnet"] = "AltLayer Testnet";
    ChainName["ZtcMainnet"] = "Ztc Mainnet";
    ChainName["MyOwnTestnet"] = "myOwn Testnet";
    ChainName["SmartBitcoinCash"] = "Smart Bitcoin Cash";
    ChainName["SmartBitcoinCashTestnet"] = "Smart Bitcoin Cash Testnet";
    ChainName["WardenTestnet"] = "Warden Testnet";
    ChainName["DeepSafeBetaMainnet"] = "DeepSafe Beta Mainnet";
    ChainName["GonChain"] = "Gon Chain";
    ChainName["AEONChain"] = "AEON Chain";
    ChainName["ChainOperaTestnet"] = "Chain Opera Testnet";
    ChainName["JapanOpenChainTestnet"] = "Japan Open Chain Testnet";
    ChainName["VolcanoChainMainnet"] = "Volcano Chain Mainnet";
    ChainName["SJATSH"] = "SJATSH";
    ChainName["MetaNovaVerse"] = "MetaNova Verse";
    ChainName["BlockchainGenesisMainnet"] = "Blockchain Genesis Mainnet";
    ChainName["MonadTestnet"] = "Monad Testnet";
    ChainName["GnosisChiadoTestnet"] = "Gnosis Chiado Testnet";
    ChainName["MaxxChainMainnet"] = "MaxxChain Mainnet";
    ChainName["TeaSepoliaTestnet"] = "Tea Sepolia Testnet";
    ChainName["GLScan"] = "GLScan";
    ChainName["ArtheraMainnet"] = "Arthera Mainnet";
    ChainName["ArtheraTestnet"] = "Arthera Testnet";
    ChainName["0XTade"] = "0XTade";
    ChainName["TAOEVMMainnet"] = "TAO EVM Mainnet";
    ChainName["TAOEVMTestnet"] = "TAO EVM Testnet";
    ChainName["WorldLandTestnet"] = "WorldLand Testnet";
    ChainName["NumbersMainnet"] = "Numbers Mainnet";
    ChainName["NumbersTestnet"] = "Numbers Testnet";
    ChainName["CryptoCoinPay"] = "CryptoCoinPay";
    ChainName["Lamina1"] = "Lamina1";
    ChainName["Lamina1Identity"] = "Lamina1 Identity";
    ChainName["GameSwiftChainTestnet"] = "GameSwift Chain Testnet";
    ChainName["FuseFlashTestnet"] = "Fuse Flash Testnet";
    ChainName["QuadransBlockchain"] = "Quadrans Blockchain";
    ChainName["QuadransBlockchainTestnet"] = "Quadrans Blockchain Testnet";
    ChainName["KBChain"] = "KB Chain";
    ChainName["ShapeSepoliaTestnet"] = "Shape Sepolia Testnet";
    ChainName["BoolNetworkBetaMainnet"] = "Bool Network Beta Mainnet";
    ChainName["Astra"] = "Astra";
    ChainName["WAGMI"] = "WAGMI";
    ChainName["AstraTestnet"] = "Astra Testnet";
    ChainName["HashBitMainnet"] = "HashBit Mainnet";
    ChainName["AbstractSepoliaTestnet"] = "Abstract Sepolia Testnet";
    ChainName["ShineChain"] = "Shine Chain";
    ChainName["JiritsuTestnetSubnet"] = "Jiritsu Testnet Subnet";
    ChainName["HaqqNetwork"] = "Haqq Network";
    ChainName["StateMeshTestnet"] = "StateMesh Testnet";
    ChainName["ShyftTestnet"] = "Shyft Testnet";
    ChainName["EGoldChain"] = "eGold Chain";
    ChainName["GEBMainnet"] = "GEB Mainnet";
    ChainName["BEVMTestnet"] = "BEVM Testnet";
    ChainName["GEBSignet"] = "GEB Signet";
    ChainName["SatsChain"] = "SatsChain";
    ChainName["SardisTestnet"] = "Sardis Testnet";
    ChainName["ArtelaMainnet"] = "Artela Mainnet";
    ChainName["ArtelaTestnet"] = "Artela Testnet";
    ChainName["SantimentIntelligenceNetworkDEPRECATED"] = "Santiment Intelligence Network DEPRECATED";
    ChainName["PolygonSupernetArianee"] = "Polygon Supernet Arianee";
    ChainName["FuseTestnet"] = "Fuse Testnet";
    ChainName["SatoshiChainMainnet"] = "SatoshiChain Mainnet";
    ChainName["Aternos"] = "Aternos";
    ChainName["SingularityZEROTestnet"] = "Singularity ZERO Testnet";
    ChainName["SingularityZEROMainnet"] = "Singularity ZERO Mainnet";
    ChainName["BRCChainMainnet"] = "BRC Chain Mainnet";
    ChainName["FibonacciMainnet"] = "Fibonacci Mainnet";
    ChainName["BLGTestnet"] = "BLG Testnet";
    ChainName["Huddle01dRTCChain"] = "Huddle01 dRTC Chain";
    ChainName["L3XProtocol"] = "L3X Protocol";
    ChainName["L3XProtocolTestnet"] = "L3X Protocol Testnet";
    ChainName["StepTestnet"] = "Step Testnet";
    ChainName["GDPRMainnet"] = "GDPR Mainnet";
    ChainName["RSS3VSLMainnet"] = "RSS3 VSL Mainnet";
    ChainName["RikezaNetworkTestnet"] = "Rikeza Network Testnet";
    ChainName["PlaydappTestnet"] = "Playdapp Testnet";
    ChainName["QuantumChainTestnet"] = "Quantum Chain Testnet";
    ChainName["PlayFairTestnetSubnet"] = "PlayFair Testnet Subnet";
    ChainName["SPS"] = "SPS";
    ChainName["CreditSmartChain"] = "Credit Smart Chain";
    ChainName["BeamTestnet"] = "Beam Testnet";
    ChainName["CannonTestnet"] = "Cannon Testnet";
    ChainName["ImmutablezkEVM"] = "Immutable zkEVM";
    ChainName["PhoenixMainnet"] = "Phoenix Mainnet";
    ChainName["Masa"] = "Masa";
    ChainName["ImmutablezkEVMTestnet"] = "Immutable zkEVM Testnet";
    ChainName["GravityAlphaTestnetSepolia"] = "Gravity Alpha Testnet Sepolia";
    ChainName["KronobitMainnet"] = "Kronobit Mainnet";
    ChainName["Game7Testnet"] = "Game7 Testnet";
    ChainName["Susono"] = "Susono";
    ChainName["SPSTestnet"] = "SPS Testnet";
    ChainName["ZerothTestnet"] = "Zeroth Testnet";
    ChainName["BitharvestChainMainnet"] = "Bitharvest Chain Mainnet";
    ChainName["Bitlazer"] = "Bitlazer";
    ChainName["EVOLVETestnet"] = "EVOLVE Testnet";
    ChainName["VitruveoTestnet"] = "Vitruveo Testnet";
    ChainName["VanaMokshaTestnet"] = "Vana Moksha Testnet";
    ChainName["VanaSatoriTestnet"] = "Vana Satori Testnet";
    ChainName["HumanodeTestnet5Israfel"] = "Humanode Testnet 5 Israfel";
    ChainName["ImmutablezkEVMDevnet"] = "Immutable zkEVM Devnet";
    ChainName["PoodlTestnet"] = "Poodl Testnet";
    ChainName["PoodlMainnet"] = "Poodl Mainnet";
    ChainName["KYMTCMainnet"] = "KYMTC Mainnet";
    ChainName["LoopNetworkMainnet"] = "LoopNetwork Mainnet";
    ChainName["TrustEVMTestnet"] = "Trust EVM Testnet";
    ChainName["EOSEVMNetworkTestnet"] = "EOS EVM Network Testnet";
    ChainName["MetaDotMainnet"] = "MetaDot Mainnet";
    ChainName["MetaDotTestnet"] = "MetaDot Testnet";
    ChainName["DeFiVerseMainnet"] = "DeFiVerse Mainnet";
    ChainName["CypheriumMainnet"] = "Cypherium Mainnet";
    ChainName["PLYRPHI"] = "PLYR PHI";
    ChainName["EventumTestnet"] = "Eventum Testnet";
    ChainName["IncentivDevnet"] = "Incentiv Devnet";
    ChainName["PivotalSepolia"] = "Pivotal Sepolia";
    ChainName["GenesysMainnet"] = "Genesys Mainnet";
    ChainName["0G-Newton-Testnet"] = "0G-Newton-Testnet";
    ChainName["IRIShubTestnet"] = "IRIShub Testnet";
    ChainName["AirDAOMainnet"] = "AirDAO Mainnet";
    ChainName["IVARChainTestnet"] = "IVAR Chain Testnet";
    ChainName["Holesky"] = "Holesky";
    ChainName["RedstoneHoleskyTestnet"] = "Redstone Holesky Testnet";
    ChainName["GarnetHolesky"] = "Garnet Holesky";
    ChainName["OnchainPoints"] = "Onchain Points";
    ChainName["DeFiVerseTestnet"] = "DeFiVerse Testnet";
    ChainName["G8ChainMainnet"] = "G8Chain Mainnet";
    ChainName["EclipseSubnet"] = "Eclipse Subnet";
    ChainName["PaletteChainTestnet"] = "Palette Chain Testnet";
    ChainName["KONETMainnet"] = "KONET Mainnet";
    ChainName["EsportsChain"] = "Esports Chain";
    ChainName["EOSEVMNetwork"] = "EOS EVM Network";
    ChainName["FrontierofDreamsTestnet"] = "Frontier of Dreams Testnet";
    ChainName["SmartTradeNetworks"] = "Smart Trade Networks";
    ChainName["ProofOfMemes"] = "Proof Of Memes";
    ChainName["G8ChainTestnet"] = "G8Chain Testnet";
    ChainName["Unreal-old"] = "unreal-old";
    ChainName["Unreal"] = "unreal";
    ChainName["MXCzkEVMMoonchain"] = "MXC zkEVM Moonchain";
    ChainName["EXPchainTestnet"] = "EXPchain Testnet";
    ChainName["UltraEVMNetworkTestnet"] = "Ultra EVM Network Testnet";
    ChainName["Titan(TKX)"] = "Titan (TKX)";
    ChainName["Titan(TKX)Testnet"] = "Titan (TKX) Testnet";
    ChainName["HOMEVerseMainnet"] = "HOME Verse Mainnet";
    ChainName["BlockXAtlantisTestnet"] = "BlockX Atlantis Testnet";
    ChainName["LocaChainMainnet"] = "LocaChain Mainnet";
    ChainName["BlockXMainnet"] = "BlockX Mainnet";
    ChainName["DecentraconnectSocial"] = "Decentraconnect Social";
    ChainName["SECTestnet"] = "SEC Testnet";
    ChainName["SECMainnet"] = "SEC Mainnet";
    ChainName["MagnetNetwork"] = "Magnet Network";
    ChainName["ZytronLineaTestnet"] = "Zytron Linea Testnet";
    ChainName["LBRYMainnet"] = "LBRY Mainnet";
    ChainName["AstraSepolia"] = "Astra Sepolia";
    ChainName["BTCIXNetwork"] = "BTCIX Network";
    ChainName["UltraEVMNetwork"] = "Ultra EVM Network";
    ChainName["CamelarkMainnet"] = "Camelark Mainnet";
    ChainName["NizaChainMainnet"] = "Niza Chain Mainnet";
    ChainName["NizaChainTestnet"] = "Niza Chain Testnet";
    ChainName["MonadDevnet"] = "Monad Devnet";
    ChainName["XUSDONEStableChainMainnet"] = "XUSD ONE StableChain Mainnet";
    ChainName["CallistoTestnet"] = "Callisto Testnet";
    ChainName["P12Chain"] = "P12 Chain";
    ChainName["Jono11Subnet"] = "Jono11 Subnet";
    ChainName["FluentDeveloperPreview"] = "Fluent Developer Preview";
    ChainName["ActionMainnet"] = "Action Mainnet";
    ChainName["C4EI"] = "C4EI";
    ChainName["RivestTestnet"] = "Rivest Testnet";
    ChainName["AllAboutHealthy"] = "All About Healthy";
    ChainName["1MoneyNetworkMainnet"] = "1Money Network Mainnet";
    ChainName["DCpayMainnet"] = "DCpay Mainnet";
    ChainName["DCpayTestnet"] = "DCpay Testnet";
    ChainName["CENNZnetAzalea"] = "CENNZnet Azalea";
    ChainName["Lestnet"] = "Lestnet";
    ChainName["OmChainMainnet"] = "omChain Mainnet";
    ChainName["BSLMainnet"] = "BSL Mainnet";
    ChainName["Taycan"] = "Taycan";
    ChainName["AirDAOTestnet"] = "AirDAO Testnet";
    ChainName["NautilusMainnet"] = "Nautilus Mainnet";
    ChainName["GoldXChainTestnet"] = "GoldXChain Testnet";
    ChainName["MAPProtocol"] = "MAP Protocol";
    ChainName["AntofyTestnet"] = "Antofy Testnet";
    ChainName["PremiumBlock"] = "PremiumBlock";
    ChainName["OpsideTestnet"] = "Opside Testnet";
    ChainName["OasisSapphire"] = "Oasis Sapphire";
    ChainName["OasisSapphireTestnet"] = "Oasis Sapphire Testnet";
    ChainName["DreyerXMainnet"] = "DreyerX Mainnet";
    ChainName["DreyerXTestnet"] = "DreyerX Testnet";
    ChainName["BlastTestnet"] = "Blast Testnet";
    ChainName["KYMTCTestnet"] = "KYMTC Testnet";
    ChainName["Amauti"] = "Amauti";
    ChainName["Nexurachain"] = "Nexurachain";
    ChainName["Webchain"] = "Webchain";
    ChainName["MintMe.comCoin"] = "MintMe.com Coin";
    ChainName["Recall"] = "Recall";
    ChainName["LiquidLayerMainnet"] = "LiquidLayer Mainnet";
    ChainName["EverclearMainnet"] = "Everclear Mainnet";
    ChainName["AlveyChainTestnet"] = "AlveyChain Testnet";
    ChainName["HammerChainMainnet"] = "Hammer Chain Mainnet";
    ChainName["KUBTestnet"] = "KUB Testnet";
    ChainName["FerrumTestnet"] = "Ferrum Testnet";
    ChainName["FerrumQuantumPortalNetwork"] = "Ferrum Quantum Portal Network";
    ChainName["DucatusXTestnet"] = "DucatusX Testnet";
    ChainName["DucatusX"] = "DucatusX";
    ChainName["HertzNetworkMainnet"] = "Hertz Network Mainnet";
    ChainName["OasisChainMainnet"] = "OasisChain Mainnet";
    ChainName["ABCoreTestnet"] = "AB Core Testnet";
    ChainName["NewtonFinanceTestnet"] = "Newton Finance Testnet";
    ChainName["XferChainTestnet"] = "XferChain Testnet";
    ChainName["KLAOSNova"] = "KLAOS Nova";
    ChainName["NanonSepolia"] = "Nanon Sepolia";
    ChainName["ZerooneMainnetSubnet"] = "zeroone Mainnet Subnet";
    ChainName["XferChainMainnet"] = "XferChain Mainnet";
    ChainName["VizingTestnet"] = "Vizing Testnet";
    ChainName["VizingMainnet"] = "Vizing Mainnet";
    ChainName["OptimismBedrock(GoerliAlphaTestnet)"] = "Optimism Bedrock (Goerli Alpha Testnet)";
    ChainName["BobaSepolia"] = "Boba Sepolia";
    ChainName["HYCHAINTestnet"] = "HYCHAIN Testnet";
    ChainName["NexaMetaNet"] = "Nexa MetaNet";
    ChainName["NexaMetaTest"] = "Nexa MetaTest";
    ChainName["KaiChainTestnet"] = "KaiChain Testnet";
    ChainName["MCHVerseMainnet"] = "MCH Verse Mainnet";
    ChainName["QChainMainnet"] = "qChain Mainnet";
    ChainName["Piecetestnet"] = "Piece testnet";
    ChainName["MiYouMainnet"] = "MiYou Mainnet";
    ChainName["CeriumTestnet"] = "Cerium Testnet";
    ChainName["MovementEVMLegacy"] = "Movement EVM Legacy";
    ChainName["MovementEVMDevnet"] = "Movement EVM Devnet";
    ChainName["MovementEVMTestnet"] = "Movement EVM Testnet";
    ChainName["EthersocialNetwork"] = "Ethersocial Network";
    ChainName["CloudTxMainnet"] = "CloudTx Mainnet";
    ChainName["CloudTxTestnet"] = "CloudTx Testnet";
    ChainName["GoChainTestnet"] = "GoChain Testnet";
    ChainName["EvokeTestnet"] = "Evoke Testnet";
    ChainName["WirexPayMainnet"] = "Wirex Pay Mainnet";
    ChainName["MezoTestnet"] = "Mezo Testnet";
    ChainName["Mezo"] = "Mezo";
    ChainName["XchainMainnet(Deprecated)"] = "Xchain Mainnet (Deprecated)";
    ChainName["XchainTestnet(Deprecated)"] = "Xchain Testnet (Deprecated)";
    ChainName["W3GamezHoleskyTestnet"] = "W3Gamez Holesky Testnet";
    ChainName["BasedAI"] = "BasedAI";
    ChainName["SantimentIntelligenceNetwork"] = "Santiment Intelligence Network";
    ChainName["BitgertMainnet"] = "Bitgert Mainnet";
    ChainName["FusionMainnet"] = "Fusion Mainnet";
    ChainName["ZilliqaEVM"] = "Zilliqa EVM";
    ChainName["Zilliqa2EVMproto-mainnet"] = "Zilliqa 2 EVM proto-mainnet";
    ChainName["ZilliqaEVMIsolatedServer"] = "Zilliqa EVM Isolated Server";
    ChainName["EntangleMainnet"] = "Entangle Mainnet";
    ChainName["ZilliqaEVMTestnet"] = "Zilliqa EVM Testnet";
    ChainName["Zilliqa2EVMproto-testnet"] = "Zilliqa 2 EVM proto-testnet";
    ChainName["Curtis"] = "Curtis";
    ChainName["EntangleTestnet"] = "Entangle Testnet";
    ChainName["ApeChain"] = "ApeChain";
    ChainName["CloudverseSubnet"] = "Cloudverse Subnet";
    ChainName["AvesMainnet"] = "Aves Mainnet";
    ChainName["ZilliqaEVMDevnet"] = "Zilliqa EVM Devnet";
    ChainName["SlingShot"] = "SlingShot";
    ChainName["Zilliqa2EVMdevnet"] = "Zilliqa 2 EVM devnet";
    ChainName["R5NetworkTestnet"] = "R5 Network Testnet";
    ChainName["Funki"] = "Funki";
    ChainName["PencilsProtocolSepoliaTestnet"] = "Pencils Protocol Sepolia Testnet";
    ChainName["Mode"] = "Mode";
    ChainName["ZEUSMainnet"] = "ZEUS Mainnet";
    ChainName["J2OTaro"] = "J2O Taro";
    ChainName["QMainnet"] = "Q Mainnet";
    ChainName["QTestnet"] = "Q Testnet";
    ChainName["LensTestnet"] = "Lens Testnet";
    ChainName["ConnectorManager"] = "ConnectorManager";
    ChainName["ConnectorManagerRobin"] = "ConnectorManager Robin";
    ChainName["PRMMainnet"] = "PRM Mainnet";
    ChainName["EnergiMainnet"] = "Energi Mainnet";
    ChainName["OHOMainnet"] = "OHO Mainnet";
    ChainName["DIVChain"] = "DIV Chain";
    ChainName["AlephZeroEVM"] = "Aleph Zero EVM";
    ChainName["Opulent-XBETA"] = "Opulent-X BETA";
    ChainName["EDUChain"] = "EDU Chain";
    ChainName["HeliosChainTestnet"] = "Helios Chain Testnet";
    ChainName["PMONChain"] = "PMON Chain";
    ChainName["Donatuz"] = "Donatuz";
    ChainName["Pegglecoin"] = "pegglecoin";
    ChainName["WMCTestnet"] = "WMC Testnet";
    ChainName["AgentLayerTestnet"] = "AgentLayer Testnet";
    ChainName["HeuristTestnet"] = "Heurist Testnet";
    ChainName["ArbitrumOne"] = "Arbitrum One";
    ChainName["ArbitrumNova"] = "Arbitrum Nova";
    ChainName["CeloMainnet"] = "Celo Mainnet";
    ChainName["OasisEmeraldTestnet"] = "Oasis Emerald Testnet";
    ChainName["OasisEmerald"] = "Oasis Emerald";
    ChainName["GoldXChainMainnet"] = "GoldXChain Mainnet";
    ChainName["AssetChainMainnet"] = "Asset Chain Mainnet";
    ChainName["AssetChainTestnet"] = "Asset Chain Testnet";
    ChainName["ZKFairMainnet"] = "ZKFair Mainnet";
    ChainName["EtherlinkMainnet"] = "Etherlink Mainnet";
    ChainName["GesotenVerseTestnet"] = "Gesoten Verse Testnet";
    ChainName["KintoTestnet"] = "Kinto Testnet";
    ChainName["Athereum"] = "Athereum";
    ChainName["Hemi"] = "Hemi";
    ChainName["AvalancheFujiTestnet"] = "Avalanche Fuji Testnet";
    ChainName["AvalancheC-Chain"] = "Avalanche C-Chain";
    ChainName["BobaAvax"] = "Boba Avax";
    ChainName["GUNZ"] = "GUNZ";
    ChainName["Formicarium"] = "Formicarium";
    ChainName["ZKFairTestnet"] = "ZKFair Testnet";
    ChainName["Frenchain"] = "Frenchain";
    ChainName["QuantumNetwork"] = "Quantum Network";
    ChainName["CeloAlfajoresTestnet"] = "Celo Alfajores Testnet";
    ChainName["AutobahnNetwork"] = "Autobahn Network";
    ChainName["JuneoJUNE-Chain"] = "Juneo JUNE-Chain";
    ChainName["JuneoDAI1-Chain"] = "Juneo DAI1-Chain";
    ChainName["JuneoUSDT1-Chain"] = "Juneo USDT1-Chain";
    ChainName["JuneoUSD1-Chain"] = "Juneo USD1-Chain";
    ChainName["JuneomBTC1-Chain"] = "Juneo mBTC1-Chain";
    ChainName["JuneoGLD1-Chain"] = "Juneo GLD1-Chain";
    ChainName["JuneoLTC1-Chain"] = "Juneo LTC1-Chain";
    ChainName["JuneoDOGE1-Chain"] = "Juneo DOGE1-Chain";
    ChainName["JuneoEUR1-Chain"] = "Juneo EUR1-Chain";
    ChainName["JuneoSGD1-Chain"] = "Juneo SGD1-Chain";
    ChainName["JuneoBCH1-Chain"] = "Juneo BCH1-Chain";
    ChainName["JuneoLINK1-Chain"] = "Juneo LINK1-Chain";
    ChainName["SwampsL2"] = "Swamps L2";
    ChainName["DeelanceMainnet"] = "Deelance Mainnet";
    ChainName["Blessnet"] = "Blessnet";
    ChainName["FusionTestnet"] = "Fusion Testnet";
    ChainName["NeoXMainnet"] = "Neo X Mainnet";
    ChainName["ReDeFiLayer1"] = "ReDeFi Layer 1";
    ChainName["REINetwork"] = "REI Network";
    ChainName["SpaceSubnetTestnet"] = "Space Subnet Testnet";
    ChainName["ZircuitGarfieldTestnet"] = "Zircuit Garfield Testnet";
    ChainName["ZircuitTestnet"] = "Zircuit Testnet";
    ChainName["ZircuitMainnet"] = "Zircuit Mainnet";
    ChainName["WireshapeFloripaTestnet"] = "Wireshape Floripa Testnet";
    ChainName["BifrostTestnet"] = "Bifrost Testnet";
    ChainName["GUNZTestnet"] = "GUNZ Testnet";
    ChainName["EnergiTestnet"] = "Energi Testnet";
    ChainName["Citronus"] = "Citronus";
    ChainName["LiveplexOracleEVM"] = "Liveplex OracleEVM";
    ChainName["YooldoVerseMainnet"] = "Yooldo Verse Mainnet";
    ChainName["YooldoVerseTestnet"] = "Yooldo Verse Testnet";
    ChainName["GTONTestnet"] = "GTON Testnet";
    ChainName["Sophon"] = "Sophon";
    ChainName["SomniaTestnet"] = "Somnia Testnet";
    ChainName["ReddioTestnet"] = "Reddio Testnet";
    ChainName["STBTestnet"] = "STB Testnet";
    ChainName["ErbieMainnet"] = "Erbie Mainnet";
    ChainName["LumozTestnetAlpha"] = "Lumoz Testnet Alpha";
    ChainName["SardisMainnet"] = "Sardis Mainnet";
    ChainName["ElectroneumMainnet"] = "Electroneum Mainnet";
    ChainName["CytonicSettlementLayerTestnet"] = "Cytonic Settlement Layer Testnet";
    ChainName["CytonicEthereumTestnet"] = "Cytonic Ethereum Testnet";
    ChainName["DOID"] = "DOID";
    ChainName["SuperseedSepoliaTestnet"] = "Superseed Sepolia Testnet";
    ChainName["BirdLayer"] = "BirdLayer";
    ChainName["DODOchaintestnet"] = "DODOchain testnet";
    ChainName["DFKChain"] = "DFK Chain";
    ChainName["GraphiteTestnet"] = "Graphite Testnet";
    ChainName["OverProtocolMainnet"] = "OverProtocol Mainnet";
    ChainName["HaqqChainTestnet"] = "Haqq Chain Testnet";
    ChainName["ToronetTestnet"] = "Toronet Testnet";
    ChainName["Titan"] = "Titan";
    ChainName["TitanSepolia"] = "Titan Sepolia";
    ChainName["Superposition"] = "Superposition";
    ChainName["PhotonAuroraTestnet"] = "Photon Aurora Testnet";
    ChainName["REIChainMainnet"] = "REI Chain Mainnet";
    ChainName["REIChainTestnet"] = "REI Chain Testnet";
    ChainName["FlammaMainnet"] = "Flamma Mainnet";
    ChainName["LambdaChainMainnet"] = "Lambda Chain Mainnet";
    ChainName["BobaBNBMainnet"] = "Boba BNB Mainnet";
    ChainName["TestnetZerooneSubnet"] = "Testnet Zeroone Subnet";
    ChainName["VELOLabsMainnet"] = "VELO Labs Mainnet";
    ChainName["DOIDTestnet"] = "DOID Testnet";
    ChainName["RolluxTestnet"] = "Rollux Testnet";
    ChainName["SonicBlazeTestnet"] = "Sonic Blaze Testnet";
    ChainName["Ink"] = "Ink";
    ChainName["COINSECNetwork"] = "COINSEC Network";
    ChainName["SepoliaPGN(PublicGoodsNetwork)"] = "Sepolia PGN (Public Goods Network)";
    ChainName["LumozQuidditchTestnet"] = "Lumoz Quidditch Testnet";
    ChainName["LineaGoerli"] = "Linea Goerli";
    ChainName["LineaSepolia"] = "Linea Sepolia";
    ChainName["Linea"] = "Linea";
    ChainName["MetisSepoliaTestnet"] = "Metis Sepolia Testnet";
    ChainName["GenesysCodeMainnet"] = "Genesys Code Mainnet";
    ChainName["ThinkiumTestnetChain0"] = "Thinkium Testnet Chain 0";
    ChainName["ThinkiumTestnetChain1"] = "Thinkium Testnet Chain 1";
    ChainName["ThinkiumTestnetChain2"] = "Thinkium Testnet Chain 2";
    ChainName["ThinkiumTestnetChain103"] = "Thinkium Testnet Chain 103";
    ChainName["BOB"] = "BOB";
    ChainName["PerennialSepolia"] = "Perennial Sepolia";
    ChainName["OrangeChainMainnet"] = "Orange Chain Mainnet";
    ChainName["Treasure"] = "Treasure";
    ChainName["KaiChain"] = "KaiChain";
    ChainName["AxelChainDev-Net"] = "AxelChain Dev-Net";
    ChainName["EticaMainnet"] = "Etica Mainnet";
    ChainName["DoKENSuperChainMainnet"] = "DoKEN Super Chain Mainnet";
    ChainName["OPTOPIATestnet"] = "OPTOPIA Testnet";
    ChainName["OptopiaMainnet"] = "Optopia Mainnet";
    ChainName["TikTrixTestnet"] = "TikTrix Testnet";
    ChainName["CitreaDevnet"] = "Citrea Devnet";
    ChainName["CeloBaklavaTestnet"] = "Celo Baklava Testnet";
    ChainName["MultiVACMainnet"] = "MultiVAC Mainnet";
    ChainName["PLYRTAUTestnet"] = "PLYR TAU Testnet";
    ChainName["LAOSSigmaTestnet"] = "LAOS Sigma Testnet";
    ChainName["ESyncNetworkMainnet"] = "eSync Network Mainnet";
    ChainName["ECreditsTestnet"] = "eCredits Testnet";
    ChainName["ESyncNetworkTestnet"] = "eSync Network Testnet";
    ChainName["GeistMainnet"] = "Geist Mainnet";
    ChainName["XCHAINTestnet"] = "XCHAIN Testnet";
    ChainName["CratD2CTestnet"] = "CratD2C Testnet";
    ChainName["VecnoMainnet"] = "Vecno Mainnet";
    ChainName["ScolcoinMainnet"] = "Scolcoin Mainnet";
    ChainName["CyberChainMainnet"] = "CyberChain Mainnet";
    ChainName["AutomataMainnet"] = "Automata Mainnet";
    ChainName["CreatorChainTestnet"] = "Creator Chain Testnet";
    ChainName["JanusTestnet"] = "Janus Testnet";
    ChainName["SiriusNet"] = "SiriusNet";
    ChainName["CosmicChain"] = "Cosmic Chain";
    ChainName["DM2VerseMainnet"] = "DM2 Verse Mainnet";
    ChainName["DM2VerseTestnet"] = "DM2 Verse Testnet";
    ChainName["AnimechainMainnet"] = "Animechain Mainnet";
    ChainName["Condrieu"] = "Condrieu";
    ChainName["ThinkiumMainnetChain0"] = "Thinkium Mainnet Chain 0";
    ChainName["ThinkiumMainnetChain1"] = "Thinkium Mainnet Chain 1";
    ChainName["ThinkiumMainnetChain2"] = "Thinkium Mainnet Chain 2";
    ChainName["ThinkiumMainnetChain103"] = "Thinkium Mainnet Chain 103";
    ChainName["ProofofPlay-Apex"] = "Proof of Play - Apex";
    ChainName["ProofofPlay-Boss"] = "Proof of Play - Boss";
    ChainName["GuapcoinX"] = "GuapcoinX";
    ChainName["WadzchainTestnet"] = "Wadzchain Testnet";
    ChainName["PolyjuiceTestnet"] = "Polyjuice Testnet";
    ChainName["GodwokenTestnetv1"] = "Godwoken Testnet v1";
    ChainName["GodwokenMainnet"] = "Godwoken Mainnet";
    ChainName["NexeraTestnet"] = "Nexera Testnet";
    ChainName["CAGAcryptoAnkaratestnet"] = "CAGA crypto Ankara testnet";
    ChainName["CAGAmainnet"] = "CAGA mainnet";
    ChainName["GrokChainMainnet"] = "Grok Chain Mainnet";
    ChainName["ICBTestnet"] = "ICB Testnet";
    ChainName["ICBNetwork"] = "ICB Network";
    ChainName["EnergyWebVoltaTestnet"] = "Energy Web Volta Testnet";
    ChainName["MixinVirtualMachine"] = "Mixin Virtual Machine";
    ChainName["ResinCoinMainnet"] = "ResinCoin Mainnet";
    ChainName["AppLayerTestnet"] = "AppLayer Testnet";
    ChainName["GEEKVerseMainnet"] = "GEEK Verse Mainnet";
    ChainName["GEEKVerseTestnet"] = "GEEK Verse Testnet";
    ChainName["BORAchainmainnet"] = "BORAchain mainnet";
    ChainName["FoundryChainTestnet"] = "Foundry Chain Testnet";
    ChainName["VentionSmartChainMainnet"] = "Vention Smart Chain Mainnet";
    ChainName["CarrchainTestnet"] = "Carrchain Testnet";
    ChainName["CycleNetworkMainnetSailboat"] = "Cycle Network Mainnet Sailboat";
    ChainName["ToronetMainnet"] = "Toronet Mainnet";
    ChainName["Firenzetestnetwork"] = "Firenze test network";
    ChainName["DragonflyMainnet(Hexapod)"] = "Dragonfly Mainnet (Hexapod)";
    ChainName["AmplifySubnet"] = "Amplify Subnet";
    ChainName["BulletinSubnet"] = "Bulletin Subnet";
    ChainName["ConduitSubnet"] = "Conduit Subnet";
    ChainName["Vanguard"] = "Vanguard";
    ChainName["GoldSmartChainTestnet"] = "Gold Smart Chain Testnet";
    ChainName["Mumbai"] = "Mumbai";
    ChainName["Amoy"] = "Amoy";
    ChainName["PolynomiaSepolia"] = "Polynomia Sepolia";
    ChainName["BerachainBepolia"] = "Berachain Bepolia";
    ChainName["BerachainbArtio"] = "Berachain bArtio";
    ChainName["BerachainArtio"] = "Berachain Artio";
    ChainName["Berachain"] = "Berachain";
    ChainName["Hizocomainnet"] = "Hizoco mainnet";
    ChainName["GeoGenesis"] = "Geo Genesis";
    ChainName["FortaChain"] = "Forta Chain";
    ChainName["NordekMainnet"] = "Nordek Mainnet";
    ChainName["AmanaTestnet"] = "Amana Testnet";
    ChainName["AmanaMixnet"] = "Amana Mixnet";
    ChainName["AmanaPrivnet"] = "Amana Privnet";
    ChainName["FlanaTestnet"] = "Flana Testnet";
    ChainName["FlanaMixnet"] = "Flana Mixnet";
    ChainName["FlanaPrivnet"] = "Flana Privnet";
    ChainName["MizanaTestnet"] = "Mizana Testnet";
    ChainName["MizanaMixnet"] = "Mizana Mixnet";
    ChainName["MizanaPrivnet"] = "Mizana Privnet";
    ChainName["Blast"] = "Blast";
    ChainName["QuantumChainMainnet"] = "Quantum Chain Mainnet";
    ChainName["SmartLayerNetworkTestnet"] = "Smart Layer Network Testnet";
    ChainName["VEMPHorizon"] = "VEMP Horizon";
    ChainName["XprotocolTestnet"] = "Xprotocol Testnet";
    ChainName["Esa"] = "Esa";
    ChainName["XprotocolSepolia"] = "Xprotocol Sepolia";
    ChainName["ZEDXION"] = "ZEDXION";
    ChainName["BaseGoerliTestnet"] = "Base Goerli Testnet";
    ChainName["BaseSepoliaTestnet"] = "Base Sepolia Testnet";
    ChainName["OChain"] = "O Chain";
    ChainName["AerieNetwork"] = "Aerie Network";
    ChainName["GDPRTestnet"] = "GDPR Testnet";
    ChainName["CYBERTRUST"] = "CYBERTRUST";
    ChainName["NautilusProteusTestnet"] = "Nautilus Proteus Testnet";
    ChainName["InoAi"] = "InoAi";
    ChainName["ZKasinoMainnet"] = "ZKasino Mainnet";
    ChainName["UnitZeroMainnet"] = "Unit Zero Mainnet";
    ChainName["UnitZeroTestnet"] = "Unit Zero Testnet";
    ChainName["UnitZeroStagenet"] = "Unit Zero Stagenet";
    ChainName["Matr1xTestnet"] = "Matr1x Testnet";
    ChainName["ChilizScovilleTestnet"] = "Chiliz Scoville Testnet";
    ChainName["ChilizSpicyTestnet"] = "Chiliz Spicy Testnet";
    ChainName["ChilizChainMainnet"] = "Chiliz Chain Mainnet";
    ChainName["Unite"] = "Unite";
    ChainName["PundiAIFXOmnilayerTestnet"] = "Pundi AIFX Omnilayer Testnet";
    ChainName["UBITSMARTCHAINMAINNET"] = "UBIT SMARTCHAIN MAINNET";
    ChainName["BeverlyHills"] = "Beverly Hills";
    ChainName["CampTestnet"] = "Camp Testnet";
    ChainName["NautilusTritionChain"] = "Nautilus Trition Chain";
    ChainName["HenezChainMainnet"] = "Henez Chain Mainnet";
    ChainName["MetaDAPEnterpriseMainnet"] = "MetaDAP Enterprise Mainnet";
    ChainName["ComboTestnet"] = "Combo Testnet";
    ChainName["LambdaTestnet"] = "Lambda Testnet";
    ChainName["MiracleChain"] = "Miracle Chain";
    ChainName["LiquidLayerTestnet"] = "LiquidLayer Testnet";
    ChainName["StratoVMTestnet"] = "StratoVM Testnet";
    ChainName["XCHAIN"] = "XCHAIN";
    ChainName["SRICHAIN"] = "SRICHAIN";
    ChainName["LuxTestnet"] = "Lux Testnet";
    ChainName["LuxMainnet"] = "Lux Mainnet";
    ChainName["LumozChainMainnet"] = "Lumoz Chain Mainnet";
    ChainName["WonderTestnet"] = "Wonder Testnet";
    ChainName["MantisTestnet(Hexapod)"] = "Mantis Testnet (Hexapod)";
    ChainName["TetronTestnetSmartChain"] = "Tetron Testnet Smart Chain";
    ChainName["TetronSmartChain"] = "Tetron Smart Chain";
    ChainName["BobaBNBMainnetOld"] = "Boba BNB Mainnet Old";
    ChainName["SlingShotTestnet"] = "SlingShot Testnet";
    ChainName["SidraChain"] = "Sidra Chain";
    ChainName["GreenChainTestnet"] = "Green Chain Testnet";
    ChainName["MetaBenzCHAIN"] = "MetaBenz CHAIN";
    ChainName["OptimusZ7Testnet"] = "OptimusZ7 Testnet";
    ChainName["PlumeDevnet(Legacy)"] = "Plume Devnet (Legacy)";
    ChainName["Plume(Legacy)"] = "Plume (Legacy)";
    ChainName["PlumeMainnet"] = "Plume Mainnet";
    ChainName["PlumeTestnet"] = "Plume Testnet";
    ChainName["EbiChain"] = "Ebi Chain";
    ChainName["SuperpositionTestnet"] = "Superposition Testnet";
    ChainName["ELibertyTestnet"] = "eLiberty Testnet";
    ChainName["EdgeMatrixChainTestnet"] = "Edge Matrix Chain Testnet";
    ChainName["EdgeMatrixChainSepolia"] = "Edge Matrix Chain Sepolia";
    ChainName["UBSmartChain(testnet)"] = "UB Smart Chain(testnet)";
    ChainName["UBSmartChain"] = "UB Smart Chain";
    ChainName["QuarkChainMainnetRoot"] = "QuarkChain Mainnet Root";
    ChainName["QuarkChainMainnetShard0"] = "QuarkChain Mainnet Shard 0";
    ChainName["QuarkChainMainnetShard1"] = "QuarkChain Mainnet Shard 1";
    ChainName["QuarkChainMainnetShard2"] = "QuarkChain Mainnet Shard 2";
    ChainName["QuarkChainMainnetShard3"] = "QuarkChain Mainnet Shard 3";
    ChainName["QuarkChainMainnetShard4"] = "QuarkChain Mainnet Shard 4";
    ChainName["QuarkChainMainnetShard5"] = "QuarkChain Mainnet Shard 5";
    ChainName["QuarkChainMainnetShard6"] = "QuarkChain Mainnet Shard 6";
    ChainName["QuarkChainMainnetShard7"] = "QuarkChain Mainnet Shard 7";
    ChainName["VeChain"] = "VeChain";
    ChainName["VeChainTestnet"] = "VeChain Testnet";
    ChainName["QuarkChainL2Mainnet"] = "QuarkChain L2 Mainnet";
    ChainName["DeprecatedCHI"] = "Deprecated CHI";
    ChainName["SocotraJUNE-Chain"] = "Socotra JUNE-Chain";
    ChainName["GlobalTrustNetwork"] = "Global Trust Network";
    ChainName["Xitcoin"] = "Xitcoin";
    ChainName["Creditcoin"] = "Creditcoin";
    ChainName["CreditcoinTestnet"] = "Creditcoin Testnet";
    ChainName["CreditcoinDevnet"] = "Creditcoin Devnet";
    ChainName["Crystaleum"] = "Crystaleum";
    ChainName["MasaTestnet"] = "Masa Testnet";
    ChainName["KaspaClassicMainnet"] = "KaspaClassic Mainnet";
    ChainName["StratisMainnet"] = "Stratis Mainnet";
    ChainName["LumozChainTestnet"] = "Lumoz Chain Testnet";
    ChainName["BROChainMainnet"] = "BROChain Mainnet";
    ChainName["QuarkChainDevnetRoot"] = "QuarkChain Devnet Root";
    ChainName["QuarkChainDevnetShard0"] = "QuarkChain Devnet Shard 0";
    ChainName["QuarkChainDevnetShard1"] = "QuarkChain Devnet Shard 1";
    ChainName["QuarkChainDevnetShard2"] = "QuarkChain Devnet Shard 2";
    ChainName["QuarkChainDevnetShard3"] = "QuarkChain Devnet Shard 3";
    ChainName["QuarkChainDevnetShard4"] = "QuarkChain Devnet Shard 4";
    ChainName["QuarkChainDevnetShard5"] = "QuarkChain Devnet Shard 5";
    ChainName["QuarkChainDevnetShard6"] = "QuarkChain Devnet Shard 6";
    ChainName["QuarkChainDevnetShard7"] = "QuarkChain Devnet Shard 7";
    ChainName["QuarkChainL2Testnet"] = "QuarkChain L2 Testnet";
    ChainName["MarsCredit"] = "Mars Credit";
    ChainName["SiberiumTestNetwork"] = "Siberium Test Network";
    ChainName["SiberiumNetwork"] = "Siberium Network";
    ChainName["Re.al"] = "re.al";
    ChainName["EGoldChainTestnet"] = "eGold Chain Testnet";
    ChainName["MetachainOneMainnet"] = "Metachain One Mainnet";
    ChainName["MetaDAPEnterpriseTestnet"] = "MetaDAP Enterprise Testnet";
    ChainName["Fushuma"] = "Fushuma";
    ChainName["Gemchain"] = "Gemchain";
    ChainName["ADILDevnet"] = "ADIL Devnet";
    ChainName["MitosisTestnet"] = "Mitosis Testnet";
    ChainName["EtherlinkTestnet"] = "Etherlink Testnet";
    ChainName["TataraTestnet"] = "Tatara Testnet";
    ChainName["OdysseyChain(Testnet)"] = "Odyssey Chain (Testnet)";
    ChainName["ETNDChainMainnets"] = "ETND Chain Mainnets";
    ChainName["FormTestnet"] = "Form Testnet";
    ChainName["MagApeTestnet"] = "MagApe Testnet";
    ChainName["BitharvestChainTestnet"] = "Bitharvest Chain Testnet";
    ChainName["ICPlazaMainnet"] = "ICPlaza Mainnet";
    ChainName["OdysseyChainMainnet"] = "Odyssey Chain Mainnet";
    ChainName["CryptoX"] = "CryptoX";
    ChainName["XCOIN"] = "XCOIN";
    ChainName["OpenLedgerTestnet"] = "OpenLedger Testnet";
    ChainName["PlayFiMainnet"] = "PlayFi Mainnet";
    ChainName["EventumMainnet"] = "Eventum Mainnet";
    ChainName["EclatMainnet"] = "Eclat Mainnet";
    ChainName["TaikoAlethia"] = "Taiko Alethia";
    ChainName["Taiko(Alpha-2Testnet)"] = "Taiko (Alpha-2 Testnet)";
    ChainName["TaikoGrimsvotnL2"] = "Taiko Grimsvotn L2";
    ChainName["TaikoEldfellL3"] = "Taiko Eldfell L3";
    ChainName["TaikoJolnirL2"] = "Taiko Jolnir L2";
    ChainName["TaikoKatlaL2"] = "Taiko Katla L2";
    ChainName["TaikoHekla"] = "Taiko Hekla";
    ChainName["Zchains"] = "Zchains";
    ChainName["MUDChain"] = "MUD Chain";
    ChainName["FairTestnet"] = "Fair Testnet";
    ChainName["WadzchainMainnet"] = "Wadzchain Mainnet";
    ChainName["Chronicle-LitProtocolTestnet"] = "Chronicle - Lit Protocol Testnet";
    ChainName["ChronicleYellowstone-LitProtocolTestnet"] = "Chronicle Yellowstone - Lit Protocol Testnet";
    ChainName["ChronicleLoa-LitProtocolTestnet"] = "Chronicle Loa - Lit Protocol Testnet";
    ChainName["BiticaChainMainnet"] = "Bitica Chain Mainnet";
    ChainName["CondorTestNetwork"] = "Condor Test Network";
    ChainName["AltblockscanMainnet"] = "Altblockscan Mainnet";
    ChainName["MindNetworkTestnet"] = "Mind Network Testnet";
    ChainName["R0ARChain"] = "R0AR Chain";
    ChainName["LydiaCoinTestnet"] = "Lydia Coin Testnet";
    ChainName["MAZZETestnet"] = "MAZZE Testnet";
    ChainName["XFair.AITestnet"] = "xFair.AI Testnet";
    ChainName["MilkomedaC1Testnet"] = "Milkomeda C1 Testnet";
    ChainName["ZooMainnet"] = "Zoo Mainnet";
    ChainName["MilkomedaA1Testnet"] = "Milkomeda A1 Testnet";
    ChainName["Akroma"] = "Akroma";
    ChainName["BitlayerTestnet"] = "Bitlayer Testnet";
    ChainName["BitlayerMainnet"] = "Bitlayer Mainnet";
    ChainName["AlayaMainnet"] = "Alaya Mainnet";
    ChainName["AlayaDevTestnet"] = "Alaya Dev Testnet";
    ChainName["MythicalChain"] = "Mythical Chain";
    ChainName["DecimalSmartChainTestnet"] = "Decimal Smart Chain Testnet";
    ChainName["DuckChainTestnet"] = "DuckChain Testnet";
    ChainName["BethelSydney"] = "Bethel Sydney";
    ChainName["Alterscope"] = "Alterscope";
    ChainName["X1Devnet"] = "X1 Devnet";
    ChainName["YMTECH-BESUTestnet"] = "YMTECH-BESU Testnet";
    ChainName["Blockfit"] = "Blockfit";
    ChainName["Jellie"] = "Jellie";
    ChainName["X1Network"] = "X1 Network";
    ChainName["AuroriaTestnet"] = "Auroria Testnet";
    ChainName["GitAGIAtlasTestnet"] = "GitAGI Atlas Testnet";
    ChainName["Sorian"] = "Sorian";
    ChainName["SorianTestnet"] = "Sorian Testnet";
    ChainName["PlatONMainnet"] = "PlatON Mainnet";
    ChainName["Heima"] = "Heima";
    ChainName["MasMainnet"] = "Mas Mainnet";
    ChainName["ReapchainMainnet"] = "Reapchain Mainnet";
    ChainName["ReapchainTestnet"] = "Reapchain Testnet";
    ChainName["Hydration"] = "Hydration";
    ChainName["DeepLMainnet"] = "DeepL Mainnet";
    ChainName["DeepLTestnet"] = "DeepL Testnet";
    ChainName["B20Testnet"] = "B20 Testnet";
    ChainName["TafECOChainMainnet"] = "Taf ECO Chain Mainnet";
    ChainName["CONETMainnet"] = "CONET Mainnet";
    ChainName["CONETSeboliaTestnet"] = "CONET Sebolia Testnet";
    ChainName["CONETCancun"] = "CONET Cancun";
    ChainName["AbyssProtocol"] = "Abyss Protocol";
    ChainName["HashKeyChainTestnet(discard)"] = "HashKey Chain Testnet(discard)";
    ChainName["HaymoTestnet"] = "Haymo Testnet";
    ChainName["UniverseTestnet"] = "Universe Testnet";
    ChainName["StudioTestnet"] = "Studio Testnet";
    ChainName["OrangeChainTestnet"] = "Orange Chain Testnet";
    ChainName["AnomalyAndromedaTestnet"] = "Anomaly Andromeda Testnet";
    ChainName["ARTISsigma1"] = "ARTIS sigma1";
    ChainName["ARTISTestnettau1"] = "ARTIS Testnet tau1";
    ChainName["SaakuruTestnet"] = "Saakuru Testnet";
    ChainName["CELESTIUMNetworkTestnet"] = "CELESTIUM Network Testnet";
    ChainName["CMP-Mainnet"] = "CMP-Mainnet";
    ChainName["EclatTestnet"] = "Eclat Testnet";
    ChainName["GearZeroNetworkTestnet"] = "Gear Zero Network Testnet";
    ChainName["EgonCoinTestnet"] = "EgonCoin Testnet";
    ChainName["NxyArea51"] = "Nxy Area 51";
    ChainName["NxyOasis"] = "Nxy Oasis";
    ChainName["SocialSmartChainMainnet"] = "Social Smart Chain Mainnet";
    ChainName["AtheneParthenon"] = "Athene Parthenon";
    ChainName["ZillionSepoliaTestnet"] = "Zillion Sepolia Testnet";
    ChainName["CipheremTestnet"] = "Cipherem Testnet";
    ChainName["OneWorldChainMainnet"] = "One World Chain Mainnet";
    ChainName["SaharaAITestnet"] = "SaharaAI Testnet";
    ChainName["Filecoin-Calibrationtestnet"] = "Filecoin - Calibration testnet";
    ChainName["ParexMainnet"] = "Parex Mainnet";
    ChainName["BloomGenesisTestnet"] = "Bloom Genesis Testnet";
    ChainName["CampNetworkTestnetV2"] = "Camp Network Testnet V2";
    ChainName["WABAChainTestnet"] = "WABA Chain Testnet";
    ChainName["NalMainnet"] = "Nal Mainnet";
    ChainName["TTcoinSmartChainMainnet"] = "TTcoin Smart Chain Mainnet";
    ChainName["BloomGenesisMainnet"] = "Bloom Genesis Mainnet";
    ChainName["AvesTestnet"] = "Aves Testnet";
    ChainName["Nativ3Testnet"] = "Nativ3 Testnet";
    ChainName["OoneChainTestnet"] = "Oone Chain Testnet";
    ChainName["OoneChainDevnet"] = "Oone Chain Devnet";
    ChainName["PolisTestnet"] = "Polis Testnet";
    ChainName["PolisMainnet"] = "Polis Mainnet";
    ChainName["UPchainTestnet"] = "UPchain Testnet";
    ChainName["UPchainMainnet"] = "UPchain Mainnet";
    ChainName["BitfinityNetworkMainnet"] = "Bitfinity Network Mainnet";
    ChainName["BitfinityNetworkTestnet"] = "Bitfinity Network Testnet";
    ChainName["LAVITAMainnet"] = "LAVITA Mainnet";
    ChainName["DigitSoulSmartChain2"] = "Digit Soul Smart Chain 2";
    ChainName["HAPchainTestnet"] = "HAPchain Testnet";
    ChainName["MetalC-Chain"] = "Metal C-Chain";
    ChainName["MetalTahoeC-Chain"] = "Metal Tahoe C-Chain";
    ChainName["CheeseChain"] = "CheeseChain";
    ChainName["TipboxcoinMainnet"] = "Tipboxcoin Mainnet";
    ChainName["AIETestnet"] = "AIE Testnet";
    ChainName["Infinaeon"] = "Infinaeon";
    ChainName["VectorSmartChain"] = "Vector Smart Chain";
    ChainName["Kekchain"] = "Kekchain";
    ChainName["Kekchain(kektest)"] = "Kekchain (kektest)";
    ChainName["AlteriumL2Testnet"] = "Alterium L2 Testnet";
    ChainName["ArbitrumRinkeby"] = "Arbitrum Rinkeby";
    ChainName["ArbitrumGoerli"] = "Arbitrum Goerli";
    ChainName["ArbitrumSepolia"] = "Arbitrum Sepolia";
    ChainName["FastexChaintestnet"] = "Fastex Chain testnet";
    ChainName["MarkrGo"] = "Markr Go";
    ChainName["DexalotSubnetTestnet"] = "Dexalot Subnet Testnet";
    ChainName["DexalotSubnet"] = "Dexalot Subnet";
    ChainName["GraphiteMainnet"] = "Graphite Mainnet";
    ChainName["SyndrL3Sepolia"] = "Syndr L3 Sepolia";
    ChainName["WeelinkTestnet"] = "Weelink Testnet";
    ChainName["PatexSepoliaTestnet"] = "Patex Sepolia Testnet";
    ChainName["UltraProMainnet"] = "Ultra Pro Mainnet";
    ChainName["OpenChainMainnet"] = "OpenChain Mainnet";
    ChainName["WorldChainSepoliaTestnetDeprecated"] = "World Chain Sepolia Testnet Deprecated";
    ChainName["GobblTestnet"] = "Gobbl Testnet";
    ChainName["AutonomysTaurusTestnet"] = "Autonomys Taurus Testnet";
    ChainName["PUMPFICHAINTESTNET"] = "PUMPFI CHAIN TESTNET";
    ChainName["PlaydappNetwork"] = "Playdapp Network";
    ChainName["CMP-Testnet"] = "CMP-Testnet";
    ChainName["EthereumFair"] = "EthereumFair";
    ChainName["DoCoinCommunityChain"] = "DoCoin Community Chain";
    ChainName["ScrollSepoliaTestnet"] = "Scroll Sepolia Testnet";
    ChainName["Scroll"] = "Scroll";
    ChainName["ScrollAlphaTestnet"] = "Scroll Alpha Testnet";
    ChainName["ScrollPre-AlphaTestnet"] = "Scroll Pre-Alpha Testnet";
    ChainName["ShinariumBeta"] = "Shinarium Beta";
    ChainName["BeanEcoSmartChain"] = "BeanEco SmartChain";
    ChainName["OverProtocolTestnet"] = "OverProtocol Testnet";
    ChainName["ZERONetwork"] = "ZERO Network";
    ChainName["OneWorldChainTestnet"] = "One World Chain Testnet";
    ChainName["PentagonTestnet"] = "Pentagon Testnet";
    ChainName["EclipseTestnet"] = "Eclipse Testnet";
    ChainName["XsollaZKSepoliaTestnet"] = "Xsolla ZK Sepolia Testnet";
    ChainName["DustBoyIoT"] = "DustBoy IoT";
    ChainName["HetuTestnet"] = "Hetu Testnet";
    ChainName["EthereumHoodi"] = "Ethereum Hoodi";
    ChainName["DJTTestnet"] = "DJT Testnet";
    ChainName["HypraMainnet"] = "Hypra Mainnet";
    ChainName["Atlas"] = "Atlas";
    ChainName["PolterTestnet"] = "Polter Testnet";
    ChainName["BearNetworkChainMainnet"] = "Bear Network Chain Mainnet";
    ChainName["ALLMainnet"] = "ALL Mainnet";
    ChainName["EDUChainTestnet"] = "EDU Chain Testnet";
    ChainName["XaiMainnet"] = "Xai Mainnet";
    ChainName["Vision-VpioneerTestChain"] = "Vision - Vpioneer Test Chain";
    ChainName["HelaOfficialRuntimeTestnet"] = "Hela Official Runtime Testnet";
    ChainName["ConwaiMainnet"] = "Conwai Mainnet";
    ChainName["GensynTestnet"] = "Gensyn Testnet";
    ChainName["WonNetwork"] = "Won Network";
    ChainName["PyropeTestnet"] = "Pyrope Testnet";
    ChainName["GaladrielDevnet"] = "Galadriel Devnet";
    ChainName["PrimeaNetworkMainnet"] = "Primea Network Mainnet";
    ChainName["Fidesinnova"] = "Fidesinnova";
    ChainName["TiltyardMainnetSubnet"] = "Tiltyard Mainnet Subnet";
    ChainName["SeiDevnet"] = "Sei Devnet";
    ChainName["ZetherMainnet"] = "Zether Mainnet";
    ChainName["ERAMMainnet"] = "ERAM Mainnet";
    ChainName["TixChainTestnet"] = "TixChain Testnet";
    ChainName["HemiSepolia"] = "Hemi Sepolia";
    ChainName["BearNetworkChainTestnet"] = "Bear Network Chain Testnet";
    ChainName["TernoaTestnet"] = "Ternoa Testnet";
    ChainName["Ternoa"] = "Ternoa";
    ChainName["PAYSCANCHAIN"] = "PAYSCAN CHAIN";
    ChainName["MiexsSmartchain"] = "Miexs Smartchain";
    ChainName["InkSepolia"] = "Ink Sepolia";
    ChainName["SurgeTestnet"] = "Surge Testnet";
    ChainName["Lamina1Testnet"] = "Lamina1 Testnet";
    ChainName["Lamina1IdentityTestnet"] = "Lamina1 Identity Testnet";
    ChainName["Modularium"] = "Modularium";
    ChainName["WinrProtocolMainnet"] = "Winr Protocol Mainnet";
    ChainName["OoneChainMainnet"] = "Oone Chain Mainnet";
    ChainName["ZebroSmartChain"] = "Zebro Smart Chain";
    ChainName["Emeraldz"] = "Emeraldz";
    ChainName["OctaSpace"] = "OctaSpace";
    ChainName["EthparTestnet"] = "Ethpar Testnet";
    ChainName["BIZSmartChainTestnet"] = "BIZ Smart Chain Testnet";
    ChainName["BOBSepolia"] = "BOB Sepolia";
    ChainName["ZkLinkNovaMainnet"] = "zkLink Nova Mainnet";
    ChainName["ZkLinkNovaSepoliaTestnet"] = "zkLink Nova Sepolia Testnet";
    ChainName["ZkLinkNovaGoerliTestnet"] = "zkLink Nova Goerli Testnet";
    ChainName["SGVerseMainnet"] = "SG Verse Mainnet";
    ChainName["TSCTestnet"] = "TSC Testnet";
    ChainName["CURVEMainnet"] = "CURVE Mainnet";
    ChainName["PRMTestnet"] = "PRM Testnet";
    ChainName["ExSatTestnet"] = "exSat Testnet";
    ChainName["RUNEVMTestnet"] = "RUNEVM Testnet";
    ChainName["4GoodNetwork"] = "4GoodNetwork";
    ChainName["Dodao"] = "Dodao";
    ChainName["BlocXMainnet"] = "BlocX Mainnet";
    ChainName["REXXMainnet"] = "REXX Mainnet";
    ChainName["Vision-Mainnet"] = "Vision - Mainnet";
    ChainName["UniteTestnet"] = "Unite Testnet";
    ChainName["PosichainMainnetShard0"] = "Posichain Mainnet Shard 0";
    ChainName["PosichainTestnetShard0"] = "Posichain Testnet Shard 0";
    ChainName["OdysseyTestnet"] = "Odyssey Testnet";
    ChainName["AstriaEVMDusknet"] = "Astria EVM Dusknet";
    ChainName["OwshenMainnet"] = "Owshen Mainnet";
    ChainName["PosichainDevnetShard0"] = "Posichain Devnet Shard 0";
    ChainName["PosichainDevnetShard1"] = "Posichain Devnet Shard 1";
    ChainName["FNCYTestnet"] = "FNCY Testnet";
    ChainName["Jono12Subnet"] = "Jono12 Subnet";
    ChainName["EluvioContentFabric"] = "Eluvio Content Fabric";
    ChainName["TreasureRuby"] = "Treasure Ruby";
    ChainName["TreasureTopaz"] = "Treasure Topaz";
    ChainName["Forma"] = "Forma";
    ChainName["FormaSketchpad"] = "Forma Sketchpad";
    ChainName["EcroxChainMainnet"] = "Ecrox Chain Mainnet";
    ChainName["SupernetTestnet"] = "Supernet Testnet";
    ChainName["AmChain"] = "AmChain";
    ChainName["NagaTestnet"] = "Naga Testnet";
    ChainName["NetmindChainTestnet"] = "Netmind Chain Testnet";
    ChainName["TiltyardSubnet"] = "Tiltyard Subnet";
    ChainName["1MoneyNetworkTestnet"] = "1Money Network Testnet";
    ChainName["SharecleMainnet"] = "Sharecle Mainnet";
    ChainName["ZKatana"] = "zKatana";
    ChainName["EthoProtocol"] = "Etho Protocol";
    ChainName["Xerom"] = "Xerom";
    ChainName["Kintsugi"] = "Kintsugi";
    ChainName["Kiln"] = "Kiln";
    ChainName["Zhejiang"] = "Zhejiang";
    ChainName["AutomataTestnet"] = "Automata Testnet";
    ChainName["AutomataOrbitTestnet"] = "Automata Orbit Testnet";
    ChainName["XRPLEVMSidechainDevnet"] = "XRPL EVM Sidechain Devnet";
    ChainName["XRPLEVMSidechainTestnet"] = "XRPL EVM Sidechain Testnet";
    ChainName["Waterfall9TestNetwork"] = "Waterfall 9 Test Network";
    ChainName["PlayFiAlbireoTestnet"] = "PlayFi Albireo Testnet";
    ChainName["XterioTestnet"] = "Xterio Testnet";
    ChainName["PrimeaNetworkTestnet"] = "Primea Network Testnet";
    ChainName["TurkeyDemoDev"] = "Turkey Demo Dev";
    ChainName["XphereTestnet"] = "Xphere Testnet";
    ChainName["DeBankTestnet"] = "DeBank Testnet";
    ChainName["AlterscopeTestnet"] = "Alterscope Testnet";
    ChainName["PlianMainnetMain"] = "Plian Mainnet Main";
    ChainName["PlatONDevTestnetDeprecated"] = "PlatON Dev Testnet Deprecated";
    ChainName["PlatONDevTestnet2"] = "PlatON Dev Testnet2";
    ChainName["CoinwebBNBshard"] = "Coinweb BNB shard";
    ChainName["RecallTestnet"] = "Recall Testnet";
    ChainName["DPUChain"] = "DPU Chain";
    ChainName["COTI"] = "COTI";
    ChainName["XterioChain(ETH)"] = "Xterio Chain (ETH)";
    ChainName["SaharaAI"] = "Sahara AI";
    ChainName["Filecoin-Butterflytestnet"] = "Filecoin - Butterfly testnet";
    ChainName["FunkiSepoliaTestnet"] = "Funki Sepolia Testnet";
    ChainName["MantaPacificTestnet"] = "Manta Pacific Testnet";
    ChainName["MantaPacificSepoliaTestnet"] = "Manta Pacific Sepolia Testnet";
    ChainName["AltLayerZeroGasNetwork"] = "AltLayer Zero Gas Network";
    ChainName["ArcadiaMainnet"] = "Arcadia Mainnet";
    ChainName["WorldsCaldera"] = "Worlds Caldera";
    ChainName["Zuuxchaintestnet"] = "Zuux chain testnet";
    ChainName["AltarTestnet"] = "Altar Testnet";
    ChainName["ZEROTestnet(Sepolia)"] = "ZERO Testnet (Sepolia)";
    ChainName["NumBlockChain"] = "NumBlock Chain";
    ChainName["MXCWannseezkEVMTestnet"] = "MXC Wannsee zkEVM Testnet";
    ChainName["MoonchainGenevaTestnet"] = "Moonchain Geneva Testnet";
    ChainName["ElectroneumTestnet"] = "Electroneum Testnet";
    ChainName["ReactiveKopli"] = "Reactive Kopli";
    ChainName["PointPayTestnet"] = "PointPay Testnet";
    ChainName["ImversedMainnet"] = "Imversed Mainnet";
    ChainName["ImversedTestnet"] = "Imversed Testnet";
    ChainName["AstarzKyoto"] = "Astar zKyoto";
    ChainName["BlockChainLOLBerachainTestnet"] = "Block Chain LOL Berachain Testnet";
    ChainName["Safe(AnWang)Mainnet"] = "Safe(AnWang) Mainnet";
    ChainName["Safe(AnWang)Testnet"] = "Safe(AnWang) Testnet";
    ChainName["TheTingBlockchainTestnetExplorer"] = "The Ting Blockchain Testnet Explorer";
    ChainName["COTITestnet"] = "COTI Testnet";
    ChainName["SaakuruMainnet"] = "Saakuru Mainnet";
    ChainName["OpenVessel"] = "OpenVessel";
    ChainName["QL1Testnet"] = "QL1 Testnet";
    ChainName["Musicoin"] = "Musicoin";
    ChainName["Zora"] = "Zora";
    ChainName["OzeanPoseidonTestnet"] = "Ozean Poseidon Testnet";
    ChainName["PlianMainnetSubchain1"] = "Plian Mainnet Subchain 1";
    ChainName["FhenixHelium"] = "Fhenix Helium";
    ChainName["Hokum"] = "Hokum";
    ChainName["Waterfall8TestNetwork"] = "Waterfall 8 Test Network";
    ChainName["HAPchain"] = "HAPchain";
    ChainName["QuarixTestnet"] = "Quarix Testnet";
    ChainName["Quarix"] = "Quarix";
    ChainName["XCAP"] = "XCAP";
    ChainName["Milvine"] = "Milvine";
    ChainName["Fluence"] = "Fluence";
    ChainName["Spotlight"] = "Spotlight";
    ChainName["SpotlightSepoliaTestnet"] = "Spotlight Sepolia Testnet";
    ChainName["PlianTestnetSubchain1"] = "Plian Testnet Subchain 1";
    ChainName["SoverunMainnet"] = "Soverun Mainnet";
    ChainName["AlienXMainnet"] = "AlienX Mainnet";
    ChainName["ALIENXHalTestnet"] = "ALIENX Hal Testnet";
    ChainName["BlessnetSepolia"] = "Blessnet Sepolia";
    ChainName["EthereumSepolia"] = "Ethereum Sepolia";
    ChainName["OPSepoliaTestnet"] = "OP Sepolia Testnet";
    ChainName["RISETestnet"] = "RISE Testnet";
    ChainName["R0ARTestnet"] = "R0AR Testnet";
    ChainName["LummioNetwork"] = "Lummio Network";
    ChainName["MementoTestnet"] = "Memento Testnet";
    ChainName["NeoXTestnetT3"] = "NeoX Testnet T3";
    ChainName["NeoXTestnetT4"] = "Neo X Testnet T4";
    ChainName["COTIDevnet"] = "COTI Devnet";
    ChainName["PepChainChurchill"] = "PepChain Churchill";
    ChainName["AnduschainMainnet"] = "Anduschain Mainnet";
    ChainName["PlianTestnetMain"] = "Plian Testnet Main";
    ChainName["PrivixChainMainnet"] = "Privix Chain Mainnet";
    ChainName["LambdaChainTestnet"] = "Lambda Chain Testnet";
    ChainName["MandeNetworkMainnet"] = "Mande Network Mainnet";
    ChainName["IOLite"] = "IOLite";
    ChainName["DeepBrainChainTestnet"] = "DeepBrainChain Testnet";
    ChainName["DeepBrainChainMainnet"] = "DeepBrainChain Mainnet";
    ChainName["StabilityTestnet"] = "Stability Testnet";
    ChainName["SmartMeshMainnet"] = "SmartMesh Mainnet";
    ChainName["Quarkblockchain"] = "quarkblockchain";
    ChainName["PegoNetwork"] = "Pego Network";
    ChainName["SoonChainSepoliaDevnet"] = "SoonChain Sepolia Devnet";
    ChainName["VcityTestnet"] = "Vcity Testnet";
    ChainName["DeBankSepoliaTestnet"] = "DeBank Sepolia Testnet";
    ChainName["DBKChain"] = "DBK Chain";
    ChainName["SwanProximaTestnet"] = "Swan Proxima Testnet";
    ChainName["XphereMainnet"] = "Xphere Mainnet";
    ChainName["VcitychainMainnet"] = "Vcitychain Mainnet";
    ChainName["ETPMainnet"] = "ETP Mainnet";
    ChainName["HokumTestnet"] = "Hokum Testnet";
    ChainName["Corn"] = "Corn";
    ChainName["CornTestnet"] = "Corn Testnet";
    ChainName["ExcelonMainnet"] = "Excelon Mainnet";
    ChainName["XMTP"] = "XMTP";
    ChainName["6DegreeofOutreach-Testnet"] = "6Degree of Outreach - Testnet";
    ChainName["ExcoincialChainVolta-Testnet"] = "Excoincial Chain Volta-Testnet";
    ChainName["ExcoincialChainMainnet"] = "Excoincial Chain Mainnet";
    ChainName["Ancient8Testnet"] = "Ancient8 Testnet";
    ChainName["AuxiliumNetworkMainnet"] = "Auxilium Network Mainnet";
    ChainName["FlachainMainnet"] = "Flachain Mainnet";
    ChainName["Filecoin-Localtestnet"] = "Filecoin - Local testnet";
    ChainName["TolimanSuaveTestnet"] = "Toliman Suave Testnet";
    ChainName["XoneTestnet"] = "Xone Testnet";
    ChainName["Citronus-citro"] = "citronus-citro";
    ChainName["JoysDigitalMainnet"] = "Joys Digital Mainnet";
    ChainName["SKALENebulaHubTestnet"] = "SKALE Nebula Hub Testnet";
    ChainName["KingdomChain"] = "Kingdom Chain";
    ChainName["Maistestsubnet"] = "maistestsubnet";
    ChainName["StavangerPublicTestnet"] = "Stavanger Public Testnet";
    ChainName["DeviantTokenBlockchain"] = "Deviant Token Blockchain";
    ChainName["DeviantTokenBlockchainTestnet"] = "Deviant Token Blockchain Testnet";
    ChainName["FluenceTestnet"] = "Fluence Testnet";
    ChainName["DKargoWarehouseTestnet"] = "dKargo Warehouse Testnet";
    ChainName["Aquachain"] = "Aquachain";
    ChainName["AutonityBakerloo(Thames)Testnet"] = "Autonity Bakerloo (Thames) Testnet";
    ChainName["AutonityBakerloo(Barada)Testnet"] = "Autonity Bakerloo (Barada) Testnet";
    ChainName["AutonityBakerloo(Sumida)Testnet"] = "Autonity Bakerloo (Sumida) Testnet";
    ChainName["AutonityBakerloo(Yamuna)Testnet"] = "Autonity Bakerloo (Yamuna) Testnet";
    ChainName["AutonityPiccadilly(Thames)Testnet"] = "Autonity Piccadilly (Thames) Testnet";
    ChainName["AutonityPiccadilly(Barada)Testnet"] = "Autonity Piccadilly (Barada) Testnet";
    ChainName["AutonityPiccadilly(Sumida)Testnet"] = "Autonity Piccadilly (Sumida) Testnet";
    ChainName["AutonityPiccadilly(Yamuna)Testnet"] = "Autonity Piccadilly (Yamuna) Testnet";
    ChainName["AutonityPiccadilly(Tiber)Testnet"] = "Autonity Piccadilly (Tiber) Testnet";
    ChainName["WinrProtocolTestnet"] = "Winr Protocol Testnet";
    ChainName["FrameTestnet"] = "Frame Testnet";
    ChainName["0xHashTestnet"] = "0xHash Testnet";
    ChainName["SXTorontoRollup"] = "SX Toronto Rollup";
    ChainName["BackstopTestnet"] = "Backstop Testnet";
    ChainName["T.E.A.MBlockchain"] = "T.E.A.M Blockchain";
    ChainName["ReyaCronos"] = "Reya Cronos";
    ChainName["PolygonBlackberry"] = "Polygon Blackberry";
    ChainName["PrivixChainTestnet"] = " Privix Chain Testnet";
    ChainName["ChadChain"] = "ChadChain";
    ChainName["JoysDigitalTestNet"] = "Joys Digital TestNet";
    ChainName["Ethos"] = "Ethos";
    ChainName["OraichainMainnet"] = "Oraichain Mainnet";
    ChainName["CyberTestnet"] = "Cyber Testnet";
    ChainName["OPCelestiaRaspberry"] = "OP Celestia Raspberry";
    ChainName["PlumeTestnet(Legacy)"] = "Plume Testnet (Legacy)";
    ChainName["BlastSepoliaTestnet"] = "Blast Sepolia Testnet";
    ChainName["GatherMainnetNetwork"] = "Gather Mainnet Network";
    ChainName["Kanazawa"] = "Kanazawa";
    ChainName["XMTPSepolia"] = "XMTP Sepolia";
    ChainName["NeonEVMDevnet"] = "Neon EVM Devnet";
    ChainName["NeonEVMDevnetRollup"] = "Neon EVM Devnet Rollup";
    ChainName["NeonEVMMainnet"] = "Neon EVM Mainnet";
    ChainName["NeonEVMTestNet"] = "Neon EVM TestNet";
    ChainName["Flame"] = "Flame";
    ChainName["RazorSkaleChain"] = "Razor Skale Chain";
    ChainName["OneLedgerMainnet"] = "OneLedger Mainnet";
    ChainName["NalSepoliaTestnet"] = "Nal Sepolia Testnet";
    ChainName["Meld"] = "Meld";
    ChainName["DeprecatedSKALECalypsoHubTestnet"] = "Deprecated SKALE Calypso Hub Testnet";
    ChainName["GatherTestnetNetwork"] = "Gather Testnet Network";
    ChainName["AssetHub"] = "Asset Hub";
    ChainName["WestendAssetHub"] = "Westend Asset Hub";
    ChainName["DeprecatedSKALEEuropaHubTestnet"] = "Deprecated SKALE Europa Hub Testnet";
    ChainName["GPTTestnet"] = "GPT Testnet";
    ChainName["GatherDevnetNetwork"] = "Gather Devnet Network";
    ChainName["DeprecatedSKALENebulaHubTestnet"] = "Deprecated SKALE Nebula Hub Testnet";
    ChainName["SophonTestnet"] = "Sophon Testnet";
    ChainName["SmartMainnet"] = "Smart Mainnet";
    ChainName["DegenChain"] = "Degen Chain";
    ChainName["TronMainnet"] = "Tron Mainnet";
    ChainName["Ancient8"] = "Ancient8";
    ChainName["PTCESCANTestnet"] = "PTCESCAN Testnet";
    ChainName["PTCESCANMainnet"] = "PTCESCAN Mainnet";
    ChainName["SKALECalypsoHubTestnet"] = "SKALE Calypso Hub Testnet";
    ChainName["LumiaMainnet"] = "Lumia Mainnet";
    ChainName["ZoraSepoliaTestnet"] = "Zora Sepolia Testnet";
    ChainName["SKALETitanHubTestnet"] = "SKALE Titan Hub Testnet";
    ChainName["IPOSNetwork"] = "IPOS Network";
    ChainName["CyberdeckNet"] = "CyberdeckNet";
    ChainName["HUMANProtocol"] = "HUMAN Protocol";
    ChainName["OFFICIALVASYL"] = "OFFICIAL VASYL";
    ChainName["AuroraMainnet"] = "Aurora Mainnet";
    ChainName["AuroraTestnet"] = "Aurora Testnet";
    ChainName["AuroraBetanet"] = "Aurora Betanet";
    ChainName["PowerGold"] = "PowerGold";
    ChainName["Turbo"] = "Turbo";
    ChainName["Tuxappcoin"] = "Tuxappcoin";
    ChainName["SKALETitanHub"] = "SKALE Titan Hub";
    ChainName["Chaos(SKALETestnet)"] = "Chaos (SKALE Testnet)";
    ChainName["RARIChainMainnet"] = "RARI Chain Mainnet";
    ChainName["RaptorChain"] = "RaptorChain";
    ChainName["ZephyrTestnet"] = "Zephyr Testnet";
    ChainName["SKALEEuropaHubTestnet"] = "SKALE Europa Hub Testnet";
    ChainName["SKALENebulaHub"] = "SKALE Nebula Hub";
    ChainName["GPTMainnet"] = "GPT Mainnet";
    ChainName["DeprecatedSKALETitanHubTestnet"] = "Deprecated SKALE Titan Hub Testnet";
    ChainName["HaustNetworkTestnet"] = "Haust Network Testnet";
    ChainName["SKALECalypsoHub"] = "SKALE Calypso Hub";
    ChainName["HaustTestnet"] = "Haust Testnet";
    ChainName["StatusNetworkSepolia"] = "Status Network Sepolia";
    ChainName["HarmonyMainnetShard0"] = "Harmony Mainnet Shard 0";
    ChainName["HarmonyMainnetShard1"] = "Harmony Mainnet Shard 1";
    ChainName["HarmonyMainnetShard2"] = "Harmony Mainnet Shard 2";
    ChainName["HarmonyMainnetShard3"] = "Harmony Mainnet Shard 3";
    ChainName["HarmonyTestnetShard0"] = "Harmony Testnet Shard 0";
    ChainName["HarmonyTestnetShard1"] = "Harmony Testnet Shard 1";
    ChainName["HarmonyDevnetShard0"] = "Harmony Devnet Shard 0";
    ChainName["HarmonyDevnetShard1"] = "Harmony Devnet Shard 1";
    ChainName["WITNESSCHAIN"] = "WITNESS CHAIN";
    ChainName["SiliconzkEVMSepoliaTestnet"] = "Silicon zkEVM Sepolia Testnet";
    ChainName["KakarotSepolia(Deprecated)"] = "Kakarot Sepolia (Deprecated)";
    ChainName["GemuchainTestnet"] = "Gemuchain Testnet";
    ChainName["RARIChainTestnet"] = "RARI Chain Testnet";
    ChainName["LumiaTestnet"] = "Lumia Testnet";
    ChainName["DataHopper"] = "DataHopper";
    ChainName["SKALEEuropaHub"] = "SKALE Europa Hub";
    ChainName["AccumulateKermit"] = "Accumulate Kermit";
    ChainName["TronShasta"] = "Tron Shasta";
    ChainName["Ancient8Testnet(deprecated)"] = "Ancient8 Testnet (deprecated)";
    ChainName["Pirl"] = "Pirl";
    ChainName["UltimaMainnet"] = "Ultima Mainnet";
    ChainName["OneLedgerTestnetFrankenstein"] = "OneLedger Testnet Frankenstein";
    ChainName["Mekong"] = "Mekong";
    ChainName["Pectra-devnet-5"] = "pectra-devnet-5";
    ChainName["ONFAChain"] = "ONFA Chain";
    ChainName["PalmTestnet"] = "Palm Testnet";
    ChainName["Palm"] = "Palm";
    ChainName["GitSwarmTestNetwork"] = "GitSwarm Test Network";
    ChainName["XaiTestnetv2"] = "Xai Testnet v2";
    ChainName["DeriwDevnet"] = "Deriw Devnet";
    ChainName["ArbitrumBlueberry"] = "Arbitrum Blueberry";
    ChainName["ALDChainTestnet"] = "ALDChain Testnet";
    ChainName["KakarotSepoliaDeprecated"] = "Kakarot Sepolia Deprecated";
    ChainName["AlphabetMainnet"] = "Alphabet Mainnet";
    ChainName["ThanosSepolia"] = "Thanos Sepolia";
    ChainName["FluenceStage"] = "Fluence Stage";
    ChainName["PIN"] = "PIN";
    ChainName["Sivo-defi-testnet"] = "sivo-defi-testnet";
    ChainName["Volmex"] = "volmex";
    ChainName["Basecamp"] = "Basecamp";
    ChainName["NtityMainnet"] = "Ntity Mainnet";
    ChainName["HaradevTestnet"] = "Haradev Testnet";
    ChainName["GMNetworkTestnet"] = "GM Network Testnet";
    ChainName["Zeniq"] = "Zeniq";
    ChainName["PDCMainnet"] = "PDC Mainnet";
    ChainName["SmartPayMobileMoney"] = "SmartPay Mobile Money";
    ChainName["MolereumNetwork"] = "Molereum Network";
    ChainName["FlameTestnet"] = "Flame Testnet";
    ChainName["Yominet"] = "Yominet";
    ChainName["GodwokenTestnet(V1)"] = "Godwoken Testnet (V1)";
    ChainName["KakarotStarknetSepolia"] = "Kakarot Starknet Sepolia";
    ChainName["DCHAINTestnet"] = "DCHAIN Testnet";
    ChainName["DCHAIN"] = "DCHAIN";
})(ChainName = exports.ChainName || (exports.ChainName = {}));
var ChainId;
(function (ChainId) {
    ChainId[ChainId["EthereumMainnet"] = 1] = "EthereumMainnet";
    ChainId[ChainId["ExpanseNetwork"] = 2] = "ExpanseNetwork";
    ChainId[ChainId["Ropsten"] = 3] = "Ropsten";
    ChainId[ChainId["Rinkeby"] = 4] = "Rinkeby";
    ChainId[ChainId["Goerli"] = 5] = "Goerli";
    ChainId[ChainId["KottiTestnet"] = 6] = "KottiTestnet";
    ChainId[ChainId["ThaiChain"] = 7] = "ThaiChain";
    ChainId[ChainId["Ubiq"] = 8] = "Ubiq";
    ChainId[ChainId["UbiqNetworkTestnet"] = 9] = "UbiqNetworkTestnet";
    ChainId[ChainId["OPMainnet"] = 10] = "OPMainnet";
    ChainId[ChainId["MetadiumMainnet"] = 11] = "MetadiumMainnet";
    ChainId[ChainId["MetadiumTestnet"] = 12] = "MetadiumTestnet";
    ChainId[ChainId["DiodeTestnetStaging"] = 13] = "DiodeTestnetStaging";
    ChainId[ChainId["FlareMainnet"] = 14] = "FlareMainnet";
    ChainId[ChainId["DiodePrenet"] = 15] = "DiodePrenet";
    ChainId[ChainId["SongbirdTestnetCoston"] = 16] = "SongbirdTestnetCoston";
    ChainId[ChainId["ThaiChain2.0ThaiFi"] = 17] = "ThaiChain2.0ThaiFi";
    ChainId[ChainId["ThunderCoreTestnet"] = 18] = "ThunderCoreTestnet";
    ChainId[ChainId["SongbirdCanary-Network"] = 19] = "SongbirdCanary-Network";
    ChainId[ChainId["ElastosSmartChain"] = 20] = "ElastosSmartChain";
    ChainId[ChainId["ElastosSmartChainTestnet"] = 21] = "ElastosSmartChainTestnet";
    ChainId[ChainId["ELA-DID-SidechainMainnet"] = 22] = "ELA-DID-SidechainMainnet";
    ChainId[ChainId["ELA-DID-SidechainTestnet"] = 23] = "ELA-DID-SidechainTestnet";
    ChainId[ChainId["KardiaChainMainnet"] = 24] = "KardiaChainMainnet";
    ChainId[ChainId["CronosMainnet"] = 25] = "CronosMainnet";
    ChainId[ChainId["GenesisL1testnet"] = 26] = "GenesisL1testnet";
    ChainId[ChainId["ShibaChain"] = 27] = "ShibaChain";
    ChainId[ChainId["BobaNetworkRinkebyTestnet"] = 28] = "BobaNetworkRinkebyTestnet";
    ChainId[ChainId["GenesisL1"] = 29] = "GenesisL1";
    ChainId[ChainId["RootstockMainnet"] = 30] = "RootstockMainnet";
    ChainId[ChainId["RootstockTestnet"] = 31] = "RootstockTestnet";
    ChainId[ChainId["GoodDataTestnet"] = 32] = "GoodDataTestnet";
    ChainId[ChainId["GoodDataMainnet"] = 33] = "GoodDataMainnet";
    ChainId[ChainId["SecureChainMainnet"] = 34] = "SecureChainMainnet";
    ChainId[ChainId["TBWGChain"] = 35] = "TBWGChain";
    ChainId[ChainId["DxchainMainnet"] = 36] = "DxchainMainnet";
    ChainId[ChainId["XplaMainnet"] = 37] = "XplaMainnet";
    ChainId[ChainId["Valorbit"] = 38] = "Valorbit";
    ChainId[ChainId["U2USolarisMainnet"] = 39] = "U2USolarisMainnet";
    ChainId[ChainId["TelosEVMMainnet"] = 40] = "TelosEVMMainnet";
    ChainId[ChainId["TelosEVMTestnet"] = 41] = "TelosEVMTestnet";
    ChainId[ChainId["LUKSOMainnet"] = 42] = "LUKSOMainnet";
    ChainId[ChainId["DarwiniaPangolinTestnet"] = 43] = "DarwiniaPangolinTestnet";
    ChainId[ChainId["CrabNetwork"] = 44] = "CrabNetwork";
    ChainId[ChainId["DarwiniaPangoroTestnet"] = 45] = "DarwiniaPangoroTestnet";
    ChainId[ChainId["DarwiniaNetwork"] = 46] = "DarwiniaNetwork";
    ChainId[ChainId["AcriaIntelliChain"] = 47] = "AcriaIntelliChain";
    ChainId[ChainId["EnnothemMainnetProterozoic"] = 48] = "EnnothemMainnetProterozoic";
    ChainId[ChainId["EnnothemTestnetPioneer"] = 49] = "EnnothemTestnetPioneer";
    ChainId[ChainId["XDCNetwork"] = 50] = "XDCNetwork";
    ChainId[ChainId["XDCApothemNetwork"] = 51] = "XDCApothemNetwork";
    ChainId[ChainId["CoinExSmartChainMainnet"] = 52] = "CoinExSmartChainMainnet";
    ChainId[ChainId["CoinExSmartChainTestnet"] = 53] = "CoinExSmartChainTestnet";
    ChainId[ChainId["OpenpieceMainnet"] = 54] = "OpenpieceMainnet";
    ChainId[ChainId["ZyxMainnet"] = 55] = "ZyxMainnet";
    ChainId[ChainId["BNBSmartChainMainnet"] = 56] = "BNBSmartChainMainnet";
    ChainId[ChainId["SyscoinMainnet"] = 57] = "SyscoinMainnet";
    ChainId[ChainId["OntologyMainnet"] = 58] = "OntologyMainnet";
    ChainId[ChainId["EOSEVMLegacy"] = 59] = "EOSEVMLegacy";
    ChainId[ChainId["GoChain"] = 60] = "GoChain";
    ChainId[ChainId["EthereumClassic"] = 61] = "EthereumClassic";
    ChainId[ChainId["MordenTestnet"] = 62] = "MordenTestnet";
    ChainId[ChainId["MordorTestnet"] = 63] = "MordorTestnet";
    ChainId[ChainId["Ellaism"] = 64] = "Ellaism";
    ChainId[ChainId["OKExChainTestnet"] = 65] = "OKExChainTestnet";
    ChainId[ChainId["OKXChainMainnet"] = 66] = "OKXChainMainnet";
    ChainId[ChainId["DBChainTestnet"] = 67] = "DBChainTestnet";
    ChainId[ChainId["SoterOneMainnet"] = 68] = "SoterOneMainnet";
    ChainId[ChainId["OptimismKovan"] = 69] = "OptimismKovan";
    ChainId[ChainId["HooSmartChain"] = 70] = "HooSmartChain";
    ChainId[ChainId["ConfluxeSpace(Testnet)"] = 71] = "ConfluxeSpace(Testnet)";
    ChainId[ChainId["DxChainTestnet"] = 72] = "DxChainTestnet";
    ChainId[ChainId["FNCY"] = 73] = "FNCY";
    ChainId[ChainId["IDChainMainnet"] = 74] = "IDChainMainnet";
    ChainId[ChainId["DecimalSmartChainMainnet"] = 75] = "DecimalSmartChainMainnet";
    ChainId[ChainId["Mix"] = 76] = "Mix";
    ChainId[ChainId["POANetworkSokol"] = 77] = "POANetworkSokol";
    ChainId[ChainId["PrimusChainmainnet"] = 78] = "PrimusChainmainnet";
    ChainId[ChainId["ZenithMainnet"] = 79] = "ZenithMainnet";
    ChainId[ChainId["GeneChain"] = 80] = "GeneChain";
    ChainId[ChainId["JapanOpenChainMainnet"] = 81] = "JapanOpenChainMainnet";
    ChainId[ChainId["MeterMainnet"] = 82] = "MeterMainnet";
    ChainId[ChainId["MeterTestnet"] = 83] = "MeterTestnet";
    ChainId[ChainId["LinqtoDevnet"] = 84] = "LinqtoDevnet";
    ChainId[ChainId["GateChainTestnet"] = 85] = "GateChainTestnet";
    ChainId[ChainId["GateChainMainnet"] = 86] = "GateChainMainnet";
    ChainId[ChainId["NovaNetwork"] = 87] = "NovaNetwork";
    ChainId[ChainId["Viction"] = 88] = "Viction";
    ChainId[ChainId["VictionTestnet"] = 89] = "VictionTestnet";
    ChainId[ChainId["GarizonStage0"] = 90] = "GarizonStage0";
    ChainId[ChainId["GarizonStage1"] = 91] = "GarizonStage1";
    ChainId[ChainId["GarizonStage2"] = 92] = "GarizonStage2";
    ChainId[ChainId["GarizonStage3"] = 93] = "GarizonStage3";
    ChainId[ChainId["SwissDLT"] = 94] = "SwissDLT";
    ChainId[ChainId["CamDLMainnet"] = 95] = "CamDLMainnet";
    ChainId[ChainId["KUBMainnet"] = 96] = "KUBMainnet";
    ChainId[ChainId["BNBSmartChainTestnet"] = 97] = "BNBSmartChainTestnet";
    ChainId[ChainId["SixProtocol"] = 98] = "SixProtocol";
    ChainId[ChainId["POANetworkCore"] = 99] = "POANetworkCore";
    ChainId[ChainId["Gnosis"] = 100] = "Gnosis";
    ChainId[ChainId["EtherInc"] = 101] = "EtherInc";
    ChainId[ChainId["Web3GamesTestnet"] = 102] = "Web3GamesTestnet";
    ChainId[ChainId["WorldLandMainnet"] = 103] = "WorldLandMainnet";
    ChainId[ChainId["KaibaLightningChainTestnet"] = 104] = "KaibaLightningChainTestnet";
    ChainId[ChainId["Web3GamesDevnet"] = 105] = "Web3GamesDevnet";
    ChainId[ChainId["VelasEVMMainnet"] = 106] = "VelasEVMMainnet";
    ChainId[ChainId["NebulaTestnet"] = 107] = "NebulaTestnet";
    ChainId[ChainId["ThunderCoreMainnet"] = 108] = "ThunderCoreMainnet";
    ChainId[ChainId["Shibarium"] = 109] = "Shibarium";
    ChainId[ChainId["ProtonTestnet"] = 110] = "ProtonTestnet";
    ChainId[ChainId["EtherLiteChain"] = 111] = "EtherLiteChain";
    ChainId[ChainId["CoinbitMainnet"] = 112] = "CoinbitMainnet";
    ChainId[ChainId["Dehvo"] = 113] = "Dehvo";
    ChainId[ChainId["FlareTestnetCoston2"] = 114] = "FlareTestnetCoston2";
    ChainId[ChainId["DeBankTestnet(Deprecated)"] = 115] = "DeBankTestnet(Deprecated)";
    ChainId[ChainId["DeBankMainnet"] = 116] = "DeBankMainnet";
    ChainId[ChainId["UptickMainnet"] = 117] = "UptickMainnet";
    ChainId[ChainId["ArcologyTestnet"] = 118] = "ArcologyTestnet";
    ChainId[ChainId["ENULSMainnet"] = 119] = "ENULSMainnet";
    ChainId[ChainId["ENULSTestnet"] = 120] = "ENULSTestnet";
    ChainId[ChainId["RealchainMainnet"] = 121] = "RealchainMainnet";
    ChainId[ChainId["FuseMainnet"] = 122] = "FuseMainnet";
    ChainId[ChainId["FuseSparknet"] = 123] = "FuseSparknet";
    ChainId[ChainId["DecentralizedWebMainnet"] = 124] = "DecentralizedWebMainnet";
    ChainId[ChainId["OYchainTestnet"] = 125] = "OYchainTestnet";
    ChainId[ChainId["OYchainMainnet"] = 126] = "OYchainMainnet";
    ChainId[ChainId["Factory127Mainnet"] = 127] = "Factory127Mainnet";
    ChainId[ChainId["HuobiECOChainMainnet"] = 128] = "HuobiECOChainMainnet";
    ChainId[ChainId["InnovatorChain"] = 129] = "InnovatorChain";
    ChainId[ChainId["Unichain"] = 130] = "Unichain";
    ChainId[ChainId["EngramTestnet"] = 131] = "EngramTestnet";
    ChainId[ChainId["NamefiChainMainnet"] = 132] = "NamefiChainMainnet";
    ChainId[ChainId["HashKeyChainTestnet"] = 133] = "HashKeyChainTestnet";
    ChainId[ChainId["IExecSidechain"] = 134] = "IExecSidechain";
    ChainId[ChainId["AlyxChainTestnet"] = 135] = "AlyxChainTestnet";
    ChainId[ChainId["DeamchainMainnet"] = 136] = "DeamchainMainnet";
    ChainId[ChainId["PolygonMainnet"] = 137] = "PolygonMainnet";
    ChainId[ChainId["DefiOracleMetaMainnet"] = 138] = "DefiOracleMetaMainnet";
    ChainId[ChainId["WoopChainMainnet"] = 139] = "WoopChainMainnet";
    ChainId[ChainId["EternalMainnet"] = 140] = "EternalMainnet";
    ChainId[ChainId["OpenpieceTestnet"] = 141] = "OpenpieceTestnet";
    ChainId[ChainId["DAXCHAIN"] = 142] = "DAXCHAIN";
    ChainId[ChainId["MonadMainnet"] = 143] = "MonadMainnet";
    ChainId[ChainId["PHINetworkv2"] = 144] = "PHINetworkv2";
    ChainId[ChainId["SoraAITestnet"] = 145] = "SoraAITestnet";
    ChainId[ChainId["SonicMainnet"] = 146] = "SonicMainnet";
    ChainId[ChainId["FlagMainnet"] = 147] = "FlagMainnet";
    ChainId[ChainId["ShimmerEVM"] = 148] = "ShimmerEVM";
    ChainId[ChainId["SixProtocolTestnet"] = 150] = "SixProtocolTestnet";
    ChainId[ChainId["RedbellyNetworkMainnet"] = 151] = "RedbellyNetworkMainnet";
    ChainId[ChainId["RedbellyNetworkDevnet"] = 152] = "RedbellyNetworkDevnet";
    ChainId[ChainId["RedbellyNetworkTestnet"] = 153] = "RedbellyNetworkTestnet";
    ChainId[ChainId["RedbellyNetworkTGE"] = 154] = "RedbellyNetworkTGE";
    ChainId[ChainId["TenetTestnet"] = 155] = "TenetTestnet";
    ChainId[ChainId["OEBlockTestnet"] = 156] = "OEBlockTestnet";
    ChainId[ChainId["Puppynet"] = 157] = "Puppynet";
    ChainId[ChainId["RoburnaMainnet"] = 158] = "RoburnaMainnet";
    ChainId[ChainId["RoburnaTestnet"] = 159] = "RoburnaTestnet";
    ChainId[ChainId["ArmoniaEvaChainMainnet"] = 160] = "ArmoniaEvaChainMainnet";
    ChainId[ChainId["ArmoniaEvaChainTestnet"] = 161] = "ArmoniaEvaChainTestnet";
    ChainId[ChainId["LightstreamsTestnet"] = 162] = "LightstreamsTestnet";
    ChainId[ChainId["LightstreamsMainnet"] = 163] = "LightstreamsMainnet";
    ChainId[ChainId["OmniOmegaTestnet"] = 164] = "OmniOmegaTestnet";
    ChainId[ChainId["OmniTestnet(Deprecated)"] = 165] = "OmniTestnet(Deprecated)";
    ChainId[ChainId["Omni"] = 166] = "Omni";
    ChainId[ChainId["AtoshiTestnet"] = 167] = "AtoshiTestnet";
    ChainId[ChainId["AIOZNetwork"] = 168] = "AIOZNetwork";
    ChainId[ChainId["MantaPacificMainnet"] = 169] = "MantaPacificMainnet";
    ChainId[ChainId["HOOSmartChainTestnet"] = 170] = "HOOSmartChainTestnet";
    ChainId[ChainId["CO2eChain"] = 171] = "CO2eChain";
    ChainId[ChainId["Latam-BlockchainResilTestnet"] = 172] = "Latam-BlockchainResilTestnet";
    ChainId[ChainId["OTC"] = 175] = "OTC";
    ChainId[ChainId["DCMainnet"] = 176] = "DCMainnet";
    ChainId[ChainId["HashKeyChain"] = 177] = "HashKeyChain";
    ChainId[ChainId["ABEYTestnet"] = 178] = "ABEYTestnet";
    ChainId[ChainId["ABEYMainnet"] = 179] = "ABEYMainnet";
    ChainId[ChainId["AMEChainMainnet"] = 180] = "AMEChainMainnet";
    ChainId[ChainId["WaterfallNetwork"] = 181] = "WaterfallNetwork";
    ChainId[ChainId["IOSTMainnet"] = 182] = "IOSTMainnet";
    ChainId[ChainId["Ethernity"] = 183] = "Ethernity";
    ChainId[ChainId["DojimaTestnet"] = 184] = "DojimaTestnet";
    ChainId[ChainId["MintMainnet"] = 185] = "MintMainnet";
    ChainId[ChainId["SeeleMainnet"] = 186] = "SeeleMainnet";
    ChainId[ChainId["Dojima"] = 187] = "Dojima";
    ChainId[ChainId["BMCMainnet"] = 188] = "BMCMainnet";
    ChainId[ChainId["BMCTestnet"] = 189] = "BMCTestnet";
    ChainId[ChainId["CMDAOBBQChain"] = 190] = "CMDAOBBQChain";
    ChainId[ChainId["FileFileGo"] = 191] = "FileFileGo";
    ChainId[ChainId["CryptoEmergency"] = 193] = "CryptoEmergency";
    ChainId[ChainId["Firachain"] = 194] = "Firachain";
    ChainId[ChainId["XLayerTestnet"] = 195] = "XLayerTestnet";
    ChainId[ChainId["XLayerMainnet"] = 196] = "XLayerMainnet";
    ChainId[ChainId["NeutrinosTestNet"] = 197] = "NeutrinosTestNet";
    ChainId[ChainId["BitchainMainnet"] = 198] = "BitchainMainnet";
    ChainId[ChainId["BitTorrentChainMainnet"] = 199] = "BitTorrentChainMainnet";
    ChainId[ChainId["ArbitrumonxDai"] = 200] = "ArbitrumonxDai";
    ChainId[ChainId["MOACtestnet"] = 201] = "MOACtestnet";
    ChainId[ChainId["EdgelessTestnet"] = 202] = "EdgelessTestnet";
    ChainId[ChainId["WowChainMainnet"] = 203] = "WowChainMainnet";
    ChainId[ChainId["OpBNBMainnet"] = 204] = "OpBNBMainnet";
    ChainId[ChainId["EKAASH"] = 205] = "EKAASH";
    ChainId[ChainId["VinuChainTestnet"] = 206] = "VinuChainTestnet";
    ChainId[ChainId["VinuChainNetwork"] = 207] = "VinuChainNetwork";
    ChainId[ChainId["StructxMainnet"] = 208] = "StructxMainnet";
    ChainId[ChainId["Bitnet"] = 210] = "Bitnet";
    ChainId[ChainId["FreightTrustNetwork"] = 211] = "FreightTrustNetwork";
    ChainId[ChainId["MAPOMakalu"] = 212] = "MAPOMakalu";
    ChainId[ChainId["B2HubMainnet"] = 213] = "B2HubMainnet";
    ChainId[ChainId["ShinariumMainnet"] = 214] = "ShinariumMainnet";
    ChainId[ChainId["IDNMainnet"] = 215] = "IDNMainnet";
    ChainId[ChainId["HappychainTestnet"] = 216] = "HappychainTestnet";
    ChainId[ChainId["SiriusNetV2"] = 217] = "SiriusNetV2";
    ChainId[ChainId["SoterOneMainnetold"] = 218] = "SoterOneMainnetold";
    ChainId[ChainId["ScalindTestnet"] = 220] = "ScalindTestnet";
    ChainId[ChainId["BlockExMainnet"] = 221] = "BlockExMainnet";
    ChainId[ChainId["Permission"] = 222] = "Permission";
    ChainId[ChainId["B2Mainnet"] = 223] = "B2Mainnet";
    ChainId[ChainId["ViridisTestnet"] = 224] = "ViridisTestnet";
    ChainId[ChainId["LACHAINMainnet"] = 225] = "LACHAINMainnet";
    ChainId[ChainId["LACHAINTestnet"] = 226] = "LACHAINTestnet";
    ChainId[ChainId["Prom"] = 227] = "Prom";
    ChainId[ChainId["MindNetworkMainnet"] = 228] = "MindNetworkMainnet";
    ChainId[ChainId["SwapDEX"] = 230] = "SwapDEX";
    ChainId[ChainId["Lens"] = 232] = "Lens";
    ChainId[ChainId["EthernityTestnet"] = 233] = "EthernityTestnet";
    ChainId[ChainId["ProtoJumboTestnet"] = 234] = "ProtoJumboTestnet";
    ChainId[ChainId["DeamchainTestnet"] = 236] = "DeamchainTestnet";
    ChainId[ChainId["BlastMainnet"] = 238] = "BlastMainnet";
    ChainId[ChainId["TACMainnet"] = 239] = "TACMainnet";
    ChainId[ChainId["CronoszkEVMTestnet"] = 240] = "CronoszkEVMTestnet";
    ChainId[ChainId["PlingaMainnet"] = 242] = "PlingaMainnet";
    ChainId[ChainId["EnergyWebChain"] = 246] = "EnergyWebChain";
    ChainId[ChainId["ChooChain"] = 247] = "ChooChain";
    ChainId[ChainId["OasysMainnet"] = 248] = "OasysMainnet";
    ChainId[ChainId["FantomOpera"] = 250] = "FantomOpera";
    ChainId[ChainId["GlideL1ProtocolXP"] = 251] = "GlideL1ProtocolXP";
    ChainId[ChainId["Fraxtal"] = 252] = "Fraxtal";
    ChainId[ChainId["GlideL2ProtocolXP"] = 253] = "GlideL2ProtocolXP";
    ChainId[ChainId["SwanChainMainnet"] = 254] = "SwanChainMainnet";
    ChainId[ChainId["Kroma"] = 255] = "Kroma";
    ChainId[ChainId["HuobiECOChainTestnet"] = 256] = "HuobiECOChainTestnet";
    ChainId[ChainId["Setheum"] = 258] = "Setheum";
    ChainId[ChainId["NeonlinkMainnet"] = 259] = "NeonlinkMainnet";
    ChainId[ChainId["GuruNetwork"] = 260] = "GuruNetwork";
    ChainId[ChainId["GuruNetworkTestnet"] = 261] = "GuruNetworkTestnet";
    ChainId[ChainId["SURBlockchainNetwork"] = 262] = "SURBlockchainNetwork";
    ChainId[ChainId["Neura"] = 266] = "Neura";
    ChainId[ChainId["NeuraTestnet"] = 267] = "NeuraTestnet";
    ChainId[ChainId["NeuraDevnet"] = 268] = "NeuraDevnet";
    ChainId[ChainId["HighPerformanceBlockchain"] = 269] = "HighPerformanceBlockchain";
    ChainId[ChainId["EgonCoinMainnet"] = 271] = "EgonCoinMainnet";
    ChainId[ChainId["XROne"] = 273] = "XROne";
    ChainId[ChainId["LaChain"] = 274] = "LaChain";
    ChainId[ChainId["XFair.AIMainnet"] = 278] = "XFair.AIMainnet";
    ChainId[ChainId["BPXChain"] = 279] = "BPXChain";
    ChainId[ChainId["ZkSyncEraGoerliTestnet(deprecated)"] = 280] = "ZkSyncEraGoerliTestnet(deprecated)";
    ChainId[ChainId["DeprecatedCronoszkEVMTestnet"] = 282] = "DeprecatedCronoszkEVMTestnet";
    ChainId[ChainId["BobaNetwork"] = 288] = "BobaNetwork";
    ChainId[ChainId["OrderlyMainnet"] = 291] = "OrderlyMainnet";
    ChainId[ChainId["DaVinci"] = 293] = "DaVinci";
    ChainId[ChainId["HederaMainnet"] = 295] = "HederaMainnet";
    ChainId[ChainId["HederaTestnet"] = 296] = "HederaTestnet";
    ChainId[ChainId["HederaPreviewnet"] = 297] = "HederaPreviewnet";
    ChainId[ChainId["HederaLocalnet"] = 298] = "HederaLocalnet";
    ChainId[ChainId["ZkSyncSepoliaTestnet"] = 300] = "ZkSyncSepoliaTestnet";
    ChainId[ChainId["Bobaopera"] = 301] = "Bobaopera";
    ChainId[ChainId["ZKcandySepoliaTestnet"] = 302] = "ZKcandySepoliaTestnet";
    ChainId[ChainId["NeurochainTestnet"] = 303] = "NeurochainTestnet";
    ChainId[ChainId["ZKSatsMainnet"] = 305] = "ZKSatsMainnet";
    ChainId[ChainId["LovelyNetworkTestnet"] = 307] = "LovelyNetworkTestnet";
    ChainId[ChainId["Furtheon"] = 308] = "Furtheon";
    ChainId[ChainId["WyzthTestnet"] = 309] = "WyzthTestnet";
    ChainId[ChainId["OmaxMainnet"] = 311] = "OmaxMainnet";
    ChainId[ChainId["NeurochainMainnet"] = 313] = "NeurochainMainnet";
    ChainId[ChainId["Filecoin-Mainnet"] = 314] = "Filecoin-Mainnet";
    ChainId[ChainId["WorldEcoMoney"] = 315] = "WorldEcoMoney";
    ChainId[ChainId["ZKcandyMainnet"] = 320] = "ZKcandyMainnet";
    ChainId[ChainId["KCCMainnet"] = 321] = "KCCMainnet";
    ChainId[ChainId["KCCTestnet"] = 322] = "KCCTestnet";
    ChainId[ChainId["CosvmMainnet"] = 323] = "CosvmMainnet";
    ChainId[ChainId["ZkSyncMainnet"] = 324] = "ZkSyncMainnet";
    ChainId[ChainId["GRVTExchange"] = 325] = "GRVTExchange";
    ChainId[ChainId["GRVTExchangeTestnet"] = 326] = "GRVTExchangeTestnet";
    ChainId[ChainId["TeloszkEVMTestnet"] = 331] = "TeloszkEVMTestnet";
    ChainId[ChainId["OmaxTestnet"] = 332] = "OmaxTestnet";
    ChainId[ChainId["Web3QMainnet"] = 333] = "Web3QMainnet";
    ChainId[ChainId["DFKChainTest"] = 335] = "DFKChainTest";
    ChainId[ChainId["Shiden"] = 336] = "Shiden";
    ChainId[ChainId["R5Network"] = 337] = "R5Network";
    ChainId[ChainId["CronosTestnet"] = 338] = "CronosTestnet";
    ChainId[ChainId["PencilsProtocol"] = 339] = "PencilsProtocol";
    ChainId[ChainId["TSCMainnet"] = 345] = "TSCMainnet";
    ChainId[ChainId["Shape"] = 360] = "Shape";
    ChainId[ChainId["ThetaMainnet"] = 361] = "ThetaMainnet";
    ChainId[ChainId["ThetaSapphireTestnet"] = 363] = "ThetaSapphireTestnet";
    ChainId[ChainId["ThetaAmberTestnet"] = 364] = "ThetaAmberTestnet";
    ChainId[ChainId["ThetaTestnet"] = 365] = "ThetaTestnet";
    ChainId[ChainId["PulseChain"] = 369] = "PulseChain";
    ChainId[ChainId["ConstaTestnet"] = 371] = "ConstaTestnet";
    ChainId[ChainId["ZKAmoebaTestnet"] = 380] = "ZKAmoebaTestnet";
    ChainId[ChainId["ZKAmoebaMainnet"] = 381] = "ZKAmoebaMainnet";
    ChainId[ChainId["Lisinski"] = 385] = "Lisinski";
    ChainId[ChainId["CronoszkEVMMainnet"] = 388] = "CronoszkEVMMainnet";
    ChainId[ChainId["CamDLTestnet"] = 395] = "CamDLTestnet";
    ChainId[ChainId["NEARProtocol"] = 397] = "NEARProtocol";
    ChainId[ChainId["NEARProtocolTestnet"] = 398] = "NEARProtocolTestnet";
    ChainId[ChainId["Nativ3Mainnet"] = 399] = "Nativ3Mainnet";
    ChainId[ChainId["HyperonChainTestNet"] = 400] = "HyperonChainTestNet";
    ChainId[ChainId["OzoneChainTestnet"] = 401] = "OzoneChainTestnet";
    ChainId[ChainId["SyndrL3"] = 404] = "SyndrL3";
    ChainId[ChainId["PepeChainMainnet"] = 411] = "PepeChainMainnet";
    ChainId[ChainId["SXNetworkMainnet"] = 416] = "SXNetworkMainnet";
    ChainId[ChainId["LaTestnet"] = 418] = "LaTestnet";
    ChainId[ChainId["OptimismGoerliTestnet"] = 420] = "OptimismGoerliTestnet";
    ChainId[ChainId["ViridisMainnet"] = 422] = "ViridisMainnet";
    ChainId[ChainId["PGN(PublicGoodsNetwork)"] = 424] = "PGN(PublicGoodsNetwork)";
    ChainId[ChainId["StenixMainnet"] = 425] = "StenixMainnet";
    ChainId[ChainId["TheWidowsMite"] = 426] = "TheWidowsMite";
    ChainId[ChainId["ZeethChain"] = 427] = "ZeethChain";
    ChainId[ChainId["GesoVerse"] = 428] = "GesoVerse";
    ChainId[ChainId["BoyaaMainnet"] = 434] = "BoyaaMainnet";
    ChainId[ChainId["TenTestnet"] = 443] = "TenTestnet";
    ChainId[ChainId["SynapseChainTestnet"] = 444] = "SynapseChainTestnet";
    ChainId[ChainId["ARZIOChain"] = 456] = "ARZIOChain";
    ChainId[ChainId["AreonNetworkTestnet"] = 462] = "AreonNetworkTestnet";
    ChainId[ChainId["AreonNetworkMainnet"] = 463] = "AreonNetworkMainnet";
    ChainId[ChainId["AppChain"] = 466] = "AppChain";
    ChainId[ChainId["FormNetwork"] = 478] = "FormNetwork";
    ChainId[ChainId["WorldChain"] = 480] = "WorldChain";
    ChainId[ChainId["StandardMainnet"] = 486] = "StandardMainnet";
    ChainId[ChainId["BlackFortExchangeNetwork"] = 488] = "BlackFortExchangeNetwork";
    ChainId[ChainId["Landstars"] = 495] = "Landstars";
    ChainId[ChainId["Rupaya"] = 499] = "Rupaya";
    ChainId[ChainId["CaminoC-Chain"] = 500] = "CaminoC-Chain";
    ChainId[ChainId["ColumbusTestNetwork"] = 501] = "ColumbusTestNetwork";
    ChainId[ChainId["SyndicateChain"] = 510] = "SyndicateChain";
    ChainId[ChainId["Double-AChainMainnet"] = 512] = "Double-AChainMainnet";
    ChainId[ChainId["Double-AChainTestnet"] = 513] = "Double-AChainTestnet";
    ChainId[ChainId["GearZeroNetworkMainnet"] = 516] = "GearZeroNetworkMainnet";
    ChainId[ChainId["XTSmartChainMainnet"] = 520] = "XTSmartChainMainnet";
    ChainId[ChainId["FirechainMainnet"] = 529] = "FirechainMainnet";
    ChainId[ChainId["PundiAIFXOmnilayer"] = 530] = "PundiAIFXOmnilayer";
    ChainId[ChainId["Candle"] = 534] = "Candle";
    ChainId[ChainId["OpTrustMainnet"] = 537] = "OpTrustMainnet";
    ChainId[ChainId["PAWCHAINTestnet"] = 542] = "PAWCHAINTestnet";
    ChainId[ChainId["FlowEVMTestnet"] = 545] = "FlowEVMTestnet";
    ChainId[ChainId["River"] = 550] = "River";
    ChainId[ChainId["Vela1ChainMainnet"] = 555] = "Vela1ChainMainnet";
    ChainId[ChainId["TaoNetwork"] = 558] = "TaoNetwork";
    ChainId[ChainId["PrometheuzTestnet"] = 565] = "PrometheuzTestnet";
    ChainId[ChainId["DogechainTestnet"] = 568] = "DogechainTestnet";
    ChainId[ChainId["RolluxMainnet"] = 570] = "RolluxMainnet";
    ChainId[ChainId["MetaChainMainnet"] = 571] = "MetaChainMainnet";
    ChainId[ChainId["FilenovaMainnet"] = 579] = "FilenovaMainnet";
    ChainId[ChainId["MetisStardustTestnet"] = 588] = "MetisStardustTestnet";
    ChainId[ChainId["Astar"] = 592] = "Astar";
    ChainId[ChainId["AcalaMandalaTestnetTC9"] = 595] = "AcalaMandalaTestnetTC9";
    ChainId[ChainId["KaruraNetworkTestnet"] = 596] = "KaruraNetworkTestnet";
    ChainId[ChainId["AcalaNetworkTestnet"] = 597] = "AcalaNetworkTestnet";
    ChainId[ChainId["MetisGoerliTestnet"] = 599] = "MetisGoerliTestnet";
    ChainId[ChainId["Meshnyantestnet"] = 600] = "Meshnyantestnet";
    ChainId[ChainId["VineTestnet"] = 601] = "VineTestnet";
    ChainId[ChainId["DarwinDevnet"] = 610] = "DarwinDevnet";
    ChainId[ChainId["EIOBMainnet"] = 612] = "EIOBMainnet";
    ChainId[ChainId["GraphlinqBlockchainMainnet"] = 614] = "GraphlinqBlockchainMainnet";
    ChainId[ChainId["Skynet"] = 619] = "Skynet";
    ChainId[ChainId["BinaryMainnet"] = 624] = "BinaryMainnet";
    ChainId[ChainId["BinarySepolia"] = 625] = "BinarySepolia";
    ChainId[ChainId["NFBChain"] = 632] = "NFBChain";
    ChainId[ChainId["Avocado"] = 634] = "Avocado";
    ChainId[ChainId["FlowEVMPreviewnet"] = 646] = "FlowEVMPreviewnet";
    ChainId[ChainId["SXNetworkTestnet"] = 647] = "SXNetworkTestnet";
    ChainId[ChainId["EnduranceSmartChainMainnet"] = 648] = "EnduranceSmartChainMainnet";
    ChainId[ChainId["KalichainTestnet"] = 653] = "KalichainTestnet";
    ChainId[ChainId["Kalichain"] = 654] = "Kalichain";
    ChainId[ChainId["AmaxSmartchain"] = 662] = "AmaxSmartchain";
    ChainId[ChainId["PixieChainTestnet"] = 666] = "PixieChainTestnet";
    ChainId[ChainId["LAOSArrakis"] = 667] = "LAOSArrakis";
    ChainId[ChainId["JuncaChain"] = 668] = "JuncaChain";
    ChainId[ChainId["JuncaChaintestnet"] = 669] = "JuncaChaintestnet";
    ChainId[ChainId["Janction"] = 678] = "Janction";
    ChainId[ChainId["JanctionTestnet"] = 679] = "JanctionTestnet";
    ChainId[ChainId["KaruraNetwork"] = 686] = "KaruraNetwork";
    ChainId[ChainId["NEROTestnet"] = 689] = "NEROTestnet";
    ChainId[ChainId["Redstone"] = 690] = "Redstone";
    ChainId[ChainId["Matchain"] = 698] = "Matchain";
    ChainId[ChainId["MatchainTestnet"] = 699] = "MatchainTestnet";
    ChainId[ChainId["StarSocialTestnet"] = 700] = "StarSocialTestnet";
    ChainId[ChainId["DarwiniaKoiTestnet"] = 701] = "DarwiniaKoiTestnet";
    ChainId[ChainId["BlockChainStationMainnet"] = 707] = "BlockChainStationMainnet";
    ChainId[ChainId["BlockChainStationTestnet"] = 708] = "BlockChainStationTestnet";
    ChainId[ChainId["Highbury"] = 710] = "Highbury";
    ChainId[ChainId["Tucana"] = 711] = "Tucana";
    ChainId[ChainId["Birdee-2"] = 712] = "Birdee-2";
    ChainId[ChainId["VrcscanMainnet"] = 713] = "VrcscanMainnet";
    ChainId[ChainId["UXLINKONEMainnet"] = 718] = "UXLINKONEMainnet";
    ChainId[ChainId["ShibariumBeta"] = 719] = "ShibariumBeta";
    ChainId[ChainId["LycanChain"] = 721] = "LycanChain";
    ChainId[ChainId["Blucrates"] = 727] = "Blucrates";
    ChainId[ChainId["LovelyNetworkMainnet"] = 730] = "LovelyNetworkMainnet";
    ChainId[ChainId["CantoTestnet"] = 740] = "CantoTestnet";
    ChainId[ChainId["VentionSmartChainTestnet"] = 741] = "VentionSmartChainTestnet";
    ChainId[ChainId["ScriptTestnet"] = 742] = "ScriptTestnet";
    ChainId[ChainId["TranchedMainnet"] = 743] = "TranchedMainnet";
    ChainId[ChainId["FlowEVMMainnet"] = 747] = "FlowEVMMainnet";
    ChainId[ChainId["Rivalz"] = 753] = "Rivalz";
    ChainId[ChainId["QL1"] = 766] = "QL1";
    ChainId[ChainId["OpenChainTestnet"] = 776] = "OpenChainTestnet";
    ChainId[ChainId["CheapETH"] = 777] = "CheapETH";
    ChainId[ChainId["AUTHEOTestnet"] = 785] = "AUTHEOTestnet";
    ChainId[ChainId["MAALChain"] = 786] = "MAALChain";
    ChainId[ChainId["AcalaNetwork"] = 787] = "AcalaNetwork";
    ChainId[ChainId["AerochainTestnet"] = 788] = "AerochainTestnet";
    ChainId[ChainId["Patex"] = 789] = "Patex";
    ChainId[ChainId["RupayaTestnet"] = 799] = "RupayaTestnet";
    ChainId[ChainId["LucidBlockchain"] = 800] = "LucidBlockchain";
    ChainId[ChainId["Haic"] = 803] = "Haic";
    ChainId[ChainId["EvozMainnet"] = 805] = "EvozMainnet";
    ChainId[ChainId["PortalFantasyChainTest"] = 808] = "PortalFantasyChainTest";
    ChainId[ChainId["Haven1Testnet"] = 810] = "Haven1Testnet";
    ChainId[ChainId["QitmeerNetworkMainnet"] = 813] = "QitmeerNetworkMainnet";
    ChainId[ChainId["FirechainzkEVM"] = 814] = "FirechainzkEVM";
    ChainId[ChainId["BeOneChainMainnet"] = 818] = "BeOneChainMainnet";
    ChainId[ChainId["CallistoMainnet"] = 820] = "CallistoMainnet";
    ChainId[ChainId["CallistoTestnetDeprecated"] = 821] = "CallistoTestnetDeprecated";
    ChainId[ChainId["RunicChainTestnet"] = 822] = "RunicChainTestnet";
    ChainId[ChainId["DailyNetworkMainnet"] = 824] = "DailyNetworkMainnet";
    ChainId[ChainId["DailyNetworkTestnet"] = 825] = "DailyNetworkTestnet";
    ChainId[ChainId["CheckDotBlockchainDevnet"] = 831] = "CheckDotBlockchainDevnet";
    ChainId[ChainId["TaraxaMainnet"] = 841] = "TaraxaMainnet";
    ChainId[ChainId["TaraxaTestnet"] = 842] = "TaraxaTestnet";
    ChainId[ChainId["HongKongMainnet"] = 852] = "HongKongMainnet";
    ChainId[ChainId["ZeethChainDev"] = 859] = "ZeethChainDev";
    ChainId[ChainId["ElectraNetwork"] = 861] = "ElectraNetwork";
    ChainId[ChainId["RadiusTestnet"] = 863] = "RadiusTestnet";
    ChainId[ChainId["FantasiaChainMainnet"] = 868] = "FantasiaChainMainnet";
    ChainId[ChainId["ElectraTestNetwork"] = 871] = "ElectraTestNetwork";
    ChainId[ChainId["BandaiNamcoResearchVerseMainnet"] = 876] = "BandaiNamcoResearchVerseMainnet";
    ChainId[ChainId["DexitNetwork"] = 877] = "DexitNetwork";
    ChainId[ChainId["AmbrosChainMainnet"] = 880] = "AmbrosChainMainnet";
    ChainId[ChainId["WeberGovernanceMainnet"] = 881] = "WeberGovernanceMainnet";
    ChainId[ChainId["Wanchain"] = 888] = "Wanchain";
    ChainId[ChainId["MAXIChainTestnet"] = 898] = "MAXIChainTestnet";
    ChainId[ChainId["MAXIChainMainnet"] = 899] = "MAXIChainMainnet";
    ChainId[ChainId["GarizonTestnetStage0"] = 900] = "GarizonTestnetStage0";
    ChainId[ChainId["GarizonTestnetStage1"] = 901] = "GarizonTestnetStage1";
    ChainId[ChainId["GarizonTestnetStage2"] = 902] = "GarizonTestnetStage2";
    ChainId[ChainId["GarizonTestnetStage3"] = 903] = "GarizonTestnetStage3";
    ChainId[ChainId["PortalFantasyChain"] = 909] = "PortalFantasyChain";
    ChainId[ChainId["DecentraBoneLayer1Testnet"] = 910] = "DecentraBoneLayer1Testnet";
    ChainId[ChainId["TAPROOTMainnet"] = 911] = "TAPROOTMainnet";
    ChainId[ChainId["Rinia"] = 917] = "Rinia";
    ChainId[ChainId["SlerfChainMainnet"] = 918] = "SlerfChainMainnet";
    ChainId[ChainId["ModeTestnet"] = 919] = "ModeTestnet";
    ChainId[ChainId["YidarkChainMainnet"] = 927] = "YidarkChainMainnet";
    ChainId[ChainId["HaustMainnet"] = 938] = "HaustMainnet";
    ChainId[ChainId["PulseChainTestnet"] = 940] = "PulseChainTestnet";
    ChainId[ChainId["PulseChainTestnetv2b"] = 941] = "PulseChainTestnetv2b";
    ChainId[ChainId["PulseChainTestnetv3"] = 942] = "PulseChainTestnetv3";
    ChainId[ChainId["PulseChainTestnetv4"] = 943] = "PulseChainTestnetv4";
    ChainId[ChainId["SubtensorEVMTestnet"] = 945] = "SubtensorEVMTestnet";
    ChainId[ChainId["MuNodeTestnet"] = 956] = "MuNodeTestnet";
    ChainId[ChainId["LyraChain"] = 957] = "LyraChain";
    ChainId[ChainId["BTC20SmartChain"] = 963] = "BTC20SmartChain";
    ChainId[ChainId["SubtensorEVM"] = 964] = "SubtensorEVM";
    ChainId[ChainId["EthXY"] = 969] = "EthXY";
    ChainId[ChainId["OortMainnet"] = 970] = "OortMainnet";
    ChainId[ChainId["OortHuygens"] = 971] = "OortHuygens";
    ChainId[ChainId["OortAscraeus"] = 972] = "OortAscraeus";
    ChainId[ChainId["PalmSmartChain"] = 973] = "PalmSmartChain";
    ChainId[ChainId["NepalBlockchainNetwork"] = 977] = "NepalBlockchainNetwork";
    ChainId[ChainId["EthXYTestnet"] = 979] = "EthXYTestnet";
    ChainId[ChainId["TOPMainnetEVM"] = 980] = "TOPMainnetEVM";
    ChainId[ChainId["IOPNTestnet"] = 984] = "IOPNTestnet";
    ChainId[ChainId["MemoSmartChainMainnet"] = 985] = "MemoSmartChainMainnet";
    ChainId[ChainId["LAGOMMainnet"] = 986] = "LAGOMMainnet";
    ChainId[ChainId["BinaryChainMainnet"] = 987] = "BinaryChainMainnet";
    ChainId[ChainId["TOPMainnet"] = 989] = "TOPMainnet";
    ChainId[ChainId["ELibertyMainnet"] = 990] = "ELibertyMainnet";
    ChainId[ChainId["5ireChainMainnet"] = 995] = "5ireChainMainnet";
    ChainId[ChainId["BifrostPolkadotMainnet"] = 996] = "BifrostPolkadotMainnet";
    ChainId[ChainId["5ireChainThunderTestnet"] = 997] = "5ireChainThunderTestnet";
    ChainId[ChainId["HyperliquidEVMTestnet"] = 998] = "HyperliquidEVMTestnet";
    ChainId[ChainId["WanchainTestnet"] = 999] = "WanchainTestnet";
    ChainId[ChainId["GTONMainnet"] = 1000] = "GTONMainnet";
    ChainId[ChainId["KaiaKairosTestnet"] = 1001] = "KaiaKairosTestnet";
    ChainId[ChainId["TectumEmissionToken"] = 1003] = "TectumEmissionToken";
    ChainId[ChainId["T-EKTA"] = 1004] = "T-EKTA";
    ChainId[ChainId["LemonChainTestnet"] = 1005] = "LemonChainTestnet";
    ChainId[ChainId["LemonChain"] = 1006] = "LemonChain";
    ChainId[ChainId["NewtonTestnet"] = 1007] = "NewtonTestnet";
    ChainId[ChainId["EurusMainnet"] = 1008] = "EurusMainnet";
    ChainId[ChainId["JumbochainMainnet"] = 1009] = "JumbochainMainnet";
    ChainId[ChainId["EvriceNetwork"] = 1010] = "EvriceNetwork";
    ChainId[ChainId["RebusClassicMainnet"] = 1011] = "RebusClassicMainnet";
    ChainId[ChainId["Newton"] = 1012] = "Newton";
    ChainId[ChainId["Sakura"] = 1022] = "Sakura";
    ChainId[ChainId["CloverTestnet"] = 1023] = "CloverTestnet";
    ChainId[ChainId["CLVParachain"] = 1024] = "CLVParachain";
    ChainId[ChainId["BitTorrentChainTestnet"] = 1028] = "BitTorrentChainTestnet";
    ChainId[ChainId["BitTorrentChainDonau"] = 1029] = "BitTorrentChainDonau";
    ChainId[ChainId["ConfluxeSpace"] = 1030] = "ConfluxeSpace";
    ChainId[ChainId["ProxyNetworkTestnet"] = 1031] = "ProxyNetworkTestnet";
    ChainId[ChainId["BronosTestnet"] = 1038] = "BronosTestnet";
    ChainId[ChainId["BronosMainnet"] = 1039] = "BronosMainnet";
    ChainId[ChainId["OpenGPUMainnet"] = 1071] = "OpenGPUMainnet";
    ChainId[ChainId["ShimmerEVMTestnetDeprecated1072"] = 1072] = "ShimmerEVMTestnetDeprecated1072";
    ChainId[ChainId["ShimmerEVMTestnet"] = 1073] = "ShimmerEVMTestnet";
    ChainId[ChainId["IOTAEVMTestnet"] = 1075] = "IOTAEVMTestnet";
    ChainId[ChainId["MintaraTestnet"] = 1079] = "MintaraTestnet";
    ChainId[ChainId["MintaraMainnet"] = 1080] = "MintaraMainnet";
    ChainId[ChainId["MetisAndromedaMainnet"] = 1088] = "MetisAndromedaMainnet";
    ChainId[ChainId["Humans.aiMainnet"] = 1089] = "Humans.aiMainnet";
    ChainId[ChainId["MOACmainnet"] = 1099] = "MOACmainnet";
    ChainId[ChainId["Dymension"] = 1100] = "Dymension";
    ChainId[ChainId["PolygonzkEVM"] = 1101] = "PolygonzkEVM";
    ChainId[ChainId["BLXqTestnet"] = 1107] = "BLXqTestnet";
    ChainId[ChainId["BLXqMainnet"] = 1108] = "BLXqMainnet";
    ChainId[ChainId["WEMIX3.0Mainnet"] = 1111] = "WEMIX3.0Mainnet";
    ChainId[ChainId["WEMIX3.0Testnet"] = 1112] = "WEMIX3.0Testnet";
    ChainId[ChainId["B2HubTestnet"] = 1113] = "B2HubTestnet";
    ChainId[ChainId["CoreBlockchainTestnet2"] = 1114] = "CoreBlockchainTestnet2";
    ChainId[ChainId["CoreBlockchainTestnet"] = 1115] = "CoreBlockchainTestnet";
    ChainId[ChainId["CoreBlockchainMainnet"] = 1116] = "CoreBlockchainMainnet";
    ChainId[ChainId["DogcoinMainnet"] = 1117] = "DogcoinMainnet";
    ChainId[ChainId["B2Testnet"] = 1123] = "B2Testnet";
    ChainId[ChainId["TakerChainMainnet"] = 1125] = "TakerChainMainnet";
    ChainId[ChainId["DeFiChainEVMNetworkMainnet"] = 1130] = "DeFiChainEVMNetworkMainnet";
    ChainId[ChainId["DeFiChainEVMNetworkTestnet"] = 1131] = "DeFiChainEVMNetworkTestnet";
    ChainId[ChainId["DeFiMetaChainChangiTestnet"] = 1133] = "DeFiMetaChainChangiTestnet";
    ChainId[ChainId["StateMesh"] = 1134] = "StateMesh";
    ChainId[ChainId["Lisk"] = 1135] = "Lisk";
    ChainId[ChainId["AmStarTestnet"] = 1138] = "AmStarTestnet";
    ChainId[ChainId["MathChain"] = 1139] = "MathChain";
    ChainId[ChainId["MathChainTestnet"] = 1140] = "MathChainTestnet";
    ChainId[ChainId["FlagTestnet"] = 1147] = "FlagTestnet";
    ChainId[ChainId["SymplexiaSmartChain"] = 1149] = "SymplexiaSmartChain";
    ChainId[ChainId["OriginTestnet"] = 1170] = "OriginTestnet";
    ChainId[ChainId["LitheumTestNetwork"] = 1174] = "LitheumTestNetwork";
    ChainId[ChainId["SmartHostTeknolojiTESTNET"] = 1177] = "SmartHostTeknolojiTESTNET";
    ChainId[ChainId["ClubMosMainnet"] = 1188] = "ClubMosMainnet";
    ChainId[ChainId["IoraChain"] = 1197] = "IoraChain";
    ChainId[ChainId["CuckooChain"] = 1200] = "CuckooChain";
    ChainId[ChainId["EvanescoTestnet"] = 1201] = "EvanescoTestnet";
    ChainId[ChainId["WorldTradeTechnicalChainMainnet"] = 1202] = "WorldTradeTechnicalChainMainnet";
    ChainId[ChainId["SaitaBlockChain(SBC)"] = 1209] = "SaitaBlockChain(SBC)";
    ChainId[ChainId["CuckooSepolia"] = 1210] = "CuckooSepolia";
    ChainId[ChainId["ADFChainTestnet"] = 1212] = "ADFChainTestnet";
    ChainId[ChainId["PopcateumMainnet"] = 1213] = "PopcateumMainnet";
    ChainId[ChainId["EnterChainMainnet"] = 1214] = "EnterChainMainnet";
    ChainId[ChainId["ADFChain"] = 1215] = "ADFChain";
    ChainId[ChainId["CycleNetworkTestnet"] = 1221] = "CycleNetworkTestnet";
    ChainId[ChainId["CycleNetworkTestnetJellyfish"] = 1223] = "CycleNetworkTestnetJellyfish";
    ChainId[ChainId["HybridTestnet(Deprecated)"] = 1224] = "HybridTestnet(Deprecated)";
    ChainId[ChainId["HybridTestnet"] = 1225] = "HybridTestnet";
    ChainId[ChainId["BitcoinProtocolTestnet"] = 1227] = "BitcoinProtocolTestnet";
    ChainId[ChainId["CycleNetworkTestnetCuttlefish"] = 1228] = "CycleNetworkTestnetCuttlefish";
    ChainId[ChainId["ExzoNetworkMainnet"] = 1229] = "ExzoNetworkMainnet";
    ChainId[ChainId["UltronTestnet"] = 1230] = "UltronTestnet";
    ChainId[ChainId["UltronMainnet"] = 1231] = "UltronMainnet";
    ChainId[ChainId["StepNetwork"] = 1234] = "StepNetwork";
    ChainId[ChainId["ITXMainnet"] = 1235] = "ITXMainnet";
    ChainId[ChainId["ARCMainnet"] = 1243] = "ARCMainnet";
    ChainId[ChainId["ARCTestnet"] = 1244] = "ARCTestnet";
    ChainId[ChainId["OMPlatformMainnet"] = 1246] = "OMPlatformMainnet";
    ChainId[ChainId["DogetherMainnet"] = 1248] = "DogetherMainnet";
    ChainId[ChainId["CICChainTestnet"] = 1252] = "CICChainTestnet";
    ChainId[ChainId["MetaccesTestnet"] = 1260] = "MetaccesTestnet";
    ChainId[ChainId["HALOMainnet"] = 1280] = "HALOMainnet";
    ChainId[ChainId["Moonbeam"] = 1284] = "Moonbeam";
    ChainId[ChainId["Moonriver"] = 1285] = "Moonriver";
    ChainId[ChainId["Moonrockold"] = 1286] = "Moonrockold";
    ChainId[ChainId["MoonbaseAlpha"] = 1287] = "MoonbaseAlpha";
    ChainId[ChainId["Moonrock"] = 1288] = "Moonrock";
    ChainId[ChainId["SwisstronikTestnet"] = 1291] = "SwisstronikTestnet";
    ChainId[ChainId["Bobabeam"] = 1294] = "Bobabeam";
    ChainId[ChainId["BobabaseTestnet"] = 1297] = "BobabaseTestnet";
    ChainId[ChainId["ArgochainTestnet"] = 1298] = "ArgochainTestnet";
    ChainId[ChainId["Argochain"] = 1299] = "Argochain";
    ChainId[ChainId["GlueMainnet"] = 1300] = "GlueMainnet";
    ChainId[ChainId["UnichainSepoliaTestnet"] = 1301] = "UnichainSepoliaTestnet";
    ChainId[ChainId["COINZAX"] = 1310] = "COINZAX";
    ChainId[ChainId["DosFujiSubnet"] = 1311] = "DosFujiSubnet";
    ChainId[ChainId["JaiHoChain"] = 1313] = "JaiHoChain";
    ChainId[ChainId["AlyxMainnet"] = 1314] = "AlyxMainnet";
    ChainId[ChainId["StoryAeneidTestnet"] = 1315] = "StoryAeneidTestnet";
    ChainId[ChainId["AIAMainnet"] = 1319] = "AIAMainnet";
    ChainId[ChainId["AIATestnet"] = 1320] = "AIATestnet";
    ChainId[ChainId["SeiTestnet"] = 1328] = "SeiTestnet";
    ChainId[ChainId["SeiNetwork"] = 1329] = "SeiNetwork";
    ChainId[ChainId["KiiTestnetOro"] = 1336] = "KiiTestnetOro";
    ChainId[ChainId["GethTestnet"] = 1337] = "GethTestnet";
    ChainId[ChainId["ElysiumTestnet"] = 1338] = "ElysiumTestnet";
    ChainId[ChainId["ElysiumMainnet"] = 1339] = "ElysiumMainnet";
    ChainId[ChainId["BlitzSubnet"] = 1343] = "BlitzSubnet";
    ChainId[ChainId["CICChainMainnet"] = 1353] = "CICChainMainnet";
    ChainId[ChainId["ZafiriumMainnet"] = 1369] = "ZafiriumMainnet";
    ChainId[ChainId["RamesttaMainnet"] = 1370] = "RamesttaMainnet";
    ChainId[ChainId["Pingakshatestnet"] = 1377] = "Pingakshatestnet";
    ChainId[ChainId["KalarChain"] = 1379] = "KalarChain";
    ChainId[ChainId["AmStarMainnet"] = 1388] = "AmStarMainnet";
    ChainId[ChainId["JoseonMainnet"] = 1392] = "JoseonMainnet";
    ChainId[ChainId["PolygonzkEVMTestnetold"] = 1402] = "PolygonzkEVMTestnetold";
    ChainId[ChainId["SiliconzkEVMSepoliaTestnet(Deprecated)"] = 1414] = "SiliconzkEVMSepoliaTestnet(Deprecated)";
    ChainId[ChainId["PolygonzkEVMTestnetPreAudit-Upgraded"] = 1422] = "PolygonzkEVMTestnetPreAudit-Upgraded";
    ChainId[ChainId["Perennial"] = 1424] = "Perennial";
    ChainId[ChainId["ONINOMainnet"] = 1425] = "ONINOMainnet";
    ChainId[ChainId["RikezaNetworkMainnet"] = 1433] = "RikezaNetworkMainnet";
    ChainId[ChainId["LivingAssetsMainnet"] = 1440] = "LivingAssetsMainnet";
    ChainId[ChainId["PolygonzkEVMTestnet"] = 1442] = "PolygonzkEVMTestnet";
    ChainId[ChainId["GILTestnet"] = 1452] = "GILTestnet";
    ChainId[ChainId["MetaChainIstanbul"] = 1453] = "MetaChainIstanbul";
    ChainId[ChainId["CtexScanBlockchain"] = 1455] = "CtexScanBlockchain";
    ChainId[ChainId["ZKBaseMainnet"] = 1456] = "ZKBaseMainnet";
    ChainId[ChainId["Vana"] = 1480] = "Vana";
    ChainId[ChainId["VitruveoMainnet"] = 1490] = "VitruveoMainnet";
    ChainId[ChainId["IDosGamesChainTestnet"] = 1499] = "IDosGamesChainTestnet";
    ChainId[ChainId["BEVMCanary"] = 1501] = "BEVMCanary";
    ChainId[ChainId["SherpaxMainnet"] = 1506] = "SherpaxMainnet";
    ChainId[ChainId["SherpaxTestnet"] = 1507] = "SherpaxTestnet";
    ChainId[ChainId["StoryTestnet"] = 1513] = "StoryTestnet";
    ChainId[ChainId["Story"] = 1514] = "Story";
    ChainId[ChainId["BeagleMessagingChain"] = 1515] = "BeagleMessagingChain";
    ChainId[ChainId["StoryOdysseyTestnet"] = 1516] = "StoryOdysseyTestnet";
    ChainId[ChainId["DatacoreSmartChain"] = 1555] = "DatacoreSmartChain";
    ChainId[ChainId["Tenet"] = 1559] = "Tenet";
    ChainId[ChainId["StarCHAINTestnet"] = 1570] = "StarCHAINTestnet";
    ChainId[ChainId["StarCHAIN"] = 1578] = "StarCHAIN";
    ChainId[ChainId["ReactiveMainnet"] = 1597] = "ReactiveMainnet";
    ChainId[ChainId["Betherance"] = 1605] = "Betherance";
    ChainId[ChainId["EthereumInscriptionMainnet"] = 1617] = "EthereumInscriptionMainnet";
    ChainId[ChainId["CatecoinChainMainnet"] = 1618] = "CatecoinChainMainnet";
    ChainId[ChainId["Atheios"] = 1620] = "Atheios";
    ChainId[ChainId["GravityAlphaMainnet"] = 1625] = "GravityAlphaMainnet";
    ChainId[ChainId["PivotalMainnet"] = 1648] = "PivotalMainnet";
    ChainId[ChainId["Btachain"] = 1657] = "Btachain";
    ChainId[ChainId["Liquichain"] = 1662] = "Liquichain";
    ChainId[ChainId["HorizenGobiTestnet"] = 1663] = "HorizenGobiTestnet";
    ChainId[ChainId["MintTestnet"] = 1686] = "MintTestnet";
    ChainId[ChainId["MintSepoliaTestnet"] = 1687] = "MintSepoliaTestnet";
    ChainId[ChainId["LUDANMainnet"] = 1688] = "LUDANMainnet";
    ChainId[ChainId["NEROMainnet"] = 1689] = "NEROMainnet";
    ChainId[ChainId["AnytypeEVMChain"] = 1701] = "AnytypeEVMChain";
    ChainId[ChainId["TBSIMainnet"] = 1707] = "TBSIMainnet";
    ChainId[ChainId["TBSITestnet"] = 1708] = "TBSITestnet";
    ChainId[ChainId["DoricNetwork"] = 1717] = "DoricNetwork";
    ChainId[ChainId["PaletteChainMainnet"] = 1718] = "PaletteChainMainnet";
    ChainId[ChainId["EthparMainnet"] = 1727] = "EthparMainnet";
    ChainId[ChainId["ReyaNetwork"] = 1729] = "ReyaNetwork";
    ChainId[ChainId["FugaMainnet"] = 1732] = "FugaMainnet";
    ChainId[ChainId["FugaTestnet"] = 1733] = "FugaTestnet";
    ChainId[ChainId["FugaDevelop"] = 1734] = "FugaDevelop";
    ChainId[ChainId["MetalL2Testnet"] = 1740] = "MetalL2Testnet";
    ChainId[ChainId["MetalL2"] = 1750] = "MetalL2";
    ChainId[ChainId["PartyChain"] = 1773] = "PartyChain";
    ChainId[ChainId["GaussMainnet"] = 1777] = "GaussMainnet";
    ChainId[ChainId["ZKBaseSepoliaTestnet"] = 1789] = "ZKBaseSepoliaTestnet";
    ChainId[ChainId["Kerleano"] = 1804] = "Kerleano";
    ChainId[ChainId["RabbitAnalogTestnetChain"] = 1807] = "RabbitAnalogTestnetChain";
    ChainId[ChainId["Lif3ChainTestnet"] = 1811] = "Lif3ChainTestnet";
    ChainId[ChainId["CubeChainMainnet"] = 1818] = "CubeChainMainnet";
    ChainId[ChainId["CubeChainTestnet"] = 1819] = "CubeChainTestnet";
    ChainId[ChainId["RubySmartChainMAINNET"] = 1821] = "RubySmartChainMAINNET";
    ChainId[ChainId["PlayBlock"] = 1829] = "PlayBlock";
    ChainId[ChainId["Verifytestnet"] = 1833] = "Verifytestnet";
    ChainId[ChainId["SwisstronikMainnet"] = 1848] = "SwisstronikMainnet";
    ChainId[ChainId["HighOctaneSubnet"] = 1853] = "HighOctaneSubnet";
    ChainId[ChainId["Teslafunds"] = 1856] = "Teslafunds";
    ChainId[ChainId["Soneium"] = 1868] = "Soneium";
    ChainId[ChainId["Whitechain"] = 1875] = "Whitechain";
    ChainId[ChainId["GitshockCartenzTestnet"] = 1881] = "GitshockCartenzTestnet";
    ChainId[ChainId["LightlinkPhoenixMainnet"] = 1890] = "LightlinkPhoenixMainnet";
    ChainId[ChainId["LightlinkPegasusTestnet"] = 1891] = "LightlinkPegasusTestnet";
    ChainId[ChainId["BONNetwork"] = 1898] = "BONNetwork";
    ChainId[ChainId["ReDeFiLayer2"] = 1899] = "ReDeFiLayer2";
    ChainId[ChainId["SportsChainNetwork"] = 1904] = "SportsChainNetwork";
    ChainId[ChainId["BitcichainMainnet"] = 1907] = "BitcichainMainnet";
    ChainId[ChainId["BitcichainTestnet"] = 1908] = "BitcichainTestnet";
    ChainId[ChainId["MerkleScan"] = 1909] = "MerkleScan";
    ChainId[ChainId["Scalind"] = 1911] = "Scalind";
    ChainId[ChainId["RubySmartChainTestnet"] = 1912] = "RubySmartChainTestnet";
    ChainId[ChainId["UPBCRESCDITestnet"] = 1918] = "UPBCRESCDITestnet";
    ChainId[ChainId["Swellchain"] = 1923] = "Swellchain";
    ChainId[ChainId["SwellchainTestnet"] = 1924] = "SwellchainTestnet";
    ChainId[ChainId["ArvixTestnet"] = 1927] = "ArvixTestnet";
    ChainId[ChainId["ONUSChainTestnet"] = 1945] = "ONUSChainTestnet";
    ChainId[ChainId["SoneiumTestnetMinato"] = 1946] = "SoneiumTestnetMinato";
    ChainId[ChainId["BionixTestnet"] = 1949] = "BionixTestnet";
    ChainId[ChainId["D-ChainMainnet"] = 1951] = "D-ChainMainnet";
    ChainId[ChainId["SelendraNetworkTestnet"] = 1953] = "SelendraNetworkTestnet";
    ChainId[ChainId["DexillaTestnet"] = 1954] = "DexillaTestnet";
    ChainId[ChainId["AIW3Testnet"] = 1956] = "AIW3Testnet";
    ChainId[ChainId["SelendraNetworkMainnet"] = 1961] = "SelendraNetworkMainnet";
    ChainId[ChainId["Eleanor"] = 1967] = "Eleanor";
    ChainId[ChainId["SuperSmartChainTestnet"] = 1969] = "SuperSmartChainTestnet";
    ChainId[ChainId["SuperSmartChainMainnet"] = 1970] = "SuperSmartChainMainnet";
    ChainId[ChainId["Atelier"] = 1971] = "Atelier";
    ChainId[ChainId["RedeCoin"] = 1972] = "RedeCoin";
    ChainId[ChainId["ONUSChainMainnet"] = 1975] = "ONUSChainMainnet";
    ChainId[ChainId["EurusTestnet"] = 1984] = "EurusTestnet";
    ChainId[ChainId["SatoshIE"] = 1985] = "SatoshIE";
    ChainId[ChainId["SatoshIETestnet"] = 1986] = "SatoshIETestnet";
    ChainId[ChainId["EtherGem"] = 1987] = "EtherGem";
    ChainId[ChainId["LydiaCoin"] = 1989] = "LydiaCoin";
    ChainId[ChainId["HubbleExchange"] = 1992] = "HubbleExchange";
    ChainId[ChainId["B3SepoliaTestnet"] = 1993] = "B3SepoliaTestnet";
    ChainId[ChainId["Ekta"] = 1994] = "Ekta";
    ChainId[ChainId["EdeXaTestnet"] = 1995] = "EdeXaTestnet";
    ChainId[ChainId["Sanko"] = 1996] = "Sanko";
    ChainId[ChainId["Kyoto"] = 1997] = "Kyoto";
    ChainId[ChainId["KyotoTestnet"] = 1998] = "KyotoTestnet";
    ChainId[ChainId["DogechainMainnet"] = 2000] = "DogechainMainnet";
    ChainId[ChainId["MilkomedaC1Mainnet"] = 2001] = "MilkomedaC1Mainnet";
    ChainId[ChainId["MilkomedaA1Mainnet"] = 2002] = "MilkomedaA1Mainnet";
    ChainId[ChainId["MetaLinkNetwork"] = 2004] = "MetaLinkNetwork";
    ChainId[ChainId["CloudWalkTestnet"] = 2008] = "CloudWalkTestnet";
    ChainId[ChainId["CloudWalkMainnet"] = 2009] = "CloudWalkMainnet";
    ChainId[ChainId["Panarchy"] = 2013] = "Panarchy";
    ChainId[ChainId["NOWChainTestnet"] = 2014] = "NOWChainTestnet";
    ChainId[ChainId["MainnetZMainnet"] = 2016] = "MainnetZMainnet";
    ChainId[ChainId["Adiri"] = 2017] = "Adiri";
    ChainId[ChainId["PublicMintDevnet"] = 2018] = "PublicMintDevnet";
    ChainId[ChainId["PublicMintTestnet"] = 2019] = "PublicMintTestnet";
    ChainId[ChainId["RoninMainnet"] = 2020] = "RoninMainnet";
    ChainId[ChainId["EdgewareEdgeEVMMainnet"] = 2021] = "EdgewareEdgeEVMMainnet";
    ChainId[ChainId["BeresheetBereEVMTestnet"] = 2022] = "BeresheetBereEVMTestnet";
    ChainId[ChainId["TaycanTestnet"] = 2023] = "TaycanTestnet";
    ChainId[ChainId["SwanSaturnTestnet"] = 2024] = "SwanSaturnTestnet";
    ChainId[ChainId["RangersProtocolMainnet"] = 2025] = "RangersProtocolMainnet";
    ChainId[ChainId["EdgelessNetwork"] = 2026] = "EdgelessNetwork";
    ChainId[ChainId["Centrifuge"] = 2031] = "Centrifuge";
    ChainId[ChainId["Catalyst"] = 2032] = "Catalyst";
    ChainId[ChainId["PhalaNetwork"] = 2035] = "PhalaNetwork";
    ChainId[ChainId["KiwiSubnet"] = 2037] = "KiwiSubnet";
    ChainId[ChainId["ShrapnelTestnet"] = 2038] = "ShrapnelTestnet";
    ChainId[ChainId["AlephZero"] = 2039] = "AlephZero";
    ChainId[ChainId["VanarMainnet"] = 2040] = "VanarMainnet";
    ChainId[ChainId["NeuroWeb"] = 2043] = "NeuroWeb";
    ChainId[ChainId["ShrapnelSubnet"] = 2044] = "ShrapnelSubnet";
    ChainId[ChainId["AIW3Mainnet"] = 2045] = "AIW3Mainnet";
    ChainId[ChainId["StratosTestnet"] = 2047] = "StratosTestnet";
    ChainId[ChainId["Stratos"] = 2048] = "Stratos";
    ChainId[ChainId["MovoSmartChainMainnet"] = 2049] = "MovoSmartChainMainnet";
    ChainId[ChainId["MetaccesMainnet"] = 2071] = "MetaccesMainnet";
    ChainId[ChainId["QuokkacoinMainnet"] = 2077] = "QuokkacoinMainnet";
    ChainId[ChainId["Altair"] = 2088] = "Altair";
    ChainId[ChainId["Algol"] = 2089] = "Algol";
    ChainId[ChainId["EcoballMainnet"] = 2100] = "EcoballMainnet";
    ChainId[ChainId["EcoballTestnetEspuma"] = 2101] = "EcoballTestnetEspuma";
    ChainId[ChainId["ExosamaNetwork"] = 2109] = "ExosamaNetwork";
    ChainId[ChainId["UCHAINMainnet"] = 2112] = "UCHAINMainnet";
    ChainId[ChainId["CatenaMainnet"] = 2121] = "CatenaMainnet";
    ChainId[ChainId["MetaplayeroneMainnet"] = 2122] = "MetaplayeroneMainnet";
    ChainId[ChainId["MetaplayeroneDubaiTestnet"] = 2124] = "MetaplayeroneDubaiTestnet";
    ChainId[ChainId["BigShortBetsTestnet"] = 2136] = "BigShortBetsTestnet";
    ChainId[ChainId["BigShortBets"] = 2137] = "BigShortBets";
    ChainId[ChainId["DefiOracleMetaTestnet"] = 2138] = "DefiOracleMetaTestnet";
    ChainId[ChainId["OnenessNetwork"] = 2140] = "OnenessNetwork";
    ChainId[ChainId["OnenessTestNet"] = 2141] = "OnenessTestNet";
    ChainId[ChainId["BOSagoraMainnet"] = 2151] = "BOSagoraMainnet";
    ChainId[ChainId["FindoraMainnet"] = 2152] = "FindoraMainnet";
    ChainId[ChainId["FindoraTestnet"] = 2153] = "FindoraTestnet";
    ChainId[ChainId["FindoraForge"] = 2154] = "FindoraForge";
    ChainId[ChainId["AnimechainTestnet"] = 2162] = "AnimechainTestnet";
    ChainId[ChainId["Game7"] = 2187] = "Game7";
    ChainId[ChainId["SnaxChain"] = 2192] = "SnaxChain";
    ChainId[ChainId["MoonsamaNetwork"] = 2199] = "MoonsamaNetwork";
    ChainId[ChainId["AntofyMainnet"] = 2202] = "AntofyMainnet";
    ChainId[ChainId["BitcoinEVM"] = 2203] = "BitcoinEVM";
    ChainId[ChainId["EvanescoMainnet"] = 2213] = "EvanescoMainnet";
    ChainId[ChainId["KavaTestnet"] = 2221] = "KavaTestnet";
    ChainId[ChainId["Kava"] = 2222] = "Kava";
    ChainId[ChainId["VChainMainnet"] = 2223] = "VChainMainnet";
    ChainId[ChainId["KrestNetwork"] = 2241] = "KrestNetwork";
    ChainId[ChainId["BOMBChain"] = 2300] = "BOMBChain";
    ChainId[ChainId["EbroNetwork"] = 2306] = "EbroNetwork";
    ChainId[ChainId["Arevia"] = 2309] = "Arevia";
    ChainId[ChainId["CratD2C"] = 2310] = "CratD2C";
    ChainId[ChainId["ChronicleVesuvius-LitProtocolTestnet"] = 2311] = "ChronicleVesuvius-LitProtocolTestnet";
    ChainId[ChainId["SOMANetworkTestnet"] = 2323] = "SOMANetworkTestnet";
    ChainId[ChainId["Altcoinchain"] = 2330] = "Altcoinchain";
    ChainId[ChainId["RSS3VSLSepoliaTestnet"] = 2331] = "RSS3VSLSepoliaTestnet";
    ChainId[ChainId["SOMANetworkMainnet"] = 2332] = "SOMANetworkMainnet";
    ChainId[ChainId["AtletaOlympia"] = 2340] = "AtletaOlympia";
    ChainId[ChainId["OmniaChain"] = 2342] = "OmniaChain";
    ChainId[ChainId["GOATNetwork"] = 2345] = "GOATNetwork";
    ChainId[ChainId["SiliconzkEVM"] = 2355] = "SiliconzkEVM";
    ChainId[ChainId["(deprecated)KromaSepolia"] = 2357] = "(deprecated)KromaSepolia";
    ChainId[ChainId["KromaSepolia"] = 2358] = "KromaSepolia";
    ChainId[ChainId["KiteAITestnet"] = 2368] = "KiteAITestnet";
    ChainId[ChainId["NexisNetworkTestnet"] = 2370] = "NexisNetworkTestnet";
    ChainId[ChainId["TACTurin"] = 2390] = "TACTurin";
    ChainId[ChainId["BOMBChainTestnet"] = 2399] = "BOMBChainTestnet";
    ChainId[ChainId["TCGVerseMainnet"] = 2400] = "TCGVerseMainnet";
    ChainId[ChainId["K2Mainnet"] = 2410] = "K2Mainnet";
    ChainId[ChainId["XODEX"] = 2415] = "XODEX";
    ChainId[ChainId["Rufus"] = 2420] = "Rufus";
    ChainId[ChainId["InEVMTestnet"] = 2424] = "InEVMTestnet";
    ChainId[ChainId["KingOfLegendsMainnet"] = 2425] = "KingOfLegendsMainnet";
    ChainId[ChainId["StandardTestnet"] = 2426] = "StandardTestnet";
    ChainId[ChainId["AtletaNetwork"] = 2440] = "AtletaNetwork";
    ChainId[ChainId["PolygonzkEVMCardonaTestnet"] = 2442] = "PolygonzkEVMCardonaTestnet";
    ChainId[ChainId["HybridChainNetworkTestnet"] = 2458] = "HybridChainNetworkTestnet";
    ChainId[ChainId["HybridChainNetworkMainnet"] = 2468] = "HybridChainNetworkMainnet";
    ChainId[ChainId["6DegreeofOutreach"] = 2477] = "6DegreeofOutreach";
    ChainId[ChainId["UnicornUltraNebulasTestnet"] = 2484] = "UnicornUltraNebulasTestnet";
    ChainId[ChainId["NOWChainMainnet"] = 2488] = "NOWChainMainnet";
    ChainId[ChainId["KarakGoerli"] = 2511] = "KarakGoerli";
    ChainId[ChainId["K2Testnet"] = 2512] = "K2Testnet";
    ChainId[ChainId["FraxtalTestnet"] = 2522] = "FraxtalTestnet";
    ChainId[ChainId["InEVMMainnet"] = 2525] = "InEVMMainnet";
    ChainId[ChainId["Bahamuthorizon"] = 2552] = "Bahamuthorizon";
    ChainId[ChainId["KorthoMainnet"] = 2559] = "KorthoMainnet";
    ChainId[ChainId["TechPayMainnet"] = 2569] = "TechPayMainnet";
    ChainId[ChainId["PhoBlockchainMainnet"] = 2605] = "PhoBlockchainMainnet";
    ChainId[ChainId["PoCRNet"] = 2606] = "PoCRNet";
    ChainId[ChainId["RedlightChainMainnet"] = 2611] = "RedlightChainMainnet";
    ChainId[ChainId["EZChainC-ChainMainnet"] = 2612] = "EZChainC-ChainMainnet";
    ChainId[ChainId["EZChainC-ChainTestnet"] = 2613] = "EZChainC-ChainTestnet";
    ChainId[ChainId["WhitechainTestnet"] = 2625] = "WhitechainTestnet";
    ChainId[ChainId["AILayerTestnet"] = 2648] = "AILayerTestnet";
    ChainId[ChainId["AILayerMainnet"] = 2649] = "AILayerMainnet";
    ChainId[ChainId["APEX"] = 2662] = "APEX";
    ChainId[ChainId["MorphTestnet"] = 2710] = "MorphTestnet";
    ChainId[ChainId["K-LAOS"] = 2718] = "K-LAOS";
    ChainId[ChainId["XRSepolia"] = 2730] = "XRSepolia";
    ChainId[ChainId["ElizabethTestnet"] = 2731] = "ElizabethTestnet";
    ChainId[ChainId["Abstract"] = 2741] = "Abstract";
    ChainId[ChainId["Nanon"] = 2748] = "Nanon";
    ChainId[ChainId["GMNetworkMainnet"] = 2777] = "GMNetworkMainnet";
    ChainId[ChainId["Apertum"] = 2786] = "Apertum";
    ChainId[ChainId["MorphHolesky"] = 2810] = "MorphHolesky";
    ChainId[ChainId["Morph"] = 2818] = "Morph";
    ChainId[ChainId["HyperAGIMainnet"] = 2868] = "HyperAGIMainnet";
    ChainId[ChainId["ChipsNetwork"] = 2882] = "ChipsNetwork";
    ChainId[ChainId["BobaNetworkGoerliTestnet"] = 2888] = "BobaNetworkGoerliTestnet";
    ChainId[ChainId["AarmaMainnet"] = 2889] = "AarmaMainnet";
    ChainId[ChainId["EluxChain"] = 2907] = "EluxChain";
    ChainId[ChainId["HYCHAIN"] = 2911] = "HYCHAIN";
    ChainId[ChainId["XenonChainTestnet"] = 2941] = "XenonChainTestnet";
    ChainId[ChainId["BitYuanMainnet"] = 2999] = "BitYuanMainnet";
    ChainId[ChainId["CENNZnetRata"] = 3000] = "CENNZnetRata";
    ChainId[ChainId["CENNZnetNikau"] = 3001] = "CENNZnetNikau";
    ChainId[ChainId["CanxiumMainnet"] = 3003] = "CanxiumMainnet";
    ChainId[ChainId["PLAYA3ULLGAMES"] = 3011] = "PLAYA3ULLGAMES";
    ChainId[ChainId["BCHyperChainMainnet"] = 3030] = "BCHyperChainMainnet";
    ChainId[ChainId["OrlandoChain"] = 3031] = "OrlandoChain";
    ChainId[ChainId["RebusTestnet"] = 3033] = "RebusTestnet";
    ChainId[ChainId["BifrostMainnet"] = 3068] = "BifrostMainnet";
    ChainId[ChainId["MovementEVM"] = 3073] = "MovementEVM";
    ChainId[ChainId["XLNetworkTestnet"] = 3084] = "XLNetworkTestnet";
    ChainId[ChainId["Immu3EVM"] = 3100] = "Immu3EVM";
    ChainId[ChainId["VultureEVMBeta"] = 3102] = "VultureEVMBeta";
    ChainId[ChainId["SatoshiVMAlphaMainnet"] = 3109] = "SatoshiVMAlphaMainnet";
    ChainId[ChainId["SatoshiVMTestnet"] = 3110] = "SatoshiVMTestnet";
    ChainId[ChainId["Filecoin-Hyperspacetestnet"] = 3141] = "Filecoin-Hyperspacetestnet";
    ChainId[ChainId["Dubxcoinnetwork"] = 3269] = "Dubxcoinnetwork";
    ChainId[ChainId["Dubxcointestnet"] = 3270] = "Dubxcointestnet";
    ChainId[ChainId["DebounceSubnetTestnet"] = 3306] = "DebounceSubnetTestnet";
    ChainId[ChainId["ZCoreTestnet"] = 3331] = "ZCoreTestnet";
    ChainId[ChainId["EthStorageL2Mainnet"] = 3332] = "EthStorageL2Mainnet";
    ChainId[ChainId["EthStorageTestnet"] = 3333] = "EthStorageTestnet";
    ChainId[ChainId["Web3QGalileo"] = 3334] = "Web3QGalileo";
    ChainId[ChainId["QuarkChainL2BetaTestnet"] = 3335] = "QuarkChainL2BetaTestnet";
    ChainId[ChainId["EthStorageL2Testnet"] = 3336] = "EthStorageL2Testnet";
    ChainId[ChainId["EthStorageDevnet"] = 3337] = "EthStorageDevnet";
    ChainId[ChainId["Peaq"] = 3338] = "Peaq";
    ChainId[ChainId["EthStorageMainnet"] = 3339] = "EthStorageMainnet";
    ChainId[ChainId["PentagonChain"] = 3344] = "PentagonChain";
    ChainId[ChainId["Meroneum"] = 3366] = "Meroneum";
    ChainId[ChainId["MeroneumTestnet"] = 3369] = "MeroneumTestnet";
    ChainId[ChainId["ParibuNetMainnet"] = 3400] = "ParibuNetMainnet";
    ChainId[ChainId["PepeUnchained"] = 3409] = "PepeUnchained";
    ChainId[ChainId["EVOLVEMainnet"] = 3424] = "EVOLVEMainnet";
    ChainId[ChainId["SecureChainTestnet"] = 3434] = "SecureChainTestnet";
    ChainId[ChainId["LayerEdgetestnet"] = 3456] = "LayerEdgetestnet";
    ChainId[ChainId["GTCSCAN"] = 3490] = "GTCSCAN";
    ChainId[ChainId["ParibuNetTestnet"] = 3500] = "ParibuNetTestnet";
    ChainId[ChainId["JFINChain"] = 3501] = "JFINChain";
    ChainId[ChainId["JFINPOS"] = 3502] = "JFINPOS";
    ChainId[ChainId["PandoProjectMainnet"] = 3601] = "PandoProjectMainnet";
    ChainId[ChainId["PandoProjectTestnet"] = 3602] = "PandoProjectTestnet";
    ChainId[ChainId["Tycooncoin"] = 3630] = "Tycooncoin";
    ChainId[ChainId["BotanixTestnet"] = 3636] = "BotanixTestnet";
    ChainId[ChainId["BotanixMainnet"] = 3637] = "BotanixMainnet";
    ChainId[ChainId["IChainNetwork"] = 3639] = "IChainNetwork";
    ChainId[ChainId["IChainTestnet"] = 3645] = "IChainTestnet";
    ChainId[ChainId["JouleverseMainnet"] = 3666] = "JouleverseMainnet";
    ChainId[ChainId["BittexMainnet"] = 3690] = "BittexMainnet";
    ChainId[ChainId["EmpireNetwork"] = 3693] = "EmpireNetwork";
    ChainId[ChainId["SenjePowersTestnet"] = 3698] = "SenjePowersTestnet";
    ChainId[ChainId["SenjePowersMainnet"] = 3699] = "SenjePowersMainnet";
    ChainId[ChainId["XplaTestnet"] = 3701] = "XplaTestnet";
    ChainId[ChainId["XoneMainnet"] = 3721] = "XoneMainnet";
    ChainId[ChainId["Crossbell"] = 3737] = "Crossbell";
    ChainId[ChainId["AstarzkEVM"] = 3776] = "AstarzkEVM";
    ChainId[ChainId["AlveyChainMainnet"] = 3797] = "AlveyChainMainnet";
    ChainId[ChainId["TangleTestnet"] = 3799] = "TangleTestnet";
    ChainId[ChainId["FirechainzkEVMGhostrider"] = 3885] = "FirechainzkEVMGhostrider";
    ChainId[ChainId["KalyChainMainnet"] = 3888] = "KalyChainMainnet";
    ChainId[ChainId["KalyChainTestnet"] = 3889] = "KalyChainTestnet";
    ChainId[ChainId["DRACNetwork"] = 3912] = "DRACNetwork";
    ChainId[ChainId["DOSTestnet"] = 3939] = "DOSTestnet";
    ChainId[ChainId["DYNOMainnet"] = 3966] = "DYNOMainnet";
    ChainId[ChainId["DYNOTestnet"] = 3967] = "DYNOTestnet";
    ChainId[ChainId["PayNetworkMainnet"] = 3969] = "PayNetworkMainnet";
    ChainId[ChainId["APEXTestnet"] = 3993] = "APEXTestnet";
    ChainId[ChainId["YuanChainMainnet"] = 3999] = "YuanChainMainnet";
    ChainId[ChainId["OzoneChainMainnet"] = 4000] = "OzoneChainMainnet";
    ChainId[ChainId["PeperiumChainTestnet"] = 4001] = "PeperiumChainTestnet";
    ChainId[ChainId["FantomTestnet"] = 4002] = "FantomTestnet";
    ChainId[ChainId["X1Fastnet"] = 4003] = "X1Fastnet";
    ChainId[ChainId["CarboniumTestnetNetwork"] = 4040] = "CarboniumTestnetNetwork";
    ChainId[ChainId["GANTestnet"] = 4048] = "GANTestnet";
    ChainId[ChainId["BobaoperaTestnet"] = 4051] = "BobaoperaTestnet";
    ChainId[ChainId["Bahamutocean"] = 4058] = "Bahamutocean";
    ChainId[ChainId["Nahmii3Mainnet"] = 4061] = "Nahmii3Mainnet";
    ChainId[ChainId["Nahmii3Testnet"] = 4062] = "Nahmii3Testnet";
    ChainId[ChainId["MusterMainnet"] = 4078] = "MusterMainnet";
    ChainId[ChainId["TobeChainTestnet"] = 4080] = "TobeChainTestnet";
    ChainId[ChainId["ZerothMainnet"] = 4088] = "ZerothMainnet";
    ChainId[ChainId["FastexChain(Bahamut)OasisTestnet"] = 4090] = "FastexChain(Bahamut)OasisTestnet";
    ChainId[ChainId["BitindiTestnet"] = 4096] = "BitindiTestnet";
    ChainId[ChainId["BitindiMainnet"] = 4099] = "BitindiMainnet";
    ChainId[ChainId["AIOZNetworkTestnet"] = 4102] = "AIOZNetworkTestnet";
    ChainId[ChainId["Humans.aiTestnet"] = 4139] = "Humans.aiTestnet";
    ChainId[ChainId["TipboxcoinTestnet"] = 4141] = "TipboxcoinTestnet";
    ChainId[ChainId["CrossFiTestnet"] = 4157] = "CrossFiTestnet";
    ChainId[ChainId["CrossFiMainnet"] = 4158] = "CrossFiMainnet";
    ChainId[ChainId["SXRollup"] = 4162] = "SXRollup";
    ChainId[ChainId["PHINetworkV1"] = 4181] = "PHINetworkV1";
    ChainId[ChainId["MerlinMainnet"] = 4200] = "MerlinMainnet";
    ChainId[ChainId["LUKSOTestnet"] = 4201] = "LUKSOTestnet";
    ChainId[ChainId["LiskSepoliaTestnet"] = 4202] = "LiskSepoliaTestnet";
    ChainId[ChainId["MerlinErigonTestnet"] = 4203] = "MerlinErigonTestnet";
    ChainId[ChainId["NexiMainnet"] = 4242] = "NexiMainnet";
    ChainId[ChainId["NexiV2Mainnet"] = 4243] = "NexiV2Mainnet";
    ChainId[ChainId["LaikaTestnet"] = 4269] = "LaikaTestnet";
    ChainId[ChainId["EchosChain"] = 4321] = "EchosChain";
    ChainId[ChainId["BobafujiTestnet"] = 4328] = "BobafujiTestnet";
    ChainId[ChainId["Beam"] = 4337] = "Beam";
    ChainId[ChainId["MemeCore"] = 4352] = "MemeCore";
    ChainId[ChainId["CreditSmartChainMainnet"] = 4400] = "CreditSmartChainMainnet";
    ChainId[ChainId["TestnetPika"] = 4422] = "TestnetPika";
    ChainId[ChainId["HtmlcoinMainnet"] = 4444] = "HtmlcoinMainnet";
    ChainId[ChainId["OrderlySepoliaTestnet"] = 4460] = "OrderlySepoliaTestnet";
    ChainId[ChainId["HydraChain"] = 4488] = "HydraChain";
    ChainId[ChainId["EmoneyNetworkTestnet"] = 4544] = "EmoneyNetworkTestnet";
    ChainId[ChainId["EmoneyNetworkMainnet"] = 4545] = "EmoneyNetworkMainnet";
    ChainId[ChainId["TRUMPCHAIN"] = 4547] = "TRUMPCHAIN";
    ChainId[ChainId["VERYMainnet"] = 4613] = "VERYMainnet";
    ChainId[ChainId["MSTChain"] = 4646] = "MSTChain";
    ChainId[ChainId["GoldChain"] = 4653] = "GoldChain";
    ChainId[ChainId["AppChainTestnet"] = 4661] = "AppChainTestnet";
    ChainId[ChainId["IoTeXNetworkMainnet"] = 4689] = "IoTeXNetworkMainnet";
    ChainId[ChainId["IoTeXNetworkTestnet"] = 4690] = "IoTeXNetworkTestnet";
    ChainId[ChainId["MEVerseChainTestnet"] = 4759] = "MEVerseChainTestnet";
    ChainId[ChainId["BlackFortExchangeNetworkTestnetDEPRECATED"] = 4777] = "BlackFortExchangeNetworkTestnetDEPRECATED";
    ChainId[ChainId["EvnodeTestnet"] = 4786] = "EvnodeTestnet";
    ChainId[ChainId["WorldChainSepoliaTestnet"] = 4801] = "WorldChainSepoliaTestnet";
    ChainId[ChainId["BlackFortExchangeNetworkTestnet"] = 4888] = "BlackFortExchangeNetworkTestnet";
    ChainId[ChainId["GlobelChain"] = 4893] = "GlobelChain";
    ChainId[ChainId["OEVNetwork"] = 4913] = "OEVNetwork";
    ChainId[ChainId["VenidiumTestnet"] = 4918] = "VenidiumTestnet";
    ChainId[ChainId["VenidiumMainnet"] = 4919] = "VenidiumMainnet";
    ChainId[ChainId["BlackFortExchangeNetworkDeprecated"] = 4999] = "BlackFortExchangeNetworkDeprecated";
    ChainId[ChainId["Mantle"] = 5000] = "Mantle";
    ChainId[ChainId["MantleTestnet"] = 5001] = "MantleTestnet";
    ChainId[ChainId["TreasurenetMainnetAlpha"] = 5002] = "TreasurenetMainnetAlpha";
    ChainId[ChainId["MantleSepoliaTestnet"] = 5003] = "MantleSepoliaTestnet";
    ChainId[ChainId["TreasurenetTestnet"] = 5005] = "TreasurenetTestnet";
    ChainId[ChainId["ONIGIRITestSubnet"] = 5039] = "ONIGIRITestSubnet";
    ChainId[ChainId["ONIGIRISubnet"] = 5040] = "ONIGIRISubnet";
    ChainId[ChainId["SkateMainnet"] = 5050] = "SkateMainnet";
    ChainId[ChainId["NollieSkatechainTestnet"] = 5051] = "NollieSkatechainTestnet";
    ChainId[ChainId["PioneZero"] = 5080] = "PioneZero";
    ChainId[ChainId["PioneChainMainnet"] = 5090] = "PioneChainMainnet";
    ChainId[ChainId["SyndicateTestnet"] = 5100] = "SyndicateTestnet";
    ChainId[ChainId["SyndicateFrameChain"] = 5101] = "SyndicateFrameChain";
    ChainId[ChainId["SICTestnet"] = 5102] = "SICTestnet";
    ChainId[ChainId["CoordinapeTestnet"] = 5103] = "CoordinapeTestnet";
    ChainId[ChainId["CharmverseTestnet"] = 5104] = "CharmverseTestnet";
    ChainId[ChainId["SuperloyaltyTestnet"] = 5105] = "SuperloyaltyTestnet";
    ChainId[ChainId["AzraTestnet"] = 5106] = "AzraTestnet";
    ChainId[ChainId["Ham"] = 5112] = "Ham";
    ChainId[ChainId["CitreaTestnet"] = 5115] = "CitreaTestnet";
    ChainId[ChainId["Seismicdevnet"] = 5124] = "Seismicdevnet";
    ChainId[ChainId["MocaChainTestnet"] = 5151] = "MocaChainTestnet";
    ChainId[ChainId["Bahamut"] = 5165] = "Bahamut";
    ChainId[ChainId["SmartLayerNetwork"] = 5169] = "SmartLayerNetwork";
    ChainId[ChainId["TLChainNetworkMainnet"] = 5177] = "TLChainNetworkMainnet";
    ChainId[ChainId["EraSwapMainnet"] = 5197] = "EraSwapMainnet";
    ChainId[ChainId["HumanodeMainnet"] = 5234] = "HumanodeMainnet";
    ChainId[ChainId["FirechainMainnetOld"] = 5290] = "FirechainMainnetOld";
    ChainId[ChainId["UzmiNetworkMainnet"] = 5315] = "UzmiNetworkMainnet";
    ChainId[ChainId["OpTrustTestnet"] = 5317] = "OpTrustTestnet";
    ChainId[ChainId["ITXTestnet"] = 5321] = "ITXTestnet";
    ChainId[ChainId["Superseed"] = 5330] = "Superseed";
    ChainId[ChainId["Netsbo"] = 5333] = "Netsbo";
    ChainId[ChainId["TritaniumTestnet"] = 5353] = "TritaniumTestnet";
    ChainId[ChainId["Settlus"] = 5371] = "Settlus";
    ChainId[ChainId["SettlusTestnet"] = 5372] = "SettlusTestnet";
    ChainId[ChainId["SettlusSepoliaTestnet"] = 5373] = "SettlusSepoliaTestnet";
    ChainId[ChainId["EdeXaMainnet"] = 5424] = "EdeXaMainnet";
    ChainId[ChainId["InertiaScan"] = 5433] = "InertiaScan";
    ChainId[ChainId["Egochain"] = 5439] = "Egochain";
    ChainId[ChainId["Saga"] = 5464] = "Saga";
    ChainId[ChainId["PointPayMainnet"] = 5511] = "PointPayMainnet";
    ChainId[ChainId["VEXEVMTESTNET"] = 5522] = "VEXEVMTESTNET";
    ChainId[ChainId["DuckChainMainnet"] = 5545] = "DuckChainMainnet";
    ChainId[ChainId["Nahmii2Mainnet"] = 5551] = "Nahmii2Mainnet";
    ChainId[ChainId["Nahmii2Testnet"] = 5553] = "Nahmii2Testnet";
    ChainId[ChainId["ChainVerseMainnet"] = 5555] = "ChainVerseMainnet";
    ChainId[ChainId["OpBNBTestnet"] = 5611] = "OpBNBTestnet";
    ChainId[ChainId["ArcturusTestneet"] = 5615] = "ArcturusTestneet";
    ChainId[ChainId["ArcturusChainTestnet"] = 5616] = "ArcturusChainTestnet";
    ChainId[ChainId["QIEBlockchain"] = 5656] = "QIEBlockchain";
    ChainId[ChainId["FilenovaTestnet"] = 5675] = "FilenovaTestnet";
    ChainId[ChainId["TanssiDemo"] = 5678] = "TanssiDemo";
    ChainId[ChainId["SyscoinTanenbaumTestnet"] = 5700] = "SyscoinTanenbaumTestnet";
    ChainId[ChainId["HikaNetworkTestnet"] = 5729] = "HikaNetworkTestnet";
    ChainId[ChainId["SatoshiChainTestnet"] = 5758] = "SatoshiChainTestnet";
    ChainId[ChainId["Ganache"] = 5777] = "Ganache";
    ChainId[ChainId["Tangle"] = 5845] = "Tangle";
    ChainId[ChainId["OntologyTestnet"] = 5851] = "OntologyTestnet";
    ChainId[ChainId["ChangChainFoundationMainnet"] = 5858] = "ChangChainFoundationMainnet";
    ChainId[ChainId["WegochainRubidiumMainnet"] = 5869] = "WegochainRubidiumMainnet";
    ChainId[ChainId["BounceBitTestnet"] = 6000] = "BounceBitTestnet";
    ChainId[ChainId["BounceBitMainnet"] = 6001] = "BounceBitMainnet";
    ChainId[ChainId["BCHyperChainTestnet"] = 6060] = "BCHyperChainTestnet";
    ChainId[ChainId["TresTestnet"] = 6065] = "TresTestnet";
    ChainId[ChainId["TresMainnet"] = 6066] = "TresMainnet";
    ChainId[ChainId["CascadiaTestnet"] = 6102] = "CascadiaTestnet";
    ChainId[ChainId["UPTNTestnet"] = 6118] = "UPTNTestnet";
    ChainId[ChainId["UPTN"] = 6119] = "UPTN";
    ChainId[ChainId["TeaMainnet"] = 6122] = "TeaMainnet";
    ChainId[ChainId["Rails"] = 6278] = "Rails";
    ChainId[ChainId["LAOS"] = 6283] = "LAOS";
    ChainId[ChainId["NFBChainTestnet"] = 6320] = "NFBChainTestnet";
    ChainId[ChainId["AuraEuphoriaTestnet"] = 6321] = "AuraEuphoriaTestnet";
    ChainId[ChainId["AuraMainnet"] = 6322] = "AuraMainnet";
    ChainId[ChainId["MegaETHTestnet"] = 6342] = "MegaETHTestnet";
    ChainId[ChainId["DigitSoulSmartChain"] = 6363] = "DigitSoulSmartChain";
    ChainId[ChainId["ConnextSepolia"] = 6398] = "ConnextSepolia";
    ChainId[ChainId["Peerpay"] = 6502] = "Peerpay";
    ChainId[ChainId["FlammaTestnet"] = 6550] = "FlammaTestnet";
    ChainId[ChainId["ScolcoinWeiChainTestnet"] = 6552] = "ScolcoinWeiChainTestnet";
    ChainId[ChainId["FoxTestnetNetwork"] = 6565] = "FoxTestnetNetwork";
    ChainId[ChainId["PixieChainMainnet"] = 6626] = "PixieChainMainnet";
    ChainId[ChainId["LatestChainTestnet"] = 6660] = "LatestChainTestnet";
    ChainId[ChainId["CybriaMainnet"] = 6661] = "CybriaMainnet";
    ChainId[ChainId["CybriaTestnet"] = 6666] = "CybriaTestnet";
    ChainId[ChainId["Storchain"] = 6667] = "Storchain";
    ChainId[ChainId["EdgeMatrixChain"] = 6678] = "EdgeMatrixChain";
    ChainId[ChainId["IRIShub"] = 6688] = "IRIShub";
    ChainId[ChainId["OXChain"] = 6699] = "OXChain";
    ChainId[ChainId["PAXBMainnet"] = 6701] = "PAXBMainnet";
    ChainId[ChainId["CompverseMainnet"] = 6779] = "CompverseMainnet";
    ChainId[ChainId["GoldSmartChainMainnet"] = 6789] = "GoldSmartChainMainnet";
    ChainId[ChainId["RACEMainnet"] = 6805] = "RACEMainnet";
    ChainId[ChainId["RACETestnet"] = 6806] = "RACETestnet";
    ChainId[ChainId["PoolsMainnet"] = 6868] = "PoolsMainnet";
    ChainId[ChainId["MTTNetwork"] = 6880] = "MTTNetwork";
    ChainId[ChainId["Nibirucataclysm-1"] = 6900] = "Nibirucataclysm-1";
    ChainId[ChainId["Nibirutestnet-2"] = 6911] = "Nibirutestnet-2";
    ChainId[ChainId["XylumeTestNet"] = 6934] = "XylumeTestNet";
    ChainId[ChainId["LaikaMainnet"] = 6942] = "LaikaMainnet";
    ChainId[ChainId["TombChainMainnet"] = 6969] = "TombChainMainnet";
    ChainId[ChainId["PolySmartChain"] = 6999] = "PolySmartChain";
    ChainId[ChainId["ZetaChainMainnet"] = 7000] = "ZetaChainMainnet";
    ChainId[ChainId["ZetaChainTestnet"] = 7001] = "ZetaChainTestnet";
    ChainId[ChainId["BSTChain"] = 7007] = "BSTChain";
    ChainId[ChainId["Ellatheheart"] = 7027] = "Ellatheheart";
    ChainId[ChainId["PlanqMainnet"] = 7070] = "PlanqMainnet";
    ChainId[ChainId["PlanqAtlasTestnet"] = 7077] = "PlanqAtlasTestnet";
    ChainId[ChainId["BharatBlockchainNetwork"] = 7099] = "BharatBlockchainNetwork";
    ChainId[ChainId["Nume"] = 7100] = "Nume";
    ChainId[ChainId["0XL3"] = 7117] = "0XL3";
    ChainId[ChainId["HelpTheHomeless"] = 7118] = "HelpTheHomeless";
    ChainId[ChainId["BitrockMainnet"] = 7171] = "BitrockMainnet";
    ChainId[ChainId["UXLINKOneTestnet"] = 7181] = "UXLINKOneTestnet";
    ChainId[ChainId["ExSatMainnet"] = 7200] = "ExSatMainnet";
    ChainId[ChainId["NexeraMainnet"] = 7208] = "NexeraMainnet";
    ChainId[ChainId["Nibirutestnet-1"] = 7210] = "Nibirutestnet-1";
    ChainId[ChainId["Nibirudevnet-3"] = 7222] = "Nibirudevnet-3";
    ChainId[ChainId["InitVerseMainnet"] = 7233] = "InitVerseMainnet";
    ChainId[ChainId["InitVersegenesistestnet"] = 7234] = "InitVersegenesistestnet";
    ChainId[ChainId["ZEUSTestnet"] = 7244] = "ZEUSTestnet";
    ChainId[ChainId["XPLAVerse"] = 7300] = "XPLAVerse";
    ChainId[ChainId["KLYNTAR"] = 7331] = "KLYNTAR";
    ChainId[ChainId["HorizenEONMainnet"] = 7332] = "HorizenEONMainnet";
    ChainId[ChainId["ShyftMainnet"] = 7341] = "ShyftMainnet";
    ChainId[ChainId["Rarimo"] = 7368] = "Rarimo";
    ChainId[ChainId["RabaNetworkMainnet"] = 7484] = "RabaNetworkMainnet";
    ChainId[ChainId["MEVerseChainMainnet"] = 7518] = "MEVerseChainMainnet";
    ChainId[ChainId["CyberMainnet"] = 7560] = "CyberMainnet";
    ChainId[ChainId["ADILTestnet"] = 7575] = "ADILTestnet";
    ChainId[ChainId["AdilChainV2Mainnet"] = 7576] = "AdilChainV2Mainnet";
    ChainId[ChainId["TheRootNetwork-Mainnet"] = 7668] = "TheRootNetwork-Mainnet";
    ChainId[ChainId["TheRootNetwork-PorciniTestnet"] = 7672] = "TheRootNetwork-PorciniTestnet";
    ChainId[ChainId["Canto"] = 7700] = "Canto";
    ChainId[ChainId["CantoTesnet"] = 7701] = "CantoTesnet";
    ChainId[ChainId["PhronTestnet"] = 7744] = "PhronTestnet";
    ChainId[ChainId["PandaSeaTestnet"] = 7770] = "PandaSeaTestnet";
    ChainId[ChainId["BitrockTestnet"] = 7771] = "BitrockTestnet";
    ChainId[ChainId["GDCCMAINNET"] = 7774] = "GDCCMAINNET";
    ChainId[ChainId["GDCCTESTNET"] = 7775] = "GDCCTESTNET";
    ChainId[ChainId["PandaSeaMainnet"] = 7776] = "PandaSeaMainnet";
    ChainId[ChainId["RiseoftheWarbotsTestnet"] = 7777] = "RiseoftheWarbotsTestnet";
    ChainId[ChainId["OreniumMainnetProtocol"] = 7778] = "OreniumMainnetProtocol";
    ChainId[ChainId["DrawCoin"] = 7788] = "DrawCoin";
    ChainId[ChainId["OpenEXLONGTestnet"] = 7798] = "OpenEXLONGTestnet";
    ChainId[ChainId["MaalChainTestnet"] = 7860] = "MaalChainTestnet";
    ChainId[ChainId["MaalChainV2"] = 7862] = "MaalChainV2";
    ChainId[ChainId["MaalChainTestnetV2"] = 7863] = "MaalChainTestnetV2";
    ChainId[ChainId["PowerloomMainnet"] = 7865] = "PowerloomMainnet";
    ChainId[ChainId["PowerloomMainnetV2"] = 7869] = "PowerloomMainnetV2";
    ChainId[ChainId["HazlorTestnet"] = 7878] = "HazlorTestnet";
    ChainId[ChainId["VexonTestnet"] = 7879] = "VexonTestnet";
    ChainId[ChainId["KintoMainnet"] = 7887] = "KintoMainnet";
    ChainId[ChainId["ARDENIUMAthena"] = 7895] = "ARDENIUMAthena";
    ChainId[ChainId["Arena-z"] = 7897] = "Arena-z";
    ChainId[ChainId["DotBlox"] = 7923] = "DotBlox";
    ChainId[ChainId["MOMainnet"] = 7924] = "MOMainnet";
    ChainId[ChainId["ExoriumTestnet"] = 7957] = "ExoriumTestnet";
    ChainId[ChainId["DOSChain"] = 7979] = "DOSChain";
    ChainId[ChainId["Teleport"] = 8000] = "Teleport";
    ChainId[ChainId["TeleportTestnet"] = 8001] = "TeleportTestnet";
    ChainId[ChainId["Polynomial"] = 8008] = "Polynomial";
    ChainId[ChainId["ISunCoinMainnet"] = 8017] = "ISunCoinMainnet";
    ChainId[ChainId["MDGLTestnet"] = 8029] = "MDGLTestnet";
    ChainId[ChainId["BOATMainnet"] = 8047] = "BOATMainnet";
    ChainId[ChainId["KarakSepolia"] = 8054] = "KarakSepolia";
    ChainId[ChainId["ShardeumLiberty1.X"] = 8080] = "ShardeumLiberty1.X";
    ChainId[ChainId["ShardeumLiberty2.X"] = 8081] = "ShardeumLiberty2.X";
    ChainId[ChainId["ShardeumSphinx1.X"] = 8082] = "ShardeumSphinx1.X";
    ChainId[ChainId["ShardeumTestnet"] = 8083] = "ShardeumTestnet";
    ChainId[ChainId["BitcoinChain"] = 8086] = "BitcoinChain";
    ChainId[ChainId["E-Dollar"] = 8087] = "E-Dollar";
    ChainId[ChainId["StreamuXBlockchain"] = 8098] = "StreamuXBlockchain";
    ChainId[ChainId["BharatBlockchainNetworkMainnet"] = 8099] = "BharatBlockchainNetworkMainnet";
    ChainId[ChainId["ZenChain"] = 8108] = "ZenChain";
    ChainId[ChainId["Shardeum"] = 8118] = "Shardeum";
    ChainId[ChainId["QitmeerNetworkTestnet"] = 8131] = "QitmeerNetworkTestnet";
    ChainId[ChainId["QitmeerNetworkMixnet"] = 8132] = "QitmeerNetworkMixnet";
    ChainId[ChainId["QitmeerNetworkPrivnet"] = 8133] = "QitmeerNetworkPrivnet";
    ChainId[ChainId["Amana"] = 8134] = "Amana";
    ChainId[ChainId["Flana"] = 8135] = "Flana";
    ChainId[ChainId["Mizana"] = 8136] = "Mizana";
    ChainId[ChainId["TestnetBeOneChain"] = 8181] = "TestnetBeOneChain";
    ChainId[ChainId["TorusMainnet"] = 8192] = "TorusMainnet";
    ChainId[ChainId["TorusTestnet"] = 8194] = "TorusTestnet";
    ChainId[ChainId["KaiaMainnet"] = 8217] = "KaiaMainnet";
    ChainId[ChainId["SpaceSubnet"] = 8227] = "SpaceSubnet";
    ChainId[ChainId["BlocktonBlockchain"] = 8272] = "BlocktonBlockchain";
    ChainId[ChainId["KorthoTest"] = 8285] = "KorthoTest";
    ChainId[ChainId["Lorenzo"] = 8329] = "Lorenzo";
    ChainId[ChainId["B3"] = 8333] = "B3";
    ChainId[ChainId["XProtocol"] = 8386] = "XProtocol";
    ChainId[ChainId["DraconesFinancialServices"] = 8387] = "DraconesFinancialServices";
    ChainId[ChainId["ZenChainTestnet"] = 8408] = "ZenChainTestnet";
    ChainId[ChainId["THATMainnet"] = 8428] = "THATMainnet";
    ChainId[ChainId["Base"] = 8453] = "Base";
    ChainId[ChainId["ChakraTestnet"] = 8545] = "ChakraTestnet";
    ChainId[ChainId["NewRealityBlockchain"] = 8569] = "NewRealityBlockchain";
    ChainId[ChainId["TokiNetwork"] = 8654] = "TokiNetwork";
    ChainId[ChainId["TokiTestnet"] = 8655] = "TokiTestnet";
    ChainId[ChainId["HelaOfficialRuntimeMainnet"] = 8668] = "HelaOfficialRuntimeMainnet";
    ChainId[ChainId["TOOLGlobalMainnet"] = 8723] = "TOOLGlobalMainnet";
    ChainId[ChainId["TOOLGlobalTestnet"] = 8724] = "TOOLGlobalTestnet";
    ChainId[ChainId["StoragechainMainnet"] = 8726] = "StoragechainMainnet";
    ChainId[ChainId["StoragechainTestnet"] = 8727] = "StoragechainTestnet";
    ChainId[ChainId["BullionsSmartChain"] = 8732] = "BullionsSmartChain";
    ChainId[ChainId["AlphNetwork"] = 8738] = "AlphNetwork";
    ChainId[ChainId["TMYChain"] = 8768] = "TMYChain";
    ChainId[ChainId["OktoTestnet"] = 8801] = "OktoTestnet";
    ChainId[ChainId["Haven1"] = 8811] = "Haven1";
    ChainId[ChainId["IOTAEVM"] = 8822] = "IOTAEVM";
    ChainId[ChainId["HydraChainTestnet"] = 8844] = "HydraChainTestnet";
    ChainId[ChainId["MAROBlockchainMainnet"] = 8848] = "MAROBlockchainMainnet";
    ChainId[ChainId["SuperLumio"] = 8866] = "SuperLumio";
    ChainId[ChainId["Lif3Chain"] = 8869] = "Lif3Chain";
    ChainId[ChainId["Unique"] = 8880] = "Unique";
    ChainId[ChainId["QuartzbyUnique"] = 8881] = "QuartzbyUnique";
    ChainId[ChainId["OpaltestnetbyUnique"] = 8882] = "OpaltestnetbyUnique";
    ChainId[ChainId["SapphirebyUnique"] = 8883] = "SapphirebyUnique";
    ChainId[ChainId["AveniumTestnet"] = 8886] = "AveniumTestnet";
    ChainId[ChainId["XANAChain"] = 8888] = "XANAChain";
    ChainId[ChainId["VyvoSmartChain"] = 8889] = "VyvoSmartChain";
    ChainId[ChainId["OreniumTestnetProtocol"] = 8890] = "OreniumTestnetProtocol";
    ChainId[ChainId["MammothMainnet"] = 8898] = "MammothMainnet";
    ChainId[ChainId["JIBCHAINL1"] = 8899] = "JIBCHAINL1";
    ChainId[ChainId["Algen"] = 8911] = "Algen";
    ChainId[ChainId["AlgenTestnet"] = 8912] = "AlgenTestnet";
    ChainId[ChainId["AlgenLayer2"] = 8921] = "AlgenLayer2";
    ChainId[ChainId["AlgenLayer2Testnet"] = 8922] = "AlgenLayer2Testnet";
    ChainId[ChainId["GiantMammothMainnet"] = 8989] = "GiantMammothMainnet";
    ChainId[ChainId["Bloxberg"] = 8995] = "Bloxberg";
    ChainId[ChainId["EvmosTestnet"] = 9000] = "EvmosTestnet";
    ChainId[ChainId["Evmos"] = 9001] = "Evmos";
    ChainId[ChainId["QubeticsAlphaTestnet"] = 9003] = "QubeticsAlphaTestnet";
    ChainId[ChainId["ShidoTestnetBlock"] = 9007] = "ShidoTestnetBlock";
    ChainId[ChainId["ShidoNetwork"] = 9008] = "ShidoNetwork";
    ChainId[ChainId["BerylBitMainnet"] = 9012] = "BerylBitMainnet";
    ChainId[ChainId["NexaTestnetBlock"] = 9024] = "NexaTestnetBlock";
    ChainId[ChainId["NexaMainnetBlock"] = 9025] = "NexaMainnetBlock";
    ChainId[ChainId["QubeticsTestnet"] = 9029] = "QubeticsTestnet";
    ChainId[ChainId["ApexFusion-NexusMainnet"] = 9069] = "ApexFusion-NexusMainnet";
    ChainId[ChainId["ApexFusion-Nexustestnet"] = 9070] = "ApexFusion-Nexustestnet";
    ChainId[ChainId["IncoGentryTestnet"] = 9090] = "IncoGentryTestnet";
    ChainId[ChainId["KPASmartChainTestnet"] = 9091] = "KPASmartChainTestnet";
    ChainId[ChainId["GenesisCoin"] = 9100] = "GenesisCoin";
    ChainId[ChainId["DestraDubaiTestnet"] = 9108] = "DestraDubaiTestnet";
    ChainId[ChainId["RiniaTestnetOld"] = 9170] = "RiniaTestnetOld";
    ChainId[ChainId["CodefinMainnet"] = 9223] = "CodefinMainnet";
    ChainId[ChainId["Galactica-Reticulum"] = 9302] = "Galactica-Reticulum";
    ChainId[ChainId["DogcoinTestnet"] = 9339] = "DogcoinTestnet";
    ChainId[ChainId["ZChain"] = 9369] = "ZChain";
    ChainId[ChainId["OasysTestnet"] = 9372] = "OasysTestnet";
    ChainId[ChainId["DelaSepoliaTestnet"] = 9393] = "DelaSepoliaTestnet";
    ChainId[ChainId["EvokeMainnet"] = 9395] = "EvokeMainnet";
    ChainId[ChainId["LoadAlphanet"] = 9496] = "LoadAlphanet";
    ChainId[ChainId["RangersProtocolTestnetRobin"] = 9527] = "RangersProtocolTestnetRobin";
    ChainId[ChainId["QEasyWeb3Testnet"] = 9528] = "QEasyWeb3Testnet";
    ChainId[ChainId["NeonlinkTestnet"] = 9559] = "NeonlinkTestnet";
    ChainId[ChainId["RebusMainnet"] = 9696] = "RebusMainnet";
    ChainId[ChainId["OortMainnetDev"] = 9700] = "OortMainnetDev";
    ChainId[ChainId["BobaBNBTestnet"] = 9728] = "BobaBNBTestnet";
    ChainId[ChainId["MainnetZTestnet"] = 9768] = "MainnetZTestnet";
    ChainId[ChainId["PepeNetworkMainnet"] = 9779] = "PepeNetworkMainnet";
    ChainId[ChainId["TabiTestnetv2"] = 9788] = "TabiTestnetv2";
    ChainId[ChainId["TabiTestnet"] = 9789] = "TabiTestnet";
    ChainId[ChainId["CarbonEVM"] = 9790] = "CarbonEVM";
    ChainId[ChainId["CarbonEVMTestnet"] = 9792] = "CarbonEVMTestnet";
    ChainId[ChainId["OptimusZ7Mainnet"] = 9797] = "OptimusZ7Mainnet";
    ChainId[ChainId["IMPERIUMTESTNET"] = 9818] = "IMPERIUMTESTNET";
    ChainId[ChainId["IMPERIUMMAINNET"] = 9819] = "IMPERIUMMAINNET";
    ChainId[ChainId["BinaryChainTestnet"] = 9876] = "BinaryChainTestnet";
    ChainId[ChainId["DogelayerMainnet"] = 9888] = "DogelayerMainnet";
    ChainId[ChainId["Pointledger"] = 9889] = "Pointledger";
    ChainId[ChainId["Arena-z-testnet"] = 9897] = "Arena-z-testnet";
    ChainId[ChainId["LarissaChain"] = 9898] = "LarissaChain";
    ChainId[ChainId["ZytronLineaMainnet"] = 9901] = "ZytronLineaMainnet";
    ChainId[ChainId["EspentoMainnet"] = 9911] = "EspentoMainnet";
    ChainId[ChainId["UXERTESTNETNETWORK"] = 9966] = "UXERTESTNETNETWORK";
    ChainId[ChainId["MindSmartChainTestnet"] = 9977] = "MindSmartChainTestnet";
    ChainId[ChainId["ComboMainnet"] = 9980] = "ComboMainnet";
    ChainId[ChainId["VolleyMainnet"] = 9981] = "VolleyMainnet";
    ChainId[ChainId["MFEVCHAINMAINNET"] = 9982] = "MFEVCHAINMAINNET";
    ChainId[ChainId["AgungNetwork"] = 9990] = "AgungNetwork";
    ChainId[ChainId["MindSmartChainMainnet"] = 9996] = "MindSmartChainMainnet";
    ChainId[ChainId["AltLayerTestnet"] = 9997] = "AltLayerTestnet";
    ChainId[ChainId["ZtcMainnet"] = 9998] = "ZtcMainnet";
    ChainId[ChainId["MyOwnTestnet"] = 9999] = "MyOwnTestnet";
    ChainId[ChainId["SmartBitcoinCash"] = 10000] = "SmartBitcoinCash";
    ChainId[ChainId["SmartBitcoinCashTestnet"] = 10001] = "SmartBitcoinCashTestnet";
    ChainId[ChainId["WardenTestnet"] = 10010] = "WardenTestnet";
    ChainId[ChainId["DeepSafeBetaMainnet"] = 10011] = "DeepSafeBetaMainnet";
    ChainId[ChainId["GonChain"] = 10024] = "GonChain";
    ChainId[ChainId["AEONChain"] = 10025] = "AEONChain";
    ChainId[ChainId["ChainOperaTestnet"] = 10066] = "ChainOperaTestnet";
    ChainId[ChainId["JapanOpenChainTestnet"] = 10081] = "JapanOpenChainTestnet";
    ChainId[ChainId["VolcanoChainMainnet"] = 10085] = "VolcanoChainMainnet";
    ChainId[ChainId["SJATSH"] = 10086] = "SJATSH";
    ChainId[ChainId["MetaNovaVerse"] = 10096] = "MetaNovaVerse";
    ChainId[ChainId["BlockchainGenesisMainnet"] = 10101] = "BlockchainGenesisMainnet";
    ChainId[ChainId["MonadTestnet"] = 10143] = "MonadTestnet";
    ChainId[ChainId["GnosisChiadoTestnet"] = 10200] = "GnosisChiadoTestnet";
    ChainId[ChainId["MaxxChainMainnet"] = 10201] = "MaxxChainMainnet";
    ChainId[ChainId["TeaSepoliaTestnet"] = 10218] = "TeaSepoliaTestnet";
    ChainId[ChainId["GLScan"] = 10222] = "GLScan";
    ChainId[ChainId["ArtheraMainnet"] = 10242] = "ArtheraMainnet";
    ChainId[ChainId["ArtheraTestnet"] = 10243] = "ArtheraTestnet";
    ChainId[ChainId["0XTade"] = 10248] = "0XTade";
    ChainId[ChainId["TAOEVMMainnet"] = 10321] = "TAOEVMMainnet";
    ChainId[ChainId["TAOEVMTestnet"] = 10324] = "TAOEVMTestnet";
    ChainId[ChainId["WorldLandTestnet"] = 10395] = "WorldLandTestnet";
    ChainId[ChainId["NumbersMainnet"] = 10507] = "NumbersMainnet";
    ChainId[ChainId["NumbersTestnet"] = 10508] = "NumbersTestnet";
    ChainId[ChainId["CryptoCoinPay"] = 10823] = "CryptoCoinPay";
    ChainId[ChainId["Lamina1"] = 10849] = "Lamina1";
    ChainId[ChainId["Lamina1Identity"] = 10850] = "Lamina1Identity";
    ChainId[ChainId["GameSwiftChainTestnet"] = 10888] = "GameSwiftChainTestnet";
    ChainId[ChainId["FuseFlashTestnet"] = 10920] = "FuseFlashTestnet";
    ChainId[ChainId["QuadransBlockchain"] = 10946] = "QuadransBlockchain";
    ChainId[ChainId["QuadransBlockchainTestnet"] = 10947] = "QuadransBlockchainTestnet";
    ChainId[ChainId["KBChain"] = 11000] = "KBChain";
    ChainId[ChainId["ShapeSepoliaTestnet"] = 11011] = "ShapeSepoliaTestnet";
    ChainId[ChainId["BoolNetworkBetaMainnet"] = 11100] = "BoolNetworkBetaMainnet";
    ChainId[ChainId["Astra"] = 11110] = "Astra";
    ChainId[ChainId["WAGMI"] = 11111] = "WAGMI";
    ChainId[ChainId["AstraTestnet"] = 11115] = "AstraTestnet";
    ChainId[ChainId["HashBitMainnet"] = 11119] = "HashBitMainnet";
    ChainId[ChainId["AbstractSepoliaTestnet"] = 11124] = "AbstractSepoliaTestnet";
    ChainId[ChainId["ShineChain"] = 11221] = "ShineChain";
    ChainId[ChainId["JiritsuTestnetSubnet"] = 11227] = "JiritsuTestnetSubnet";
    ChainId[ChainId["HaqqNetwork"] = 11235] = "HaqqNetwork";
    ChainId[ChainId["StateMeshTestnet"] = 11343] = "StateMeshTestnet";
    ChainId[ChainId["ShyftTestnet"] = 11437] = "ShyftTestnet";
    ChainId[ChainId["EGoldChain"] = 11451] = "EGoldChain";
    ChainId[ChainId["GEBMainnet"] = 11501] = "GEBMainnet";
    ChainId[ChainId["BEVMTestnet"] = 11503] = "BEVMTestnet";
    ChainId[ChainId["GEBSignet"] = 11504] = "GEBSignet";
    ChainId[ChainId["SatsChain"] = 11521] = "SatsChain";
    ChainId[ChainId["SardisTestnet"] = 11612] = "SardisTestnet";
    ChainId[ChainId["ArtelaMainnet"] = 11820] = "ArtelaMainnet";
    ChainId[ChainId["ArtelaTestnet"] = 11822] = "ArtelaTestnet";
    ChainId[ChainId["SantimentIntelligenceNetworkDEPRECATED"] = 11888] = "SantimentIntelligenceNetworkDEPRECATED";
    ChainId[ChainId["PolygonSupernetArianee"] = 11891] = "PolygonSupernetArianee";
    ChainId[ChainId["FuseTestnet"] = 12001] = "FuseTestnet";
    ChainId[ChainId["SatoshiChainMainnet"] = 12009] = "SatoshiChainMainnet";
    ChainId[ChainId["Aternos"] = 12020] = "Aternos";
    ChainId[ChainId["SingularityZEROTestnet"] = 12051] = "SingularityZEROTestnet";
    ChainId[ChainId["SingularityZEROMainnet"] = 12052] = "SingularityZEROMainnet";
    ChainId[ChainId["BRCChainMainnet"] = 12123] = "BRCChainMainnet";
    ChainId[ChainId["FibonacciMainnet"] = 12306] = "FibonacciMainnet";
    ChainId[ChainId["BLGTestnet"] = 12321] = "BLGTestnet";
    ChainId[ChainId["Huddle01dRTCChain"] = 12323] = "Huddle01dRTCChain";
    ChainId[ChainId["L3XProtocol"] = 12324] = "L3XProtocol";
    ChainId[ChainId["L3XProtocolTestnet"] = 12325] = "L3XProtocolTestnet";
    ChainId[ChainId["StepTestnet"] = 12345] = "StepTestnet";
    ChainId[ChainId["GDPRMainnet"] = 12358] = "GDPRMainnet";
    ChainId[ChainId["RSS3VSLMainnet"] = 12553] = "RSS3VSLMainnet";
    ChainId[ChainId["RikezaNetworkTestnet"] = 12715] = "RikezaNetworkTestnet";
    ChainId[ChainId["PlaydappTestnet"] = 12781] = "PlaydappTestnet";
    ChainId[ChainId["QuantumChainTestnet"] = 12890] = "QuantumChainTestnet";
    ChainId[ChainId["PlayFairTestnetSubnet"] = 12898] = "PlayFairTestnetSubnet";
    ChainId[ChainId["SPS"] = 13000] = "SPS";
    ChainId[ChainId["CreditSmartChain"] = 13308] = "CreditSmartChain";
    ChainId[ChainId["BeamTestnet"] = 13337] = "BeamTestnet";
    ChainId[ChainId["CannonTestnet"] = 13370] = "CannonTestnet";
    ChainId[ChainId["ImmutablezkEVM"] = 13371] = "ImmutablezkEVM";
    ChainId[ChainId["PhoenixMainnet"] = 13381] = "PhoenixMainnet";
    ChainId[ChainId["Masa"] = 13396] = "Masa";
    ChainId[ChainId["ImmutablezkEVMTestnet"] = 13473] = "ImmutablezkEVMTestnet";
    ChainId[ChainId["GravityAlphaTestnetSepolia"] = 13505] = "GravityAlphaTestnetSepolia";
    ChainId[ChainId["KronobitMainnet"] = 13600] = "KronobitMainnet";
    ChainId[ChainId["Game7Testnet"] = 13746] = "Game7Testnet";
    ChainId[ChainId["Susono"] = 13812] = "Susono";
    ChainId[ChainId["SPSTestnet"] = 14000] = "SPSTestnet";
    ChainId[ChainId["ZerothTestnet"] = 14088] = "ZerothTestnet";
    ChainId[ChainId["BitharvestChainMainnet"] = 14149] = "BitharvestChainMainnet";
    ChainId[ChainId["Bitlazer"] = 14235] = "Bitlazer";
    ChainId[ChainId["EVOLVETestnet"] = 14324] = "EVOLVETestnet";
    ChainId[ChainId["VitruveoTestnet"] = 14333] = "VitruveoTestnet";
    ChainId[ChainId["VanaMokshaTestnet"] = 14800] = "VanaMokshaTestnet";
    ChainId[ChainId["VanaSatoriTestnet"] = 14801] = "VanaSatoriTestnet";
    ChainId[ChainId["HumanodeTestnet5Israfel"] = 14853] = "HumanodeTestnet5Israfel";
    ChainId[ChainId["ImmutablezkEVMDevnet"] = 15003] = "ImmutablezkEVMDevnet";
    ChainId[ChainId["PoodlTestnet"] = 15257] = "PoodlTestnet";
    ChainId[ChainId["PoodlMainnet"] = 15259] = "PoodlMainnet";
    ChainId[ChainId["KYMTCMainnet"] = 15430] = "KYMTCMainnet";
    ChainId[ChainId["LoopNetworkMainnet"] = 15551] = "LoopNetworkMainnet";
    ChainId[ChainId["TrustEVMTestnet"] = 15555] = "TrustEVMTestnet";
    ChainId[ChainId["EOSEVMNetworkTestnet"] = 15557] = "EOSEVMNetworkTestnet";
    ChainId[ChainId["MetaDotMainnet"] = 16000] = "MetaDotMainnet";
    ChainId[ChainId["MetaDotTestnet"] = 16001] = "MetaDotTestnet";
    ChainId[ChainId["DeFiVerseMainnet"] = 16116] = "DeFiVerseMainnet";
    ChainId[ChainId["CypheriumMainnet"] = 16166] = "CypheriumMainnet";
    ChainId[ChainId["PLYRPHI"] = 16180] = "PLYRPHI";
    ChainId[ChainId["EventumTestnet"] = 16182] = "EventumTestnet";
    ChainId[ChainId["IncentivDevnet"] = 16350] = "IncentivDevnet";
    ChainId[ChainId["PivotalSepolia"] = 16481] = "PivotalSepolia";
    ChainId[ChainId["GenesysMainnet"] = 16507] = "GenesysMainnet";
    ChainId[ChainId["0G-Newton-Testnet"] = 16600] = "0G-Newton-Testnet";
    ChainId[ChainId["IRIShubTestnet"] = 16688] = "IRIShubTestnet";
    ChainId[ChainId["AirDAOMainnet"] = 16718] = "AirDAOMainnet";
    ChainId[ChainId["IVARChainTestnet"] = 16888] = "IVARChainTestnet";
    ChainId[ChainId["Holesky"] = 17000] = "Holesky";
    ChainId[ChainId["RedstoneHoleskyTestnet"] = 17001] = "RedstoneHoleskyTestnet";
    ChainId[ChainId["GarnetHolesky"] = 17069] = "GarnetHolesky";
    ChainId[ChainId["OnchainPoints"] = 17071] = "OnchainPoints";
    ChainId[ChainId["DeFiVerseTestnet"] = 17117] = "DeFiVerseTestnet";
    ChainId[ChainId["G8ChainMainnet"] = 17171] = "G8ChainMainnet";
    ChainId[ChainId["EclipseSubnet"] = 17172] = "EclipseSubnet";
    ChainId[ChainId["PaletteChainTestnet"] = 17180] = "PaletteChainTestnet";
    ChainId[ChainId["KONETMainnet"] = 17217] = "KONETMainnet";
    ChainId[ChainId["EsportsChain"] = 17735] = "EsportsChain";
    ChainId[ChainId["EOSEVMNetwork"] = 17777] = "EOSEVMNetwork";
    ChainId[ChainId["FrontierofDreamsTestnet"] = 18000] = "FrontierofDreamsTestnet";
    ChainId[ChainId["SmartTradeNetworks"] = 18122] = "SmartTradeNetworks";
    ChainId[ChainId["ProofOfMemes"] = 18159] = "ProofOfMemes";
    ChainId[ChainId["G8ChainTestnet"] = 18181] = "G8ChainTestnet";
    ChainId[ChainId["Unreal-old"] = 18231] = "Unreal-old";
    ChainId[ChainId["Unreal"] = 18233] = "Unreal";
    ChainId[ChainId["MXCzkEVMMoonchain"] = 18686] = "MXCzkEVMMoonchain";
    ChainId[ChainId["EXPchainTestnet"] = 18880] = "EXPchainTestnet";
    ChainId[ChainId["UltraEVMNetworkTestnet"] = 18881] = "UltraEVMNetworkTestnet";
    ChainId[ChainId["Titan(TKX)"] = 18888] = "Titan(TKX)";
    ChainId[ChainId["Titan(TKX)Testnet"] = 18889] = "Titan(TKX)Testnet";
    ChainId[ChainId["HOMEVerseMainnet"] = 19011] = "HOMEVerseMainnet";
    ChainId[ChainId["BlockXAtlantisTestnet"] = 19077] = "BlockXAtlantisTestnet";
    ChainId[ChainId["LocaChainMainnet"] = 19180] = "LocaChainMainnet";
    ChainId[ChainId["BlockXMainnet"] = 19191] = "BlockXMainnet";
    ChainId[ChainId["DecentraconnectSocial"] = 19224] = "DecentraconnectSocial";
    ChainId[ChainId["SECTestnet"] = 19515] = "SECTestnet";
    ChainId[ChainId["SECMainnet"] = 19516] = "SECMainnet";
    ChainId[ChainId["MagnetNetwork"] = 19527] = "MagnetNetwork";
    ChainId[ChainId["ZytronLineaTestnet"] = 19546] = "ZytronLineaTestnet";
    ChainId[ChainId["LBRYMainnet"] = 19600] = "LBRYMainnet";
    ChainId[ChainId["AstraSepolia"] = 19777] = "AstraSepolia";
    ChainId[ChainId["BTCIXNetwork"] = 19845] = "BTCIXNetwork";
    ChainId[ChainId["UltraEVMNetwork"] = 19991] = "UltraEVMNetwork";
    ChainId[ChainId["CamelarkMainnet"] = 20001] = "CamelarkMainnet";
    ChainId[ChainId["NizaChainMainnet"] = 20041] = "NizaChainMainnet";
    ChainId[ChainId["NizaChainTestnet"] = 20073] = "NizaChainTestnet";
    ChainId[ChainId["MonadDevnet"] = 20143] = "MonadDevnet";
    ChainId[ChainId["XUSDONEStableChainMainnet"] = 20441] = "XUSDONEStableChainMainnet";
    ChainId[ChainId["CallistoTestnet"] = 20729] = "CallistoTestnet";
    ChainId[ChainId["P12Chain"] = 20736] = "P12Chain";
    ChainId[ChainId["Jono11Subnet"] = 20765] = "Jono11Subnet";
    ChainId[ChainId["FluentDeveloperPreview"] = 20993] = "FluentDeveloperPreview";
    ChainId[ChainId["ActionMainnet"] = 21000] = "ActionMainnet";
    ChainId[ChainId["C4EI"] = 21004] = "C4EI";
    ChainId[ChainId["RivestTestnet"] = 21097] = "RivestTestnet";
    ChainId[ChainId["AllAboutHealthy"] = 21133] = "AllAboutHealthy";
    ChainId[ChainId["1MoneyNetworkMainnet"] = 21210] = "1MoneyNetworkMainnet";
    ChainId[ChainId["DCpayMainnet"] = 21223] = "DCpayMainnet";
    ChainId[ChainId["DCpayTestnet"] = 21224] = "DCpayTestnet";
    ChainId[ChainId["CENNZnetAzalea"] = 21337] = "CENNZnetAzalea";
    ChainId[ChainId["Lestnet"] = 21363] = "Lestnet";
    ChainId[ChainId["OmChainMainnet"] = 21816] = "OmChainMainnet";
    ChainId[ChainId["BSLMainnet"] = 21912] = "BSLMainnet";
    ChainId[ChainId["Taycan"] = 22023] = "Taycan";
    ChainId[ChainId["AirDAOTestnet"] = 22040] = "AirDAOTestnet";
    ChainId[ChainId["NautilusMainnet"] = 22222] = "NautilusMainnet";
    ChainId[ChainId["GoldXChainTestnet"] = 22324] = "GoldXChainTestnet";
    ChainId[ChainId["MAPProtocol"] = 22776] = "MAPProtocol";
    ChainId[ChainId["AntofyTestnet"] = 23006] = "AntofyTestnet";
    ChainId[ChainId["PremiumBlock"] = 23023] = "PremiumBlock";
    ChainId[ChainId["OpsideTestnet"] = 23118] = "OpsideTestnet";
    ChainId[ChainId["OasisSapphire"] = 23294] = "OasisSapphire";
    ChainId[ChainId["OasisSapphireTestnet"] = 23295] = "OasisSapphireTestnet";
    ChainId[ChainId["DreyerXMainnet"] = 23451] = "DreyerXMainnet";
    ChainId[ChainId["DreyerXTestnet"] = 23452] = "DreyerXTestnet";
    ChainId[ChainId["BlastTestnet"] = 23888] = "BlastTestnet";
    ChainId[ChainId["KYMTCTestnet"] = 24076] = "KYMTCTestnet";
    ChainId[ChainId["Amauti"] = 24116] = "Amauti";
    ChainId[ChainId["Nexurachain"] = 24125] = "Nexurachain";
    ChainId[ChainId["Webchain"] = 24484] = "Webchain";
    ChainId[ChainId["MintMe.comCoin"] = 24734] = "MintMe.comCoin";
    ChainId[ChainId["Recall"] = 24816] = "Recall";
    ChainId[ChainId["LiquidLayerMainnet"] = 25186] = "LiquidLayerMainnet";
    ChainId[ChainId["EverclearMainnet"] = 25327] = "EverclearMainnet";
    ChainId[ChainId["AlveyChainTestnet"] = 25839] = "AlveyChainTestnet";
    ChainId[ChainId["HammerChainMainnet"] = 25888] = "HammerChainMainnet";
    ChainId[ChainId["KUBTestnet"] = 25925] = "KUBTestnet";
    ChainId[ChainId["FerrumTestnet"] = 26026] = "FerrumTestnet";
    ChainId[ChainId["FerrumQuantumPortalNetwork"] = 26100] = "FerrumQuantumPortalNetwork";
    ChainId[ChainId["DucatusXTestnet"] = 26482] = "DucatusXTestnet";
    ChainId[ChainId["DucatusX"] = 26483] = "DucatusX";
    ChainId[ChainId["HertzNetworkMainnet"] = 26600] = "HertzNetworkMainnet";
    ChainId[ChainId["OasisChainMainnet"] = 26863] = "OasisChainMainnet";
    ChainId[ChainId["ABCoreTestnet"] = 26888] = "ABCoreTestnet";
    ChainId[ChainId["NewtonFinanceTestnet"] = 26988] = "NewtonFinanceTestnet";
    ChainId[ChainId["XferChainTestnet"] = 27125] = "XferChainTestnet";
    ChainId[ChainId["KLAOSNova"] = 27181] = "KLAOSNova";
    ChainId[ChainId["NanonSepolia"] = 27483] = "NanonSepolia";
    ChainId[ChainId["ZerooneMainnetSubnet"] = 27827] = "ZerooneMainnetSubnet";
    ChainId[ChainId["XferChainMainnet"] = 28125] = "XferChainMainnet";
    ChainId[ChainId["VizingTestnet"] = 28516] = "VizingTestnet";
    ChainId[ChainId["VizingMainnet"] = 28518] = "VizingMainnet";
    ChainId[ChainId["OptimismBedrock(GoerliAlphaTestnet)"] = 28528] = "OptimismBedrock(GoerliAlphaTestnet)";
    ChainId[ChainId["BobaSepolia"] = 28882] = "BobaSepolia";
    ChainId[ChainId["HYCHAINTestnet"] = 29112] = "HYCHAINTestnet";
    ChainId[ChainId["NexaMetaNet"] = 29223] = "NexaMetaNet";
    ChainId[ChainId["NexaMetaTest"] = 29225] = "NexaMetaTest";
    ChainId[ChainId["KaiChainTestnet"] = 29536] = "KaiChainTestnet";
    ChainId[ChainId["MCHVerseMainnet"] = 29548] = "MCHVerseMainnet";
    ChainId[ChainId["QChainMainnet"] = 30000] = "QChainMainnet";
    ChainId[ChainId["Piecetestnet"] = 30067] = "Piecetestnet";
    ChainId[ChainId["MiYouMainnet"] = 30088] = "MiYouMainnet";
    ChainId[ChainId["CeriumTestnet"] = 30103] = "CeriumTestnet";
    ChainId[ChainId["MovementEVMLegacy"] = 30730] = "MovementEVMLegacy";
    ChainId[ChainId["MovementEVMDevnet"] = 30731] = "MovementEVMDevnet";
    ChainId[ChainId["MovementEVMTestnet"] = 30732] = "MovementEVMTestnet";
    ChainId[ChainId["EthersocialNetwork"] = 31102] = "EthersocialNetwork";
    ChainId[ChainId["CloudTxMainnet"] = 31223] = "CloudTxMainnet";
    ChainId[ChainId["CloudTxTestnet"] = 31224] = "CloudTxTestnet";
    ChainId[ChainId["GoChainTestnet"] = 31337] = "GoChainTestnet";
    ChainId[ChainId["EvokeTestnet"] = 31414] = "EvokeTestnet";
    ChainId[ChainId["WirexPayMainnet"] = 31415] = "WirexPayMainnet";
    ChainId[ChainId["MezoTestnet"] = 31611] = "MezoTestnet";
    ChainId[ChainId["Mezo"] = 31612] = "Mezo";
    ChainId[ChainId["XchainMainnet(Deprecated)"] = 31753] = "XchainMainnet(Deprecated)";
    ChainId[ChainId["XchainTestnet(Deprecated)"] = 31754] = "XchainTestnet(Deprecated)";
    ChainId[ChainId["W3GamezHoleskyTestnet"] = 32001] = "W3GamezHoleskyTestnet";
    ChainId[ChainId["BasedAI"] = 32323] = "BasedAI";
    ChainId[ChainId["SantimentIntelligenceNetwork"] = 32382] = "SantimentIntelligenceNetwork";
    ChainId[ChainId["BitgertMainnet"] = 32520] = "BitgertMainnet";
    ChainId[ChainId["FusionMainnet"] = 32659] = "FusionMainnet";
    ChainId[ChainId["ZilliqaEVM"] = 32769] = "ZilliqaEVM";
    ChainId[ChainId["Zilliqa2EVMproto-mainnet"] = 32770] = "Zilliqa2EVMproto-mainnet";
    ChainId[ChainId["ZilliqaEVMIsolatedServer"] = 32990] = "ZilliqaEVMIsolatedServer";
    ChainId[ChainId["EntangleMainnet"] = 33033] = "EntangleMainnet";
    ChainId[ChainId["ZilliqaEVMTestnet"] = 33101] = "ZilliqaEVMTestnet";
    ChainId[ChainId["Zilliqa2EVMproto-testnet"] = 33103] = "Zilliqa2EVMproto-testnet";
    ChainId[ChainId["Curtis"] = 33111] = "Curtis";
    ChainId[ChainId["EntangleTestnet"] = 33133] = "EntangleTestnet";
    ChainId[ChainId["ApeChain"] = 33139] = "ApeChain";
    ChainId[ChainId["CloudverseSubnet"] = 33210] = "CloudverseSubnet";
    ChainId[ChainId["AvesMainnet"] = 33333] = "AvesMainnet";
    ChainId[ChainId["ZilliqaEVMDevnet"] = 33385] = "ZilliqaEVMDevnet";
    ChainId[ChainId["SlingShot"] = 33401] = "SlingShot";
    ChainId[ChainId["Zilliqa2EVMdevnet"] = 33469] = "Zilliqa2EVMdevnet";
    ChainId[ChainId["R5NetworkTestnet"] = 33710] = "R5NetworkTestnet";
    ChainId[ChainId["Funki"] = 33979] = "Funki";
    ChainId[ChainId["PencilsProtocolSepoliaTestnet"] = 33999] = "PencilsProtocolSepoliaTestnet";
    ChainId[ChainId["Mode"] = 34443] = "Mode";
    ChainId[ChainId["ZEUSMainnet"] = 34504] = "ZEUSMainnet";
    ChainId[ChainId["J2OTaro"] = 35011] = "J2OTaro";
    ChainId[ChainId["QMainnet"] = 35441] = "QMainnet";
    ChainId[ChainId["QTestnet"] = 35443] = "QTestnet";
    ChainId[ChainId["LensTestnet"] = 37111] = "LensTestnet";
    ChainId[ChainId["ConnectorManager"] = 38400] = "ConnectorManager";
    ChainId[ChainId["ConnectorManagerRobin"] = 38401] = "ConnectorManagerRobin";
    ChainId[ChainId["PRMMainnet"] = 39656] = "PRMMainnet";
    ChainId[ChainId["EnergiMainnet"] = 39797] = "EnergiMainnet";
    ChainId[ChainId["OHOMainnet"] = 39815] = "OHOMainnet";
    ChainId[ChainId["DIVChain"] = 40000] = "DIVChain";
    ChainId[ChainId["AlephZeroEVM"] = 41455] = "AlephZeroEVM";
    ChainId[ChainId["Opulent-XBETA"] = 41500] = "Opulent-XBETA";
    ChainId[ChainId["EDUChain"] = 41923] = "EDUChain";
    ChainId[ChainId["HeliosChainTestnet"] = 42000] = "HeliosChainTestnet";
    ChainId[ChainId["PMONChain"] = 42001] = "PMONChain";
    ChainId[ChainId["Donatuz"] = 42026] = "Donatuz";
    ChainId[ChainId["Pegglecoin"] = 42069] = "Pegglecoin";
    ChainId[ChainId["WMCTestnet"] = 42070] = "WMCTestnet";
    ChainId[ChainId["AgentLayerTestnet"] = 42072] = "AgentLayerTestnet";
    ChainId[ChainId["HeuristTestnet"] = 42096] = "HeuristTestnet";
    ChainId[ChainId["ArbitrumOne"] = 42161] = "ArbitrumOne";
    ChainId[ChainId["ArbitrumNova"] = 42170] = "ArbitrumNova";
    ChainId[ChainId["CeloMainnet"] = 42220] = "CeloMainnet";
    ChainId[ChainId["OasisEmeraldTestnet"] = 42261] = "OasisEmeraldTestnet";
    ChainId[ChainId["OasisEmerald"] = 42262] = "OasisEmerald";
    ChainId[ChainId["GoldXChainMainnet"] = 42355] = "GoldXChainMainnet";
    ChainId[ChainId["AssetChainMainnet"] = 42420] = "AssetChainMainnet";
    ChainId[ChainId["AssetChainTestnet"] = 42421] = "AssetChainTestnet";
    ChainId[ChainId["ZKFairMainnet"] = 42766] = "ZKFairMainnet";
    ChainId[ChainId["EtherlinkMainnet"] = 42793] = "EtherlinkMainnet";
    ChainId[ChainId["GesotenVerseTestnet"] = 42801] = "GesotenVerseTestnet";
    ChainId[ChainId["KintoTestnet"] = 42888] = "KintoTestnet";
    ChainId[ChainId["Athereum"] = 43110] = "Athereum";
    ChainId[ChainId["Hemi"] = 43111] = "Hemi";
    ChainId[ChainId["AvalancheFujiTestnet"] = 43113] = "AvalancheFujiTestnet";
    ChainId[ChainId["AvalancheC-Chain"] = 43114] = "AvalancheC-Chain";
    ChainId[ChainId["BobaAvax"] = 43288] = "BobaAvax";
    ChainId[ChainId["GUNZ"] = 43419] = "GUNZ";
    ChainId[ChainId["Formicarium"] = 43521] = "Formicarium";
    ChainId[ChainId["ZKFairTestnet"] = 43851] = "ZKFairTestnet";
    ChainId[ChainId["Frenchain"] = 44444] = "Frenchain";
    ChainId[ChainId["QuantumNetwork"] = 44445] = "QuantumNetwork";
    ChainId[ChainId["CeloAlfajoresTestnet"] = 44787] = "CeloAlfajoresTestnet";
    ChainId[ChainId["AutobahnNetwork"] = 45000] = "AutobahnNetwork";
    ChainId[ChainId["JuneoJUNE-Chain"] = 45003] = "JuneoJUNE-Chain";
    ChainId[ChainId["JuneoDAI1-Chain"] = 45004] = "JuneoDAI1-Chain";
    ChainId[ChainId["JuneoUSDT1-Chain"] = 45005] = "JuneoUSDT1-Chain";
    ChainId[ChainId["JuneoUSD1-Chain"] = 45006] = "JuneoUSD1-Chain";
    ChainId[ChainId["JuneomBTC1-Chain"] = 45007] = "JuneomBTC1-Chain";
    ChainId[ChainId["JuneoGLD1-Chain"] = 45008] = "JuneoGLD1-Chain";
    ChainId[ChainId["JuneoLTC1-Chain"] = 45009] = "JuneoLTC1-Chain";
    ChainId[ChainId["JuneoDOGE1-Chain"] = 45010] = "JuneoDOGE1-Chain";
    ChainId[ChainId["JuneoEUR1-Chain"] = 45011] = "JuneoEUR1-Chain";
    ChainId[ChainId["JuneoSGD1-Chain"] = 45012] = "JuneoSGD1-Chain";
    ChainId[ChainId["JuneoBCH1-Chain"] = 45013] = "JuneoBCH1-Chain";
    ChainId[ChainId["JuneoLINK1-Chain"] = 45014] = "JuneoLINK1-Chain";
    ChainId[ChainId["SwampsL2"] = 45454] = "SwampsL2";
    ChainId[ChainId["DeelanceMainnet"] = 45510] = "DeelanceMainnet";
    ChainId[ChainId["Blessnet"] = 45513] = "Blessnet";
    ChainId[ChainId["FusionTestnet"] = 46688] = "FusionTestnet";
    ChainId[ChainId["NeoXMainnet"] = 47763] = "NeoXMainnet";
    ChainId[ChainId["ReDeFiLayer1"] = 47803] = "ReDeFiLayer1";
    ChainId[ChainId["REINetwork"] = 47805] = "REINetwork";
    ChainId[ChainId["SpaceSubnetTestnet"] = 48795] = "SpaceSubnetTestnet";
    ChainId[ChainId["ZircuitGarfieldTestnet"] = 48898] = "ZircuitGarfieldTestnet";
    ChainId[ChainId["ZircuitTestnet"] = 48899] = "ZircuitTestnet";
    ChainId[ChainId["ZircuitMainnet"] = 48900] = "ZircuitMainnet";
    ChainId[ChainId["WireshapeFloripaTestnet"] = 49049] = "WireshapeFloripaTestnet";
    ChainId[ChainId["BifrostTestnet"] = 49088] = "BifrostTestnet";
    ChainId[ChainId["GUNZTestnet"] = 49321] = "GUNZTestnet";
    ChainId[ChainId["EnergiTestnet"] = 49797] = "EnergiTestnet";
    ChainId[ChainId["Citronus"] = 50000] = "Citronus";
    ChainId[ChainId["LiveplexOracleEVM"] = 50001] = "LiveplexOracleEVM";
    ChainId[ChainId["YooldoVerseMainnet"] = 50005] = "YooldoVerseMainnet";
    ChainId[ChainId["YooldoVerseTestnet"] = 50006] = "YooldoVerseTestnet";
    ChainId[ChainId["GTONTestnet"] = 50021] = "GTONTestnet";
    ChainId[ChainId["Sophon"] = 50104] = "Sophon";
    ChainId[ChainId["SomniaTestnet"] = 50312] = "SomniaTestnet";
    ChainId[ChainId["ReddioTestnet"] = 50341] = "ReddioTestnet";
    ChainId[ChainId["STBTestnet"] = 50505] = "STBTestnet";
    ChainId[ChainId["ErbieMainnet"] = 50888] = "ErbieMainnet";
    ChainId[ChainId["LumozTestnetAlpha"] = 51178] = "LumozTestnetAlpha";
    ChainId[ChainId["SardisMainnet"] = 51712] = "SardisMainnet";
    ChainId[ChainId["ElectroneumMainnet"] = 52014] = "ElectroneumMainnet";
    ChainId[ChainId["CytonicSettlementLayerTestnet"] = 52225] = "CytonicSettlementLayerTestnet";
    ChainId[ChainId["CytonicEthereumTestnet"] = 52226] = "CytonicEthereumTestnet";
    ChainId[ChainId["DOID"] = 53277] = "DOID";
    ChainId[ChainId["SuperseedSepoliaTestnet"] = 53302] = "SuperseedSepoliaTestnet";
    ChainId[ChainId["BirdLayer"] = 53456] = "BirdLayer";
    ChainId[ChainId["DODOchaintestnet"] = 53457] = "DODOchaintestnet";
    ChainId[ChainId["DFKChain"] = 53935] = "DFKChain";
    ChainId[ChainId["GraphiteTestnet"] = 54170] = "GraphiteTestnet";
    ChainId[ChainId["OverProtocolMainnet"] = 54176] = "OverProtocolMainnet";
    ChainId[ChainId["HaqqChainTestnet"] = 54211] = "HaqqChainTestnet";
    ChainId[ChainId["ToronetTestnet"] = 54321] = "ToronetTestnet";
    ChainId[ChainId["Titan"] = 55004] = "Titan";
    ChainId[ChainId["TitanSepolia"] = 55007] = "TitanSepolia";
    ChainId[ChainId["Superposition"] = 55244] = "Superposition";
    ChainId[ChainId["PhotonAuroraTestnet"] = 55551] = "PhotonAuroraTestnet";
    ChainId[ChainId["REIChainMainnet"] = 55555] = "REIChainMainnet";
    ChainId[ChainId["REIChainTestnet"] = 55556] = "REIChainTestnet";
    ChainId[ChainId["FlammaMainnet"] = 55614] = "FlammaMainnet";
    ChainId[ChainId["LambdaChainMainnet"] = 56026] = "LambdaChainMainnet";
    ChainId[ChainId["BobaBNBMainnet"] = 56288] = "BobaBNBMainnet";
    ChainId[ChainId["TestnetZerooneSubnet"] = 56400] = "TestnetZerooneSubnet";
    ChainId[ChainId["VELOLabsMainnet"] = 56789] = "VELOLabsMainnet";
    ChainId[ChainId["DOIDTestnet"] = 56797] = "DOIDTestnet";
    ChainId[ChainId["RolluxTestnet"] = 57000] = "RolluxTestnet";
    ChainId[ChainId["SonicBlazeTestnet"] = 57054] = "SonicBlazeTestnet";
    ChainId[ChainId["Ink"] = 57073] = "Ink";
    ChainId[ChainId["COINSECNetwork"] = 57451] = "COINSECNetwork";
    ChainId[ChainId["SepoliaPGN(PublicGoodsNetwork)"] = 58008] = "SepoliaPGN(PublicGoodsNetwork)";
    ChainId[ChainId["LumozQuidditchTestnet"] = 58680] = "LumozQuidditchTestnet";
    ChainId[ChainId["LineaGoerli"] = 59140] = "LineaGoerli";
    ChainId[ChainId["LineaSepolia"] = 59141] = "LineaSepolia";
    ChainId[ChainId["Linea"] = 59144] = "Linea";
    ChainId[ChainId["MetisSepoliaTestnet"] = 59902] = "MetisSepoliaTestnet";
    ChainId[ChainId["GenesysCodeMainnet"] = 59971] = "GenesysCodeMainnet";
    ChainId[ChainId["ThinkiumTestnetChain0"] = 60000] = "ThinkiumTestnetChain0";
    ChainId[ChainId["ThinkiumTestnetChain1"] = 60001] = "ThinkiumTestnetChain1";
    ChainId[ChainId["ThinkiumTestnetChain2"] = 60002] = "ThinkiumTestnetChain2";
    ChainId[ChainId["ThinkiumTestnetChain103"] = 60103] = "ThinkiumTestnetChain103";
    ChainId[ChainId["BOB"] = 60808] = "BOB";
    ChainId[ChainId["PerennialSepolia"] = 60850] = "PerennialSepolia";
    ChainId[ChainId["OrangeChainMainnet"] = 61022] = "OrangeChainMainnet";
    ChainId[ChainId["Treasure"] = 61166] = "Treasure";
    ChainId[ChainId["KaiChain"] = 61406] = "KaiChain";
    ChainId[ChainId["AxelChainDev-Net"] = 61800] = "AxelChainDev-Net";
    ChainId[ChainId["EticaMainnet"] = 61803] = "EticaMainnet";
    ChainId[ChainId["DoKENSuperChainMainnet"] = 61916] = "DoKENSuperChainMainnet";
    ChainId[ChainId["OPTOPIATestnet"] = 62049] = "OPTOPIATestnet";
    ChainId[ChainId["OptopiaMainnet"] = 62050] = "OptopiaMainnet";
    ChainId[ChainId["TikTrixTestnet"] = 62092] = "TikTrixTestnet";
    ChainId[ChainId["CitreaDevnet"] = 62298] = "CitreaDevnet";
    ChainId[ChainId["CeloBaklavaTestnet"] = 62320] = "CeloBaklavaTestnet";
    ChainId[ChainId["MultiVACMainnet"] = 62621] = "MultiVACMainnet";
    ChainId[ChainId["PLYRTAUTestnet"] = 62831] = "PLYRTAUTestnet";
    ChainId[ChainId["LAOSSigmaTestnet"] = 62850] = "LAOSSigmaTestnet";
    ChainId[ChainId["ESyncNetworkMainnet"] = 63000] = "ESyncNetworkMainnet";
    ChainId[ChainId["ECreditsTestnet"] = 63001] = "ECreditsTestnet";
    ChainId[ChainId["ESyncNetworkTestnet"] = 63002] = "ESyncNetworkTestnet";
    ChainId[ChainId["GeistMainnet"] = 63157] = "GeistMainnet";
    ChainId[ChainId["XCHAINTestnet"] = 64002] = "XCHAINTestnet";
    ChainId[ChainId["CratD2CTestnet"] = 65349] = "CratD2CTestnet";
    ChainId[ChainId["VecnoMainnet"] = 65357] = "VecnoMainnet";
    ChainId[ChainId["ScolcoinMainnet"] = 65450] = "ScolcoinMainnet";
    ChainId[ChainId["CyberChainMainnet"] = 65535] = "CyberChainMainnet";
    ChainId[ChainId["AutomataMainnet"] = 65536] = "AutomataMainnet";
    ChainId[ChainId["CreatorChainTestnet"] = 66665] = "CreatorChainTestnet";
    ChainId[ChainId["JanusTestnet"] = 66988] = "JanusTestnet";
    ChainId[ChainId["SiriusNet"] = 67390] = "SiriusNet";
    ChainId[ChainId["CosmicChain"] = 67588] = "CosmicChain";
    ChainId[ChainId["DM2VerseMainnet"] = 68770] = "DM2VerseMainnet";
    ChainId[ChainId["DM2VerseTestnet"] = 68775] = "DM2VerseTestnet";
    ChainId[ChainId["AnimechainMainnet"] = 69000] = "AnimechainMainnet";
    ChainId[ChainId["Condrieu"] = 69420] = "Condrieu";
    ChainId[ChainId["ThinkiumMainnetChain0"] = 70000] = "ThinkiumMainnetChain0";
    ChainId[ChainId["ThinkiumMainnetChain1"] = 70001] = "ThinkiumMainnetChain1";
    ChainId[ChainId["ThinkiumMainnetChain2"] = 70002] = "ThinkiumMainnetChain2";
    ChainId[ChainId["ThinkiumMainnetChain103"] = 70103] = "ThinkiumMainnetChain103";
    ChainId[ChainId["ProofofPlay-Apex"] = 70700] = "ProofofPlay-Apex";
    ChainId[ChainId["ProofofPlay-Boss"] = 70701] = "ProofofPlay-Boss";
    ChainId[ChainId["GuapcoinX"] = 71111] = "GuapcoinX";
    ChainId[ChainId["WadzchainTestnet"] = 71117] = "WadzchainTestnet";
    ChainId[ChainId["PolyjuiceTestnet"] = 71393] = "PolyjuiceTestnet";
    ChainId[ChainId["GodwokenTestnetv1"] = 71401] = "GodwokenTestnetv1";
    ChainId[ChainId["GodwokenMainnet"] = 71402] = "GodwokenMainnet";
    ChainId[ChainId["NexeraTestnet"] = 72080] = "NexeraTestnet";
    ChainId[ChainId["CAGAcryptoAnkaratestnet"] = 72778] = "CAGAcryptoAnkaratestnet";
    ChainId[ChainId["CAGAmainnet"] = 72888] = "CAGAmainnet";
    ChainId[ChainId["GrokChainMainnet"] = 72992] = "GrokChainMainnet";
    ChainId[ChainId["ICBTestnet"] = 73114] = "ICBTestnet";
    ChainId[ChainId["ICBNetwork"] = 73115] = "ICBNetwork";
    ChainId[ChainId["EnergyWebVoltaTestnet"] = 73799] = "EnergyWebVoltaTestnet";
    ChainId[ChainId["MixinVirtualMachine"] = 73927] = "MixinVirtualMachine";
    ChainId[ChainId["ResinCoinMainnet"] = 75000] = "ResinCoinMainnet";
    ChainId[ChainId["AppLayerTestnet"] = 75338] = "AppLayerTestnet";
    ChainId[ChainId["GEEKVerseMainnet"] = 75512] = "GEEKVerseMainnet";
    ChainId[ChainId["GEEKVerseTestnet"] = 75513] = "GEEKVerseTestnet";
    ChainId[ChainId["BORAchainmainnet"] = 77001] = "BORAchainmainnet";
    ChainId[ChainId["FoundryChainTestnet"] = 77238] = "FoundryChainTestnet";
    ChainId[ChainId["VentionSmartChainMainnet"] = 77612] = "VentionSmartChainMainnet";
    ChainId[ChainId["CarrchainTestnet"] = 77652] = "CarrchainTestnet";
    ChainId[ChainId["CycleNetworkMainnetSailboat"] = 77677] = "CycleNetworkMainnetSailboat";
    ChainId[ChainId["ToronetMainnet"] = 77777] = "ToronetMainnet";
    ChainId[ChainId["Firenzetestnetwork"] = 78110] = "Firenzetestnetwork";
    ChainId[ChainId["DragonflyMainnet(Hexapod)"] = 78281] = "DragonflyMainnet(Hexapod)";
    ChainId[ChainId["AmplifySubnet"] = 78430] = "AmplifySubnet";
    ChainId[ChainId["BulletinSubnet"] = 78431] = "BulletinSubnet";
    ChainId[ChainId["ConduitSubnet"] = 78432] = "ConduitSubnet";
    ChainId[ChainId["Vanguard"] = 78600] = "Vanguard";
    ChainId[ChainId["GoldSmartChainTestnet"] = 79879] = "GoldSmartChainTestnet";
    ChainId[ChainId["Mumbai"] = 80001] = "Mumbai";
    ChainId[ChainId["Amoy"] = 80002] = "Amoy";
    ChainId[ChainId["PolynomiaSepolia"] = 80008] = "PolynomiaSepolia";
    ChainId[ChainId["BerachainBepolia"] = 80069] = "BerachainBepolia";
    ChainId[ChainId["BerachainbArtio"] = 80084] = "BerachainbArtio";
    ChainId[ChainId["BerachainArtio"] = 80085] = "BerachainArtio";
    ChainId[ChainId["Berachain"] = 80094] = "Berachain";
    ChainId[ChainId["Hizocomainnet"] = 80096] = "Hizocomainnet";
    ChainId[ChainId["GeoGenesis"] = 80451] = "GeoGenesis";
    ChainId[ChainId["FortaChain"] = 80931] = "FortaChain";
    ChainId[ChainId["NordekMainnet"] = 81041] = "NordekMainnet";
    ChainId[ChainId["AmanaTestnet"] = 81341] = "AmanaTestnet";
    ChainId[ChainId["AmanaMixnet"] = 81342] = "AmanaMixnet";
    ChainId[ChainId["AmanaPrivnet"] = 81343] = "AmanaPrivnet";
    ChainId[ChainId["FlanaTestnet"] = 81351] = "FlanaTestnet";
    ChainId[ChainId["FlanaMixnet"] = 81352] = "FlanaMixnet";
    ChainId[ChainId["FlanaPrivnet"] = 81353] = "FlanaPrivnet";
    ChainId[ChainId["MizanaTestnet"] = 81361] = "MizanaTestnet";
    ChainId[ChainId["MizanaMixnet"] = 81362] = "MizanaMixnet";
    ChainId[ChainId["MizanaPrivnet"] = 81363] = "MizanaPrivnet";
    ChainId[ChainId["Blast"] = 81457] = "Blast";
    ChainId[ChainId["QuantumChainMainnet"] = 81720] = "QuantumChainMainnet";
    ChainId[ChainId["SmartLayerNetworkTestnet"] = 82459] = "SmartLayerNetworkTestnet";
    ChainId[ChainId["VEMPHorizon"] = 82614] = "VEMPHorizon";
    ChainId[ChainId["XprotocolTestnet"] = 83144] = "XprotocolTestnet";
    ChainId[ChainId["Esa"] = 83278] = "Esa";
    ChainId[ChainId["XprotocolSepolia"] = 83868] = "XprotocolSepolia";
    ChainId[ChainId["ZEDXION"] = 83872] = "ZEDXION";
    ChainId[ChainId["BaseGoerliTestnet"] = 84531] = "BaseGoerliTestnet";
    ChainId[ChainId["BaseSepoliaTestnet"] = 84532] = "BaseSepoliaTestnet";
    ChainId[ChainId["OChain"] = 84841] = "OChain";
    ChainId[ChainId["AerieNetwork"] = 84886] = "AerieNetwork";
    ChainId[ChainId["GDPRTestnet"] = 85321] = "GDPRTestnet";
    ChainId[ChainId["CYBERTRUST"] = 85449] = "CYBERTRUST";
    ChainId[ChainId["NautilusProteusTestnet"] = 88002] = "NautilusProteusTestnet";
    ChainId[ChainId["InoAi"] = 88559] = "InoAi";
    ChainId[ChainId["ZKasinoMainnet"] = 88800] = "ZKasinoMainnet";
    ChainId[ChainId["UnitZeroMainnet"] = 88811] = "UnitZeroMainnet";
    ChainId[ChainId["UnitZeroTestnet"] = 88817] = "UnitZeroTestnet";
    ChainId[ChainId["UnitZeroStagenet"] = 88819] = "UnitZeroStagenet";
    ChainId[ChainId["Matr1xTestnet"] = 88866] = "Matr1xTestnet";
    ChainId[ChainId["ChilizScovilleTestnet"] = 88880] = "ChilizScovilleTestnet";
    ChainId[ChainId["ChilizSpicyTestnet"] = 88882] = "ChilizSpicyTestnet";
    ChainId[ChainId["ChilizChainMainnet"] = 88888] = "ChilizChainMainnet";
    ChainId[ChainId["Unite"] = 88899] = "Unite";
    ChainId[ChainId["PundiAIFXOmnilayerTestnet"] = 90001] = "PundiAIFXOmnilayerTestnet";
    ChainId[ChainId["UBITSMARTCHAINMAINNET"] = 90002] = "UBITSMARTCHAINMAINNET";
    ChainId[ChainId["BeverlyHills"] = 90210] = "BeverlyHills";
    ChainId[ChainId["CampTestnet"] = 90354] = "CampTestnet";
    ChainId[ChainId["NautilusTritionChain"] = 91002] = "NautilusTritionChain";
    ChainId[ChainId["HenezChainMainnet"] = 91111] = "HenezChainMainnet";
    ChainId[ChainId["MetaDAPEnterpriseMainnet"] = 91120] = "MetaDAPEnterpriseMainnet";
    ChainId[ChainId["ComboTestnet"] = 91715] = "ComboTestnet";
    ChainId[ChainId["LambdaTestnet"] = 92001] = "LambdaTestnet";
    ChainId[ChainId["MiracleChain"] = 92278] = "MiracleChain";
    ChainId[ChainId["LiquidLayerTestnet"] = 93572] = "LiquidLayerTestnet";
    ChainId[ChainId["StratoVMTestnet"] = 93747] = "StratoVMTestnet";
    ChainId[ChainId["XCHAIN"] = 94524] = "XCHAIN";
    ChainId[ChainId["SRICHAIN"] = 95432] = "SRICHAIN";
    ChainId[ChainId["LuxTestnet"] = 96368] = "LuxTestnet";
    ChainId[ChainId["LuxMainnet"] = 96369] = "LuxMainnet";
    ChainId[ChainId["LumozChainMainnet"] = 96370] = "LumozChainMainnet";
    ChainId[ChainId["WonderTestnet"] = 96371] = "WonderTestnet";
    ChainId[ChainId["MantisTestnet(Hexapod)"] = 96970] = "MantisTestnet(Hexapod)";
    ChainId[ChainId["TetronTestnetSmartChain"] = 97053] = "TetronTestnetSmartChain";
    ChainId[ChainId["TetronSmartChain"] = 97055] = "TetronSmartChain";
    ChainId[ChainId["BobaBNBMainnetOld"] = 97288] = "BobaBNBMainnetOld";
    ChainId[ChainId["SlingShotTestnet"] = 97435] = "SlingShotTestnet";
    ChainId[ChainId["SidraChain"] = 97453] = "SidraChain";
    ChainId[ChainId["GreenChainTestnet"] = 97531] = "GreenChainTestnet";
    ChainId[ChainId["MetaBenzCHAIN"] = 97766] = "MetaBenzCHAIN";
    ChainId[ChainId["OptimusZ7Testnet"] = 97970] = "OptimusZ7Testnet";
    ChainId[ChainId["PlumeDevnet(Legacy)"] = 98864] = "PlumeDevnet(Legacy)";
    ChainId[ChainId["Plume(Legacy)"] = 98865] = "Plume(Legacy)";
    ChainId[ChainId["PlumeMainnet"] = 98866] = "PlumeMainnet";
    ChainId[ChainId["PlumeTestnet"] = 98867] = "PlumeTestnet";
    ChainId[ChainId["EbiChain"] = 98881] = "EbiChain";
    ChainId[ChainId["SuperpositionTestnet"] = 98985] = "SuperpositionTestnet";
    ChainId[ChainId["ELibertyTestnet"] = 99099] = "ELibertyTestnet";
    ChainId[ChainId["EdgeMatrixChainTestnet"] = 99876] = "EdgeMatrixChainTestnet";
    ChainId[ChainId["EdgeMatrixChainSepolia"] = 99879] = "EdgeMatrixChainSepolia";
    ChainId[ChainId["UBSmartChain(testnet)"] = 99998] = "UBSmartChain(testnet)";
    ChainId[ChainId["UBSmartChain"] = 99999] = "UBSmartChain";
    ChainId[ChainId["QuarkChainMainnetRoot"] = 100000] = "QuarkChainMainnetRoot";
    ChainId[ChainId["QuarkChainMainnetShard0"] = 100001] = "QuarkChainMainnetShard0";
    ChainId[ChainId["QuarkChainMainnetShard1"] = 100002] = "QuarkChainMainnetShard1";
    ChainId[ChainId["QuarkChainMainnetShard2"] = 100003] = "QuarkChainMainnetShard2";
    ChainId[ChainId["QuarkChainMainnetShard3"] = 100004] = "QuarkChainMainnetShard3";
    ChainId[ChainId["QuarkChainMainnetShard4"] = 100005] = "QuarkChainMainnetShard4";
    ChainId[ChainId["QuarkChainMainnetShard5"] = 100006] = "QuarkChainMainnetShard5";
    ChainId[ChainId["QuarkChainMainnetShard6"] = 100007] = "QuarkChainMainnetShard6";
    ChainId[ChainId["QuarkChainMainnetShard7"] = 100008] = "QuarkChainMainnetShard7";
    ChainId[ChainId["VeChain"] = 100009] = "VeChain";
    ChainId[ChainId["VeChainTestnet"] = 100010] = "VeChainTestnet";
    ChainId[ChainId["QuarkChainL2Mainnet"] = 100011] = "QuarkChainL2Mainnet";
    ChainId[ChainId["DeprecatedCHI"] = 100100] = "DeprecatedCHI";
    ChainId[ChainId["SocotraJUNE-Chain"] = 101003] = "SocotraJUNE-Chain";
    ChainId[ChainId["GlobalTrustNetwork"] = 101010] = "GlobalTrustNetwork";
    ChainId[ChainId["Xitcoin"] = 101088] = "Xitcoin";
    ChainId[ChainId["Creditcoin"] = 102030] = "Creditcoin";
    ChainId[ChainId["CreditcoinTestnet"] = 102031] = "CreditcoinTestnet";
    ChainId[ChainId["CreditcoinDevnet"] = 102032] = "CreditcoinDevnet";
    ChainId[ChainId["Crystaleum"] = 103090] = "Crystaleum";
    ChainId[ChainId["MasaTestnet"] = 103454] = "MasaTestnet";
    ChainId[ChainId["KaspaClassicMainnet"] = 104566] = "KaspaClassicMainnet";
    ChainId[ChainId["StratisMainnet"] = 105105] = "StratisMainnet";
    ChainId[ChainId["LumozChainTestnet"] = 105363] = "LumozChainTestnet";
    ChainId[ChainId["BROChainMainnet"] = 108801] = "BROChainMainnet";
    ChainId[ChainId["QuarkChainDevnetRoot"] = 110000] = "QuarkChainDevnetRoot";
    ChainId[ChainId["QuarkChainDevnetShard0"] = 110001] = "QuarkChainDevnetShard0";
    ChainId[ChainId["QuarkChainDevnetShard1"] = 110002] = "QuarkChainDevnetShard1";
    ChainId[ChainId["QuarkChainDevnetShard2"] = 110003] = "QuarkChainDevnetShard2";
    ChainId[ChainId["QuarkChainDevnetShard3"] = 110004] = "QuarkChainDevnetShard3";
    ChainId[ChainId["QuarkChainDevnetShard4"] = 110005] = "QuarkChainDevnetShard4";
    ChainId[ChainId["QuarkChainDevnetShard5"] = 110006] = "QuarkChainDevnetShard5";
    ChainId[ChainId["QuarkChainDevnetShard6"] = 110007] = "QuarkChainDevnetShard6";
    ChainId[ChainId["QuarkChainDevnetShard7"] = 110008] = "QuarkChainDevnetShard7";
    ChainId[ChainId["QuarkChainL2Testnet"] = 110011] = "QuarkChainL2Testnet";
    ChainId[ChainId["MarsCredit"] = 110110] = "MarsCredit";
    ChainId[ChainId["SiberiumTestNetwork"] = 111000] = "SiberiumTestNetwork";
    ChainId[ChainId["SiberiumNetwork"] = 111111] = "SiberiumNetwork";
    ChainId[ChainId["Re.al"] = 111188] = "Re.al";
    ChainId[ChainId["EGoldChainTestnet"] = 111451] = "EGoldChainTestnet";
    ChainId[ChainId["MetachainOneMainnet"] = 112358] = "MetachainOneMainnet";
    ChainId[ChainId["MetaDAPEnterpriseTestnet"] = 119139] = "MetaDAPEnterpriseTestnet";
    ChainId[ChainId["Fushuma"] = 121224] = "Fushuma";
    ChainId[ChainId["Gemchain"] = 123321] = "Gemchain";
    ChainId[ChainId["ADILDevnet"] = 123456] = "ADILDevnet";
    ChainId[ChainId["MitosisTestnet"] = 124832] = "MitosisTestnet";
    ChainId[ChainId["EtherlinkTestnet"] = 128123] = "EtherlinkTestnet";
    ChainId[ChainId["TataraTestnet"] = 129399] = "TataraTestnet";
    ChainId[ChainId["OdysseyChain(Testnet)"] = 131313] = "OdysseyChain(Testnet)";
    ChainId[ChainId["ETNDChainMainnets"] = 131419] = "ETNDChainMainnets";
    ChainId[ChainId["FormTestnet"] = 132902] = "FormTestnet";
    ChainId[ChainId["MagApeTestnet"] = 141319] = "MagApeTestnet";
    ChainId[ChainId["BitharvestChainTestnet"] = 141491] = "BitharvestChainTestnet";
    ChainId[ChainId["ICPlazaMainnet"] = 142857] = "ICPlazaMainnet";
    ChainId[ChainId["OdysseyChainMainnet"] = 153153] = "OdysseyChainMainnet";
    ChainId[ChainId["CryptoX"] = 158245] = "CryptoX";
    ChainId[ChainId["XCOIN"] = 158345] = "XCOIN";
    ChainId[ChainId["OpenLedgerTestnet"] = 161201] = "OpenLedgerTestnet";
    ChainId[ChainId["PlayFiMainnet"] = 161212] = "PlayFiMainnet";
    ChainId[ChainId["EventumMainnet"] = 161803] = "EventumMainnet";
    ChainId[ChainId["EclatMainnet"] = 165279] = "EclatMainnet";
    ChainId[ChainId["TaikoAlethia"] = 167000] = "TaikoAlethia";
    ChainId[ChainId["Taiko(Alpha-2Testnet)"] = 167004] = "Taiko(Alpha-2Testnet)";
    ChainId[ChainId["TaikoGrimsvotnL2"] = 167005] = "TaikoGrimsvotnL2";
    ChainId[ChainId["TaikoEldfellL3"] = 167006] = "TaikoEldfellL3";
    ChainId[ChainId["TaikoJolnirL2"] = 167007] = "TaikoJolnirL2";
    ChainId[ChainId["TaikoKatlaL2"] = 167008] = "TaikoKatlaL2";
    ChainId[ChainId["TaikoHekla"] = 167009] = "TaikoHekla";
    ChainId[ChainId["Zchains"] = 168168] = "Zchains";
    ChainId[ChainId["MUDChain"] = 168169] = "MUDChain";
    ChainId[ChainId["FairTestnet"] = 171000] = "FairTestnet";
    ChainId[ChainId["WadzchainMainnet"] = 171717] = "WadzchainMainnet";
    ChainId[ChainId["Chronicle-LitProtocolTestnet"] = 175177] = "Chronicle-LitProtocolTestnet";
    ChainId[ChainId["ChronicleYellowstone-LitProtocolTestnet"] = 175188] = "ChronicleYellowstone-LitProtocolTestnet";
    ChainId[ChainId["ChronicleLoa-LitProtocolTestnet"] = 175190] = "ChronicleLoa-LitProtocolTestnet";
    ChainId[ChainId["BiticaChainMainnet"] = 188710] = "BiticaChainMainnet";
    ChainId[ChainId["CondorTestNetwork"] = 188881] = "CondorTestNetwork";
    ChainId[ChainId["AltblockscanMainnet"] = 191919] = "AltblockscanMainnet";
    ChainId[ChainId["MindNetworkTestnet"] = 192940] = "MindNetworkTestnet";
    ChainId[ChainId["R0ARChain"] = 193939] = "R0ARChain";
    ChainId[ChainId["LydiaCoinTestnet"] = 198989] = "LydiaCoinTestnet";
    ChainId[ChainId["MAZZETestnet"] = 199991] = "MAZZETestnet";
    ChainId[ChainId["XFair.AITestnet"] = 200000] = "XFair.AITestnet";
    ChainId[ChainId["MilkomedaC1Testnet"] = 200101] = "MilkomedaC1Testnet";
    ChainId[ChainId["ZooMainnet"] = 200200] = "ZooMainnet";
    ChainId[ChainId["MilkomedaA1Testnet"] = 200202] = "MilkomedaA1Testnet";
    ChainId[ChainId["Akroma"] = 200625] = "Akroma";
    ChainId[ChainId["BitlayerTestnet"] = 200810] = "BitlayerTestnet";
    ChainId[ChainId["BitlayerMainnet"] = 200901] = "BitlayerMainnet";
    ChainId[ChainId["AlayaMainnet"] = 201018] = "AlayaMainnet";
    ChainId[ChainId["AlayaDevTestnet"] = 201030] = "AlayaDevTestnet";
    ChainId[ChainId["MythicalChain"] = 201804] = "MythicalChain";
    ChainId[ChainId["DecimalSmartChainTestnet"] = 202020] = "DecimalSmartChainTestnet";
    ChainId[ChainId["DuckChainTestnet"] = 202105] = "DuckChainTestnet";
    ChainId[ChainId["BethelSydney"] = 202202] = "BethelSydney";
    ChainId[ChainId["Alterscope"] = 202209] = "Alterscope";
    ChainId[ChainId["X1Devnet"] = 202212] = "X1Devnet";
    ChainId[ChainId["YMTECH-BESUTestnet"] = 202401] = "YMTECH-BESUTestnet";
    ChainId[ChainId["Blockfit"] = 202424] = "Blockfit";
    ChainId[ChainId["Jellie"] = 202624] = "Jellie";
    ChainId[ChainId["X1Network"] = 204005] = "X1Network";
    ChainId[ChainId["AuroriaTestnet"] = 205205] = "AuroriaTestnet";
    ChainId[ChainId["GitAGIAtlasTestnet"] = 210049] = "GitAGIAtlasTestnet";
    ChainId[ChainId["Sorian"] = 210209] = "Sorian";
    ChainId[ChainId["SorianTestnet"] = 210210] = "SorianTestnet";
    ChainId[ChainId["PlatONMainnet"] = 210425] = "PlatONMainnet";
    ChainId[ChainId["Heima"] = 212013] = "Heima";
    ChainId[ChainId["MasMainnet"] = 220315] = "MasMainnet";
    ChainId[ChainId["ReapchainMainnet"] = 221230] = "ReapchainMainnet";
    ChainId[ChainId["ReapchainTestnet"] = 221231] = "ReapchainTestnet";
    ChainId[ChainId["Hydration"] = 222222] = "Hydration";
    ChainId[ChainId["DeepLMainnet"] = 222555] = "DeepLMainnet";
    ChainId[ChainId["DeepLTestnet"] = 222666] = "DeepLTestnet";
    ChainId[ChainId["B20Testnet"] = 223344] = "B20Testnet";
    ChainId[ChainId["TafECOChainMainnet"] = 224168] = "TafECOChainMainnet";
    ChainId[ChainId["CONETMainnet"] = 224400] = "CONETMainnet";
    ChainId[ChainId["CONETSeboliaTestnet"] = 224422] = "CONETSeboliaTestnet";
    ChainId[ChainId["CONETCancun"] = 224433] = "CONETCancun";
    ChainId[ChainId["AbyssProtocol"] = 229772] = "AbyssProtocol";
    ChainId[ChainId["HashKeyChainTestnet(discard)"] = 230315] = "HashKeyChainTestnet(discard)";
    ChainId[ChainId["HaymoTestnet"] = 234666] = "HaymoTestnet";
    ChainId[ChainId["UniverseTestnet"] = 235711] = "UniverseTestnet";
    ChainId[ChainId["StudioTestnet"] = 240240] = "StudioTestnet";
    ChainId[ChainId["OrangeChainTestnet"] = 240515] = "OrangeChainTestnet";
    ChainId[ChainId["AnomalyAndromedaTestnet"] = 241120] = "AnomalyAndromedaTestnet";
    ChainId[ChainId["ARTISsigma1"] = 246529] = "ARTISsigma1";
    ChainId[ChainId["ARTISTestnettau1"] = 246785] = "ARTISTestnettau1";
    ChainId[ChainId["SaakuruTestnet"] = 247253] = "SaakuruTestnet";
    ChainId[ChainId["CELESTIUMNetworkTestnet"] = 252525] = "CELESTIUMNetworkTestnet";
    ChainId[ChainId["CMP-Mainnet"] = 256256] = "CMP-Mainnet";
    ChainId[ChainId["EclatTestnet"] = 262371] = "EclatTestnet";
    ChainId[ChainId["GearZeroNetworkTestnet"] = 266256] = "GearZeroNetworkTestnet";
    ChainId[ChainId["EgonCoinTestnet"] = 271271] = "EgonCoinTestnet";
    ChainId[ChainId["NxyArea51"] = 272247] = "NxyArea51";
    ChainId[ChainId["NxyOasis"] = 272520] = "NxyOasis";
    ChainId[ChainId["SocialSmartChainMainnet"] = 281121] = "SocialSmartChainMainnet";
    ChainId[ChainId["AtheneParthenon"] = 281123] = "AtheneParthenon";
    ChainId[ChainId["ZillionSepoliaTestnet"] = 282828] = "ZillionSepoliaTestnet";
    ChainId[ChainId["CipheremTestnet"] = 292003] = "CipheremTestnet";
    ChainId[ChainId["OneWorldChainMainnet"] = 309075] = "OneWorldChainMainnet";
    ChainId[ChainId["SaharaAITestnet"] = 313313] = "SaharaAITestnet";
    ChainId[ChainId["Filecoin-Calibrationtestnet"] = 314159] = "Filecoin-Calibrationtestnet";
    ChainId[ChainId["ParexMainnet"] = 322202] = "ParexMainnet";
    ChainId[ChainId["BloomGenesisTestnet"] = 323213] = "BloomGenesisTestnet";
    ChainId[ChainId["CampNetworkTestnetV2"] = 325000] = "CampNetworkTestnetV2";
    ChainId[ChainId["WABAChainTestnet"] = 327126] = "WABAChainTestnet";
    ChainId[ChainId["NalMainnet"] = 328527] = "NalMainnet";
    ChainId[ChainId["TTcoinSmartChainMainnet"] = 330844] = "TTcoinSmartChainMainnet";
    ChainId[ChainId["BloomGenesisMainnet"] = 333313] = "BloomGenesisMainnet";
    ChainId[ChainId["AvesTestnet"] = 333331] = "AvesTestnet";
    ChainId[ChainId["Nativ3Testnet"] = 333333] = "Nativ3Testnet";
    ChainId[ChainId["OoneChainTestnet"] = 333666] = "OoneChainTestnet";
    ChainId[ChainId["OoneChainDevnet"] = 333777] = "OoneChainDevnet";
    ChainId[ChainId["PolisTestnet"] = 333888] = "PolisTestnet";
    ChainId[ChainId["PolisMainnet"] = 333999] = "PolisMainnet";
    ChainId[ChainId["UPchainTestnet"] = 336655] = "UPchainTestnet";
    ChainId[ChainId["UPchainMainnet"] = 336666] = "UPchainMainnet";
    ChainId[ChainId["BitfinityNetworkMainnet"] = 355110] = "BitfinityNetworkMainnet";
    ChainId[ChainId["BitfinityNetworkTestnet"] = 355113] = "BitfinityNetworkTestnet";
    ChainId[ChainId["LAVITAMainnet"] = 360890] = "LAVITAMainnet";
    ChainId[ChainId["DigitSoulSmartChain2"] = 363636] = "DigitSoulSmartChain2";
    ChainId[ChainId["HAPchainTestnet"] = 373737] = "HAPchainTestnet";
    ChainId[ChainId["MetalC-Chain"] = 381931] = "MetalC-Chain";
    ChainId[ChainId["MetalTahoeC-Chain"] = 381932] = "MetalTahoeC-Chain";
    ChainId[ChainId["CheeseChain"] = 383353] = "CheeseChain";
    ChainId[ChainId["TipboxcoinMainnet"] = 404040] = "TipboxcoinMainnet";
    ChainId[ChainId["AIETestnet"] = 413413] = "AIETestnet";
    ChainId[ChainId["Infinaeon"] = 420000] = "Infinaeon";
    ChainId[ChainId["VectorSmartChain"] = 420042] = "VectorSmartChain";
    ChainId[ChainId["Kekchain"] = 420420] = "Kekchain";
    ChainId[ChainId["Kekchain(kektest)"] = 420666] = "Kekchain(kektest)";
    ChainId[ChainId["AlteriumL2Testnet"] = 420692] = "AlteriumL2Testnet";
    ChainId[ChainId["ArbitrumRinkeby"] = 421611] = "ArbitrumRinkeby";
    ChainId[ChainId["ArbitrumGoerli"] = 421613] = "ArbitrumGoerli";
    ChainId[ChainId["ArbitrumSepolia"] = 421614] = "ArbitrumSepolia";
    ChainId[ChainId["FastexChaintestnet"] = 424242] = "FastexChaintestnet";
    ChainId[ChainId["MarkrGo"] = 431140] = "MarkrGo";
    ChainId[ChainId["DexalotSubnetTestnet"] = 432201] = "DexalotSubnetTestnet";
    ChainId[ChainId["DexalotSubnet"] = 432204] = "DexalotSubnet";
    ChainId[ChainId["GraphiteMainnet"] = 440017] = "GraphiteMainnet";
    ChainId[ChainId["SyndrL3Sepolia"] = 444444] = "SyndrL3Sepolia";
    ChainId[ChainId["WeelinkTestnet"] = 444900] = "WeelinkTestnet";
    ChainId[ChainId["PatexSepoliaTestnet"] = 471100] = "PatexSepoliaTestnet";
    ChainId[ChainId["UltraProMainnet"] = 473861] = "UltraProMainnet";
    ChainId[ChainId["OpenChainMainnet"] = 474142] = "OpenChainMainnet";
    ChainId[ChainId["WorldChainSepoliaTestnetDeprecated"] = 484752] = "WorldChainSepoliaTestnetDeprecated";
    ChainId[ChainId["GobblTestnet"] = 486487] = "GobblTestnet";
    ChainId[ChainId["AutonomysTaurusTestnet"] = 490000] = "AutonomysTaurusTestnet";
    ChainId[ChainId["PUMPFICHAINTESTNET"] = 490092] = "PUMPFICHAINTESTNET";
    ChainId[ChainId["PlaydappNetwork"] = 504441] = "PlaydappNetwork";
    ChainId[ChainId["CMP-Testnet"] = 512512] = "CMP-Testnet";
    ChainId[ChainId["EthereumFair"] = 513100] = "EthereumFair";
    ChainId[ChainId["DoCoinCommunityChain"] = 526916] = "DoCoinCommunityChain";
    ChainId[ChainId["ScrollSepoliaTestnet"] = 534351] = "ScrollSepoliaTestnet";
    ChainId[ChainId["Scroll"] = 534352] = "Scroll";
    ChainId[ChainId["ScrollAlphaTestnet"] = 534353] = "ScrollAlphaTestnet";
    ChainId[ChainId["ScrollPre-AlphaTestnet"] = 534354] = "ScrollPre-AlphaTestnet";
    ChainId[ChainId["ShinariumBeta"] = 534849] = "ShinariumBeta";
    ChainId[ChainId["BeanEcoSmartChain"] = 535037] = "BeanEcoSmartChain";
    ChainId[ChainId["OverProtocolTestnet"] = 541764] = "OverProtocolTestnet";
    ChainId[ChainId["ZERONetwork"] = 543210] = "ZERONetwork";
    ChainId[ChainId["OneWorldChainTestnet"] = 552981] = "OneWorldChainTestnet";
    ChainId[ChainId["PentagonTestnet"] = 555555] = "PentagonTestnet";
    ChainId[ChainId["EclipseTestnet"] = 555666] = "EclipseTestnet";
    ChainId[ChainId["XsollaZKSepoliaTestnet"] = 555777] = "XsollaZKSepoliaTestnet";
    ChainId[ChainId["DustBoyIoT"] = 555888] = "DustBoyIoT";
    ChainId[ChainId["HetuTestnet"] = 560000] = "HetuTestnet";
    ChainId[ChainId["EthereumHoodi"] = 560048] = "EthereumHoodi";
    ChainId[ChainId["DJTTestnet"] = 621847] = "DJTTestnet";
    ChainId[ChainId["HypraMainnet"] = 622277] = "HypraMainnet";
    ChainId[ChainId["Atlas"] = 622463] = "Atlas";
    ChainId[ChainId["PolterTestnet"] = 631571] = "PolterTestnet";
    ChainId[ChainId["BearNetworkChainMainnet"] = 641230] = "BearNetworkChainMainnet";
    ChainId[ChainId["ALLMainnet"] = 651940] = "ALLMainnet";
    ChainId[ChainId["EDUChainTestnet"] = 656476] = "EDUChainTestnet";
    ChainId[ChainId["XaiMainnet"] = 660279] = "XaiMainnet";
    ChainId[ChainId["Vision-VpioneerTestChain"] = 666666] = "Vision-VpioneerTestChain";
    ChainId[ChainId["HelaOfficialRuntimeTestnet"] = 666888] = "HelaOfficialRuntimeTestnet";
    ChainId[ChainId["ConwaiMainnet"] = 668668] = "ConwaiMainnet";
    ChainId[ChainId["GensynTestnet"] = 685685] = "GensynTestnet";
    ChainId[ChainId["WonNetwork"] = 686868] = "WonNetwork";
    ChainId[ChainId["PyropeTestnet"] = 695569] = "PyropeTestnet";
    ChainId[ChainId["GaladrielDevnet"] = 696969] = "GaladrielDevnet";
    ChainId[ChainId["PrimeaNetworkMainnet"] = 698369] = "PrimeaNetworkMainnet";
    ChainId[ChainId["Fidesinnova"] = 706883] = "Fidesinnova";
    ChainId[ChainId["TiltyardMainnetSubnet"] = 710420] = "TiltyardMainnetSubnet";
    ChainId[ChainId["SeiDevnet"] = 713715] = "SeiDevnet";
    ChainId[ChainId["ZetherMainnet"] = 715131] = "ZetherMainnet";
    ChainId[ChainId["ERAMMainnet"] = 721529] = "ERAMMainnet";
    ChainId[ChainId["TixChainTestnet"] = 723107] = "TixChainTestnet";
    ChainId[ChainId["HemiSepolia"] = 743111] = "HemiSepolia";
    ChainId[ChainId["BearNetworkChainTestnet"] = 751230] = "BearNetworkChainTestnet";
    ChainId[ChainId["TernoaTestnet"] = 752024] = "TernoaTestnet";
    ChainId[ChainId["Ternoa"] = 752025] = "Ternoa";
    ChainId[ChainId["PAYSCANCHAIN"] = 756689] = "PAYSCANCHAIN";
    ChainId[ChainId["MiexsSmartchain"] = 761412] = "MiexsSmartchain";
    ChainId[ChainId["InkSepolia"] = 763373] = "InkSepolia";
    ChainId[ChainId["SurgeTestnet"] = 763374] = "SurgeTestnet";
    ChainId[ChainId["Lamina1Testnet"] = 764984] = "Lamina1Testnet";
    ChainId[ChainId["Lamina1IdentityTestnet"] = 767368] = "Lamina1IdentityTestnet";
    ChainId[ChainId["Modularium"] = 776877] = "Modularium";
    ChainId[ChainId["WinrProtocolMainnet"] = 777777] = "WinrProtocolMainnet";
    ChainId[ChainId["OoneChainMainnet"] = 777888] = "OoneChainMainnet";
    ChainId[ChainId["ZebroSmartChain"] = 786786] = "ZebroSmartChain";
    ChainId[ChainId["Emeraldz"] = 789789] = "Emeraldz";
    ChainId[ChainId["OctaSpace"] = 800001] = "OctaSpace";
    ChainId[ChainId["EthparTestnet"] = 806582] = "EthparTestnet";
    ChainId[ChainId["BIZSmartChainTestnet"] = 808080] = "BIZSmartChainTestnet";
    ChainId[ChainId["BOBSepolia"] = 808813] = "BOBSepolia";
    ChainId[ChainId["ZkLinkNovaMainnet"] = 810180] = "ZkLinkNovaMainnet";
    ChainId[ChainId["ZkLinkNovaSepoliaTestnet"] = 810181] = "ZkLinkNovaSepoliaTestnet";
    ChainId[ChainId["ZkLinkNovaGoerliTestnet"] = 810182] = "ZkLinkNovaGoerliTestnet";
    ChainId[ChainId["SGVerseMainnet"] = 812397] = "SGVerseMainnet";
    ChainId[ChainId["TSCTestnet"] = 820522] = "TSCTestnet";
    ChainId[ChainId["CURVEMainnet"] = 827431] = "CURVEMainnet";
    ChainId[ChainId["PRMTestnet"] = 839320] = "PRMTestnet";
    ChainId[ChainId["ExSatTestnet"] = 839999] = "ExSatTestnet";
    ChainId[ChainId["RUNEVMTestnet"] = 840000] = "RUNEVMTestnet";
    ChainId[ChainId["4GoodNetwork"] = 846000] = "4GoodNetwork";
    ChainId[ChainId["Dodao"] = 855456] = "Dodao";
    ChainId[ChainId["BlocXMainnet"] = 879151] = "BlocXMainnet";
    ChainId[ChainId["REXXMainnet"] = 888882] = "REXXMainnet";
    ChainId[ChainId["Vision-Mainnet"] = 888888] = "Vision-Mainnet";
    ChainId[ChainId["UniteTestnet"] = 888991] = "UniteTestnet";
    ChainId[ChainId["PosichainMainnetShard0"] = 900000] = "PosichainMainnetShard0";
    ChainId[ChainId["PosichainTestnetShard0"] = 910000] = "PosichainTestnetShard0";
    ChainId[ChainId["OdysseyTestnet"] = 911867] = "OdysseyTestnet";
    ChainId[ChainId["AstriaEVMDusknet"] = 912559] = "AstriaEVMDusknet";
    ChainId[ChainId["OwshenMainnet"] = 918273] = "OwshenMainnet";
    ChainId[ChainId["PosichainDevnetShard0"] = 920000] = "PosichainDevnetShard0";
    ChainId[ChainId["PosichainDevnetShard1"] = 920001] = "PosichainDevnetShard1";
    ChainId[ChainId["FNCYTestnet"] = 923018] = "FNCYTestnet";
    ChainId[ChainId["Jono12Subnet"] = 955081] = "Jono12Subnet";
    ChainId[ChainId["EluvioContentFabric"] = 955305] = "EluvioContentFabric";
    ChainId[ChainId["TreasureRuby"] = 978657] = "TreasureRuby";
    ChainId[ChainId["TreasureTopaz"] = 978658] = "TreasureTopaz";
    ChainId[ChainId["Forma"] = 984122] = "Forma";
    ChainId[ChainId["FormaSketchpad"] = 984123] = "FormaSketchpad";
    ChainId[ChainId["EcroxChainMainnet"] = 988207] = "EcroxChainMainnet";
    ChainId[ChainId["SupernetTestnet"] = 998899] = "SupernetTestnet";
    ChainId[ChainId["AmChain"] = 999999] = "AmChain";
    ChainId[ChainId["NagaTestnet"] = 1008686] = "NagaTestnet";
    ChainId[ChainId["NetmindChainTestnet"] = 1100789] = "NetmindChainTestnet";
    ChainId[ChainId["TiltyardSubnet"] = 1127469] = "TiltyardSubnet";
    ChainId[ChainId["1MoneyNetworkTestnet"] = 1212101] = "1MoneyNetworkTestnet";
    ChainId[ChainId["SharecleMainnet"] = 1234567] = "SharecleMainnet";
    ChainId[ChainId["ZKatana"] = 1261120] = "ZKatana";
    ChainId[ChainId["EthoProtocol"] = 1313114] = "EthoProtocol";
    ChainId[ChainId["Xerom"] = 1313500] = "Xerom";
    ChainId[ChainId["Kintsugi"] = 1337702] = "Kintsugi";
    ChainId[ChainId["Kiln"] = 1337802] = "Kiln";
    ChainId[ChainId["Zhejiang"] = 1337803] = "Zhejiang";
    ChainId[ChainId["AutomataTestnet"] = 1398243] = "AutomataTestnet";
    ChainId[ChainId["AutomataOrbitTestnet"] = 1398244] = "AutomataOrbitTestnet";
    ChainId[ChainId["XRPLEVMSidechainDevnet"] = 1440002] = "XRPLEVMSidechainDevnet";
    ChainId[ChainId["XRPLEVMSidechainTestnet"] = 1449000] = "XRPLEVMSidechainTestnet";
    ChainId[ChainId["Waterfall9TestNetwork"] = 1501869] = "Waterfall9TestNetwork";
    ChainId[ChainId["PlayFiAlbireoTestnet"] = 1612127] = "PlayFiAlbireoTestnet";
    ChainId[ChainId["XterioTestnet"] = 1637450] = "XterioTestnet";
    ChainId[ChainId["PrimeaNetworkTestnet"] = 1698369] = "PrimeaNetworkTestnet";
    ChainId[ChainId["TurkeyDemoDev"] = 1731313] = "TurkeyDemoDev";
    ChainId[ChainId["XphereTestnet"] = 1998991] = "XphereTestnet";
    ChainId[ChainId["DeBankTestnet"] = 2021398] = "DeBankTestnet";
    ChainId[ChainId["AlterscopeTestnet"] = 2022091] = "AlterscopeTestnet";
    ChainId[ChainId["PlianMainnetMain"] = 2099156] = "PlianMainnetMain";
    ChainId[ChainId["PlatONDevTestnetDeprecated"] = 2203181] = "PlatONDevTestnetDeprecated";
    ChainId[ChainId["PlatONDevTestnet2"] = 2206132] = "PlatONDevTestnet2";
    ChainId[ChainId["CoinwebBNBshard"] = 2222222] = "CoinwebBNBshard";
    ChainId[ChainId["RecallTestnet"] = 2481632] = "RecallTestnet";
    ChainId[ChainId["DPUChain"] = 2611555] = "DPUChain";
    ChainId[ChainId["COTI"] = 2632500] = "COTI";
    ChainId[ChainId["XterioChain(ETH)"] = 2702128] = "XterioChain(ETH)";
    ChainId[ChainId["SaharaAI"] = 3132023] = "SaharaAI";
    ChainId[ChainId["Filecoin-Butterflytestnet"] = 3141592] = "Filecoin-Butterflytestnet";
    ChainId[ChainId["FunkiSepoliaTestnet"] = 3397901] = "FunkiSepoliaTestnet";
    ChainId[ChainId["MantaPacificTestnet"] = 3441005] = "MantaPacificTestnet";
    ChainId[ChainId["MantaPacificSepoliaTestnet"] = 3441006] = "MantaPacificSepoliaTestnet";
    ChainId[ChainId["AltLayerZeroGasNetwork"] = 4000003] = "AltLayerZeroGasNetwork";
    ChainId[ChainId["ArcadiaMainnet"] = 4278608] = "ArcadiaMainnet";
    ChainId[ChainId["WorldsCaldera"] = 4281033] = "WorldsCaldera";
    ChainId[ChainId["Zuuxchaintestnet"] = 4284265] = "Zuuxchaintestnet";
    ChainId[ChainId["AltarTestnet"] = 4444444] = "AltarTestnet";
    ChainId[ChainId["ZEROTestnet(Sepolia)"] = 4457845] = "ZEROTestnet(Sepolia)";
    ChainId[ChainId["NumBlockChain"] = 5112023] = "NumBlockChain";
    ChainId[ChainId["MXCWannseezkEVMTestnet"] = 5167003] = "MXCWannseezkEVMTestnet";
    ChainId[ChainId["MoonchainGenevaTestnet"] = 5167004] = "MoonchainGenevaTestnet";
    ChainId[ChainId["ElectroneumTestnet"] = 5201420] = "ElectroneumTestnet";
    ChainId[ChainId["ReactiveKopli"] = 5318008] = "ReactiveKopli";
    ChainId[ChainId["PointPayTestnet"] = 5511555] = "PointPayTestnet";
    ChainId[ChainId["ImversedMainnet"] = 5555555] = "ImversedMainnet";
    ChainId[ChainId["ImversedTestnet"] = 5555558] = "ImversedTestnet";
    ChainId[ChainId["AstarzKyoto"] = 6038361] = "AstarzKyoto";
    ChainId[ChainId["BlockChainLOLBerachainTestnet"] = 6231991] = "BlockChainLOLBerachainTestnet";
    ChainId[ChainId["Safe(AnWang)Mainnet"] = 6666665] = "Safe(AnWang)Mainnet";
    ChainId[ChainId["Safe(AnWang)Testnet"] = 6666666] = "Safe(AnWang)Testnet";
    ChainId[ChainId["TheTingBlockchainTestnetExplorer"] = 6666689] = "TheTingBlockchainTestnetExplorer";
    ChainId[ChainId["COTITestnet"] = 7082400] = "COTITestnet";
    ChainId[ChainId["SaakuruMainnet"] = 7225878] = "SaakuruMainnet";
    ChainId[ChainId["OpenVessel"] = 7355310] = "OpenVessel";
    ChainId[ChainId["QL1Testnet"] = 7668378] = "QL1Testnet";
    ChainId[ChainId["Musicoin"] = 7762959] = "Musicoin";
    ChainId[ChainId["Zora"] = 7777777] = "Zora";
    ChainId[ChainId["OzeanPoseidonTestnet"] = 7849306] = "OzeanPoseidonTestnet";
    ChainId[ChainId["PlianMainnetSubchain1"] = 8007736] = "PlianMainnetSubchain1";
    ChainId[ChainId["FhenixHelium"] = 8008135] = "FhenixHelium";
    ChainId[ChainId["Hokum"] = 8080808] = "Hokum";
    ChainId[ChainId["Waterfall8TestNetwork"] = 8601152] = "Waterfall8TestNetwork";
    ChainId[ChainId["HAPchain"] = 8794598] = "HAPchain";
    ChainId[ChainId["QuarixTestnet"] = 8888881] = "QuarixTestnet";
    ChainId[ChainId["Quarix"] = 8888888] = "Quarix";
    ChainId[ChainId["XCAP"] = 9322252] = "XCAP";
    ChainId[ChainId["Milvine"] = 9322253] = "Milvine";
    ChainId[ChainId["Fluence"] = 9999999] = "Fluence";
    ChainId[ChainId["Spotlight"] = 10058111] = "Spotlight";
    ChainId[ChainId["SpotlightSepoliaTestnet"] = 10058112] = "SpotlightSepoliaTestnet";
    ChainId[ChainId["PlianTestnetSubchain1"] = 10067275] = "PlianTestnetSubchain1";
    ChainId[ChainId["SoverunMainnet"] = 10101010] = "SoverunMainnet";
    ChainId[ChainId["AlienXMainnet"] = 10241024] = "AlienXMainnet";
    ChainId[ChainId["ALIENXHalTestnet"] = 10241025] = "ALIENXHalTestnet";
    ChainId[ChainId["BlessnetSepolia"] = 11145513] = "BlessnetSepolia";
    ChainId[ChainId["EthereumSepolia"] = 11155111] = "EthereumSepolia";
    ChainId[ChainId["OPSepoliaTestnet"] = 11155420] = "OPSepoliaTestnet";
    ChainId[ChainId["RISETestnet"] = 11155931] = "RISETestnet";
    ChainId[ChainId["R0ARTestnet"] = 11166111] = "R0ARTestnet";
    ChainId[ChainId["LummioNetwork"] = 12020498] = "LummioNetwork";
    ChainId[ChainId["MementoTestnet"] = 12052024] = "MementoTestnet";
    ChainId[ChainId["NeoXTestnetT3"] = 12227331] = "NeoXTestnetT3";
    ChainId[ChainId["NeoXTestnetT4"] = 12227332] = "NeoXTestnetT4";
    ChainId[ChainId["COTIDevnet"] = 13068200] = "COTIDevnet";
    ChainId[ChainId["PepChainChurchill"] = 13371337] = "PepChainChurchill";
    ChainId[ChainId["AnduschainMainnet"] = 14288640] = "AnduschainMainnet";
    ChainId[ChainId["PlianTestnetMain"] = 16658437] = "PlianTestnetMain";
    ChainId[ChainId["PrivixChainMainnet"] = 16969696] = "PrivixChainMainnet";
    ChainId[ChainId["LambdaChainTestnet"] = 17000920] = "LambdaChainTestnet";
    ChainId[ChainId["MandeNetworkMainnet"] = 18071918] = "MandeNetworkMainnet";
    ChainId[ChainId["IOLite"] = 18289463] = "IOLite";
    ChainId[ChainId["DeepBrainChainTestnet"] = 19850818] = "DeepBrainChainTestnet";
    ChainId[ChainId["DeepBrainChainMainnet"] = 19880818] = "DeepBrainChainMainnet";
    ChainId[ChainId["StabilityTestnet"] = 20180427] = "StabilityTestnet";
    ChainId[ChainId["SmartMeshMainnet"] = 20180430] = "SmartMeshMainnet";
    ChainId[ChainId["Quarkblockchain"] = 20181205] = "Quarkblockchain";
    ChainId[ChainId["PegoNetwork"] = 20201022] = "PegoNetwork";
    ChainId[ChainId["SoonChainSepoliaDevnet"] = 20221001] = "SoonChainSepoliaDevnet";
    ChainId[ChainId["VcityTestnet"] = 20230825] = "VcityTestnet";
    ChainId[ChainId["DeBankSepoliaTestnet"] = 20240324] = "DeBankSepoliaTestnet";
    ChainId[ChainId["DBKChain"] = 20240603] = "DBKChain";
    ChainId[ChainId["SwanProximaTestnet"] = 20241133] = "SwanProximaTestnet";
    ChainId[ChainId["XphereMainnet"] = 20250217] = "XphereMainnet";
    ChainId[ChainId["VcitychainMainnet"] = 20250825] = "VcitychainMainnet";
    ChainId[ChainId["ETPMainnet"] = 20256789] = "ETPMainnet";
    ChainId[ChainId["HokumTestnet"] = 20482050] = "HokumTestnet";
    ChainId[ChainId["Corn"] = 21000000] = "Corn";
    ChainId[ChainId["CornTestnet"] = 21000001] = "CornTestnet";
    ChainId[ChainId["ExcelonMainnet"] = 22052002] = "ExcelonMainnet";
    ChainId[ChainId["XMTP"] = 24132016] = "XMTP";
    ChainId[ChainId["6DegreeofOutreach-Testnet"] = 24772477] = "6DegreeofOutreach-Testnet";
    ChainId[ChainId["ExcoincialChainVolta-Testnet"] = 27082017] = "ExcoincialChainVolta-Testnet";
    ChainId[ChainId["ExcoincialChainMainnet"] = 27082022] = "ExcoincialChainMainnet";
    ChainId[ChainId["Ancient8Testnet"] = 28122024] = "Ancient8Testnet";
    ChainId[ChainId["AuxiliumNetworkMainnet"] = 28945486] = "AuxiliumNetworkMainnet";
    ChainId[ChainId["FlachainMainnet"] = 29032022] = "FlachainMainnet";
    ChainId[ChainId["Filecoin-Localtestnet"] = 31415926] = "Filecoin-Localtestnet";
    ChainId[ChainId["TolimanSuaveTestnet"] = 33626250] = "TolimanSuaveTestnet";
    ChainId[ChainId["XoneTestnet"] = 33772211] = "XoneTestnet";
    ChainId[ChainId["Citronus-citro"] = 34949059] = "Citronus-citro";
    ChainId[ChainId["JoysDigitalMainnet"] = 35855456] = "JoysDigitalMainnet";
    ChainId[ChainId["SKALENebulaHubTestnet"] = 37084624] = "SKALENebulaHubTestnet";
    ChainId[ChainId["KingdomChain"] = 39916801] = "KingdomChain";
    ChainId[ChainId["Maistestsubnet"] = 43214913] = "Maistestsubnet";
    ChainId[ChainId["StavangerPublicTestnet"] = 50591822] = "StavangerPublicTestnet";
    ChainId[ChainId["DeviantTokenBlockchain"] = 52027071] = "DeviantTokenBlockchain";
    ChainId[ChainId["DeviantTokenBlockchainTestnet"] = 52027080] = "DeviantTokenBlockchainTestnet";
    ChainId[ChainId["FluenceTestnet"] = 52164803] = "FluenceTestnet";
    ChainId[ChainId["DKargoWarehouseTestnet"] = 61022448] = "DKargoWarehouseTestnet";
    ChainId[ChainId["Aquachain"] = 61717561] = "Aquachain";
    ChainId[ChainId["AutonityBakerloo(Thames)Testnet"] = 65010000] = "AutonityBakerloo(Thames)Testnet";
    ChainId[ChainId["AutonityBakerloo(Barada)Testnet"] = 65010001] = "AutonityBakerloo(Barada)Testnet";
    ChainId[ChainId["AutonityBakerloo(Sumida)Testnet"] = 65010002] = "AutonityBakerloo(Sumida)Testnet";
    ChainId[ChainId["AutonityBakerloo(Yamuna)Testnet"] = 65010003] = "AutonityBakerloo(Yamuna)Testnet";
    ChainId[ChainId["AutonityPiccadilly(Thames)Testnet"] = 65100000] = "AutonityPiccadilly(Thames)Testnet";
    ChainId[ChainId["AutonityPiccadilly(Barada)Testnet"] = 65100001] = "AutonityPiccadilly(Barada)Testnet";
    ChainId[ChainId["AutonityPiccadilly(Sumida)Testnet"] = 65100002] = "AutonityPiccadilly(Sumida)Testnet";
    ChainId[ChainId["AutonityPiccadilly(Yamuna)Testnet"] = 65100003] = "AutonityPiccadilly(Yamuna)Testnet";
    ChainId[ChainId["AutonityPiccadilly(Tiber)Testnet"] = 65100004] = "AutonityPiccadilly(Tiber)Testnet";
    ChainId[ChainId["WinrProtocolTestnet"] = 66666666] = "WinrProtocolTestnet";
    ChainId[ChainId["FrameTestnet"] = 68840142] = "FrameTestnet";
    ChainId[ChainId["0xHashTestnet"] = 77787778] = "0xHashTestnet";
    ChainId[ChainId["SXTorontoRollup"] = 79479957] = "SXTorontoRollup";
    ChainId[ChainId["BackstopTestnet"] = 88558801] = "BackstopTestnet";
    ChainId[ChainId["T.E.A.MBlockchain"] = 88888888] = "T.E.A.MBlockchain";
    ChainId[ChainId["ReyaCronos"] = 89346162] = "ReyaCronos";
    ChainId[ChainId["PolygonBlackberry"] = 94204209] = "PolygonBlackberry";
    ChainId[ChainId["PrivixChainTestnet"] = 96969696] = "PrivixChainTestnet";
    ChainId[ChainId["ChadChain"] = 97912060] = "ChadChain";
    ChainId[ChainId["JoysDigitalTestNet"] = 99415706] = "JoysDigitalTestNet";
    ChainId[ChainId["Ethos"] = 100000000] = "Ethos";
    ChainId[ChainId["OraichainMainnet"] = 108160679] = "OraichainMainnet";
    ChainId[ChainId["CyberTestnet"] = 111557560] = "CyberTestnet";
    ChainId[ChainId["OPCelestiaRaspberry"] = 123420111] = "OPCelestiaRaspberry";
    ChainId[ChainId["PlumeTestnet(Legacy)"] = 161221135] = "PlumeTestnet(Legacy)";
    ChainId[ChainId["BlastSepoliaTestnet"] = 168587773] = "BlastSepoliaTestnet";
    ChainId[ChainId["GatherMainnetNetwork"] = 192837465] = "GatherMainnetNetwork";
    ChainId[ChainId["Kanazawa"] = 222000222] = "Kanazawa";
    ChainId[ChainId["XMTPSepolia"] = 241320161] = "XMTPSepolia";
    ChainId[ChainId["NeonEVMDevnet"] = 245022926] = "NeonEVMDevnet";
    ChainId[ChainId["NeonEVMDevnetRollup"] = 245022929] = "NeonEVMDevnetRollup";
    ChainId[ChainId["NeonEVMMainnet"] = 245022934] = "NeonEVMMainnet";
    ChainId[ChainId["NeonEVMTestNet"] = 245022940] = "NeonEVMTestNet";
    ChainId[ChainId["Flame"] = 253368190] = "Flame";
    ChainId[ChainId["RazorSkaleChain"] = 278611351] = "RazorSkaleChain";
    ChainId[ChainId["OneLedgerMainnet"] = 311752642] = "OneLedgerMainnet";
    ChainId[ChainId["NalSepoliaTestnet"] = 328527624] = "NalSepoliaTestnet";
    ChainId[ChainId["Meld"] = 333000333] = "Meld";
    ChainId[ChainId["DeprecatedSKALECalypsoHubTestnet"] = 344106930] = "DeprecatedSKALECalypsoHubTestnet";
    ChainId[ChainId["GatherTestnetNetwork"] = 356256156] = "GatherTestnetNetwork";
    ChainId[ChainId["AssetHub"] = 420420419] = "AssetHub";
    ChainId[ChainId["WestendAssetHub"] = 420420421] = "WestendAssetHub";
    ChainId[ChainId["DeprecatedSKALEEuropaHubTestnet"] = 476158412] = "DeprecatedSKALEEuropaHubTestnet";
    ChainId[ChainId["GPTTestnet"] = 476462898] = "GPTTestnet";
    ChainId[ChainId["GatherDevnetNetwork"] = 486217935] = "GatherDevnetNetwork";
    ChainId[ChainId["DeprecatedSKALENebulaHubTestnet"] = 503129905] = "DeprecatedSKALENebulaHubTestnet";
    ChainId[ChainId["SophonTestnet"] = 531050104] = "SophonTestnet";
    ChainId[ChainId["SmartMainnet"] = 661898459] = "SmartMainnet";
    ChainId[ChainId["DegenChain"] = 666666666] = "DegenChain";
    ChainId[ChainId["TronMainnet"] = 728126428] = "TronMainnet";
    ChainId[ChainId["Ancient8"] = 888888888] = "Ancient8";
    ChainId[ChainId["PTCESCANTestnet"] = 889910245] = "PTCESCANTestnet";
    ChainId[ChainId["PTCESCANMainnet"] = 889910246] = "PTCESCANMainnet";
    ChainId[ChainId["SKALECalypsoHubTestnet"] = 974399131] = "SKALECalypsoHubTestnet";
    ChainId[ChainId["LumiaMainnet"] = 994873017] = "LumiaMainnet";
    ChainId[ChainId["ZoraSepoliaTestnet"] = 999999999] = "ZoraSepoliaTestnet";
    ChainId[ChainId["SKALETitanHubTestnet"] = 1020352220] = "SKALETitanHubTestnet";
    ChainId[ChainId["IPOSNetwork"] = 1122334455] = "IPOSNetwork";
    ChainId[ChainId["CyberdeckNet"] = 1146703430] = "CyberdeckNet";
    ChainId[ChainId["HUMANProtocol"] = 1273227453] = "HUMANProtocol";
    ChainId[ChainId["OFFICIALVASYL"] = 1278060416] = "OFFICIALVASYL";
    ChainId[ChainId["AuroraMainnet"] = 1313161554] = "AuroraMainnet";
    ChainId[ChainId["AuroraTestnet"] = 1313161555] = "AuroraTestnet";
    ChainId[ChainId["AuroraBetanet"] = 1313161556] = "AuroraBetanet";
    ChainId[ChainId["PowerGold"] = 1313161560] = "PowerGold";
    ChainId[ChainId["Turbo"] = 1313161567] = "Turbo";
    ChainId[ChainId["Tuxappcoin"] = 1313161573] = "Tuxappcoin";
    ChainId[ChainId["SKALETitanHub"] = 1350216234] = "SKALETitanHub";
    ChainId[ChainId["Chaos(SKALETestnet)"] = 1351057110] = "Chaos(SKALETestnet)";
    ChainId[ChainId["RARIChainMainnet"] = 1380012617] = "RARIChainMainnet";
    ChainId[ChainId["RaptorChain"] = 1380996178] = "RaptorChain";
    ChainId[ChainId["ZephyrTestnet"] = 1417429182] = "ZephyrTestnet";
    ChainId[ChainId["SKALEEuropaHubTestnet"] = 1444673419] = "SKALEEuropaHubTestnet";
    ChainId[ChainId["SKALENebulaHub"] = 1482601649] = "SKALENebulaHub";
    ChainId[ChainId["GPTMainnet"] = 1511670449] = "GPTMainnet";
    ChainId[ChainId["DeprecatedSKALETitanHubTestnet"] = 1517929550] = "DeprecatedSKALETitanHubTestnet";
    ChainId[ChainId["HaustNetworkTestnet"] = 1523903251] = "HaustNetworkTestnet";
    ChainId[ChainId["SKALECalypsoHub"] = 1564830818] = "SKALECalypsoHub";
    ChainId[ChainId["HaustTestnet"] = 1570754601] = "HaustTestnet";
    ChainId[ChainId["StatusNetworkSepolia"] = 1660990954] = "StatusNetworkSepolia";
    ChainId[ChainId["HarmonyMainnetShard0"] = 1666600000] = "HarmonyMainnetShard0";
    ChainId[ChainId["HarmonyMainnetShard1"] = 1666600001] = "HarmonyMainnetShard1";
    ChainId[ChainId["HarmonyMainnetShard2"] = 1666600002] = "HarmonyMainnetShard2";
    ChainId[ChainId["HarmonyMainnetShard3"] = 1666600003] = "HarmonyMainnetShard3";
    ChainId[ChainId["HarmonyTestnetShard0"] = 1666700000] = "HarmonyTestnetShard0";
    ChainId[ChainId["HarmonyTestnetShard1"] = 1666700001] = "HarmonyTestnetShard1";
    ChainId[ChainId["HarmonyDevnetShard0"] = 1666900000] = "HarmonyDevnetShard0";
    ChainId[ChainId["HarmonyDevnetShard1"] = 1666900001] = "HarmonyDevnetShard1";
    ChainId[ChainId["WITNESSCHAIN"] = 1702448187] = "WITNESSCHAIN";
    ChainId[ChainId["SiliconzkEVMSepoliaTestnet"] = 1722641160] = "SiliconzkEVMSepoliaTestnet";
    ChainId[ChainId["KakarotSepolia(Deprecated)"] = 1802203764] = "KakarotSepolia(Deprecated)";
    ChainId[ChainId["GemuchainTestnet"] = 1903648807] = "GemuchainTestnet";
    ChainId[ChainId["RARIChainTestnet"] = 1918988905] = "RARIChainTestnet";
    ChainId[ChainId["LumiaTestnet"] = 1952959480] = "LumiaTestnet";
    ChainId[ChainId["DataHopper"] = 2021121117] = "DataHopper";
    ChainId[ChainId["SKALEEuropaHub"] = 2046399126] = "SKALEEuropaHub";
    ChainId[ChainId["AccumulateKermit"] = 2478899481] = "AccumulateKermit";
    ChainId[ChainId["TronShasta"] = 2494104990] = "TronShasta";
    ChainId[ChainId["Ancient8Testnet(deprecated)"] = 2863311531] = "Ancient8Testnet(deprecated)";
    ChainId[ChainId["Pirl"] = 3125659152] = "Pirl";
    ChainId[ChainId["UltimaMainnet"] = 3416255149] = "UltimaMainnet";
    ChainId[ChainId["OneLedgerTestnetFrankenstein"] = 4216137055] = "OneLedgerTestnetFrankenstein";
    ChainId[ChainId["Mekong"] = 7078815900] = "Mekong";
    ChainId[ChainId["Pectra-devnet-5"] = 7088110746] = "Pectra-devnet-5";
    ChainId[ChainId["ONFAChain"] = 8691942025] = "ONFAChain";
    ChainId[ChainId["PalmTestnet"] = 11297108099] = "PalmTestnet";
    ChainId[ChainId["Palm"] = 11297108109] = "Palm";
    ChainId[ChainId["GitSwarmTestNetwork"] = 28872323069] = "GitSwarmTestNetwork";
    ChainId[ChainId["XaiTestnetv2"] = 37714555429] = "XaiTestnetv2";
    ChainId[ChainId["DeriwDevnet"] = 44474237230] = "DeriwDevnet";
    ChainId[ChainId["ArbitrumBlueberry"] = 88153591557] = "ArbitrumBlueberry";
    ChainId[ChainId["ALDChainTestnet"] = 96737205180] = "ALDChainTestnet";
    ChainId[ChainId["KakarotSepoliaDeprecated"] = 107107114116] = "KakarotSepoliaDeprecated";
    ChainId[ChainId["AlphabetMainnet"] = 111222333444] = "AlphabetMainnet";
    ChainId[ChainId["ThanosSepolia"] = 111551119090] = "ThanosSepolia";
    ChainId[ChainId["FluenceStage"] = 123420000220] = "FluenceStage";
    ChainId[ChainId["PIN"] = 123420000558] = "PIN";
    ChainId[ChainId["Sivo-defi-testnet"] = 123420000586] = "Sivo-defi-testnet";
    ChainId[ChainId["Volmex"] = 123420000588] = "Volmex";
    ChainId[ChainId["Basecamp"] = 123420001114] = "Basecamp";
    ChainId[ChainId["NtityMainnet"] = 197710212030] = "NtityMainnet";
    ChainId[ChainId["HaradevTestnet"] = 197710212031] = "HaradevTestnet";
    ChainId[ChainId["GMNetworkTestnet"] = 202402181627] = "GMNetworkTestnet";
    ChainId[ChainId["Zeniq"] = 383414847825] = "Zeniq";
    ChainId[ChainId["PDCMainnet"] = 666301171999] = "PDCMainnet";
    ChainId[ChainId["SmartPayMobileMoney"] = 666301179999] = "SmartPayMobileMoney";
    ChainId[ChainId["MolereumNetwork"] = 6022140761023] = "MolereumNetwork";
    ChainId[ChainId["FlameTestnet"] = 16604737732183] = "FlameTestnet";
    ChainId[ChainId["Yominet"] = 428962654539583] = "Yominet";
    ChainId[ChainId["GodwokenTestnet(V1)"] = 868455272153094] = "GodwokenTestnet(V1)";
    ChainId[ChainId["KakarotStarknetSepolia"] = 920637907288165] = "KakarotStarknetSepolia";
    ChainId[ChainId["DCHAINTestnet"] = 2713017997578000] = "DCHAINTestnet";
    ChainId[ChainId["DCHAIN"] = 2716446429837000] = "DCHAIN";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
